webpackJsonp([0],{

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiRequest = undefined;

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApiRequest = exports.ApiRequest = function ApiRequest(injections, options) {
  (0, _classCallCheck3.default)(this, ApiRequest);

  // Assign given injections to the service instance
  this.constructor.injectArguments(this, injections, options);
};

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseController = undefined;

var _keys = __webpack_require__(70);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _merge2 = __webpack_require__(124);

var _merge3 = _interopRequireDefault(_merge2);

var _get2 = __webpack_require__(290);

var _get3 = _interopRequireDefault(_get2);

var _some2 = __webpack_require__(1568);

var _some3 = _interopRequireDefault(_some2);

var _app = __webpack_require__(628);

var _feature = __webpack_require__(184);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global _:false */

var BaseController = function () {
  function BaseController(injections, options) {
    (0, _classCallCheck3.default)(this, BaseController);

    // Assign given injections to the controllers instance
    this.constructor.injectArguments(this, injections, options);

    // Ensure that the mandatory controllerSevice has been injected
    this.constructor.contractInjection(this, 'controllerService');

    // Set initial languageOptions once
    if (!this.languageOptions) {
      this.setLanguageOptions();
    }
  }

  (0, _createClass3.default)(BaseController, [{
    key: 'isFeatureActive',
    value: function isFeatureActive(feature) {
      return (0, _some3.default)(this.featureFlags, function (ff) {
        return ff.name === feature;
      });
    }
  }, {
    key: 'error',
    value: function error(_error) {
      this.constructor.contractInjection(this, 'errorService');
      this.errorService.error(_error);
    }
  }, {
    key: 'getConfig',
    value: function getConfig() {
      return this.config;
    }

    // FIXME yay, magic numbers!

  }, {
    key: 'getMinMaxDate',
    value: function getMinMaxDate() {
      var minDate = new Date(Date.now());
      minDate.setHours(0);
      minDate.setMinutes(0);
      minDate.setSeconds(0);
      minDate.setMilliseconds(0);
      minDate.setFullYear(minDate.getFullYear() - 18);

      var initDate = new Date(Date.now());
      initDate.setHours(1);
      initDate.setMinutes(0);
      initDate.setSeconds(0);
      initDate.setMilliseconds(0);
      initDate.setFullYear(minDate.getFullYear());

      var maxDate = new Date(Date.now());
      maxDate.setFullYear(maxDate.getFullYear() - 120);

      return {
        initDate: initDate,
        minDate: minDate,
        maxDate: maxDate
      };
    }
  }, {
    key: 'getConfigItem',
    value: function getConfigItem(key, defaultValue) {
      // Support tenant specific config keys, defaults to config key without tenant prefix
      var tenantKey = this.tenant + '.' + key;
      return (0, _get3.default)(this.config, tenantKey, (0, _get3.default)(this.config, key, defaultValue));
    }
  }, {
    key: 'go',
    value: function go(to) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.constructor.contractInjection(this, '$state');

      // Ensure that the given parameters are splitted
      // to the target state and its parameters. If the
      // given to parameter contains a state object, we
      // have to deconstruct this object first.
      if (to.state) {
        params = (0, _merge3.default)(to.params || {}, params);
        to = to.state.name;
      }

      if (options.silent) {
        return this.$state.go(to, params, { location: 'replace' }).then(this.resetTabIndex);
      }
      return this.$state.go(to, params).then(this.resetTabIndex);
    }
  }, {
    key: 'resetTabIndex',
    value: function resetTabIndex() {
      // eslint-disable-next-line angular/document-service
      var firstTabElement = document.getElementById('firstTabableElement');
      firstTabElement.focus({ focusVisible: false });
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      this.constructor.contractInjection(this, '$window');
      this.$window.history.back();

      // Support native app history
      if (navigator && navigator.app) {
        navigator.app.backHistory();
      }
    }
  }, {
    key: 'nextState',
    value: function nextState(state) {
      if (state) {
        return this.go(state);
      }

      var nextStateIndex = this.pageStates.indexOf(this.$state.current.name) + 1;
      if (nextStateIndex < this.pageStates.length) {
        this.go(this.pageStates[nextStateIndex]);
      }
    }
  }, {
    key: 'prevState',
    value: function prevState(state) {
      if (state) {
        return this.go(state);
      }

      var prevStateIndex = this.pageStates.indexOf(this.$state.current.name) - 1;
      if (prevStateIndex >= 0) {
        this.go(this.pageStates[prevStateIndex]);
      }
    }
  }, {
    key: 'reload',
    value: function reload(params) {
      this.go(this.$state.current, params);
    }
  }, {
    key: 'bindTranslationChange',
    value: function bindTranslationChange(rootScope) {
      var _this = this;

      rootScope.$on('$translatePartialLoaderStructureChanged', function () {
        _this.setLanguageOptions();
      });
    }
  }, {
    key: 'setLanguageOptions',
    value: function setLanguageOptions() {
      var _this2 = this;

      var lang = this.$translate.use();
      return this.controllerService.tmhDynamicLocale.set(lang).then(function () {
        var _$locale$DATETIME_FOR = _this2.$locale.DATETIME_FORMATS,
            longDate = _$locale$DATETIME_FOR.longDate,
            mediumDate = _$locale$DATETIME_FOR.mediumDate,
            shortDate = _$locale$DATETIME_FOR.shortDate;

        _this2.languageOptions = {
          lang: lang,
          dateFormat: mediumDate,
          longDate: longDate,
          mediumDate: mediumDate,
          shortDate: shortDate
        };
        return _this2.languageOptions;
      });
    }
  }, {
    key: '$log',
    get: function get() {
      return this.controllerService.$log;
    }
  }, {
    key: '$locale',
    get: function get() {
      return this.controllerService.$locale;
    }
  }, {
    key: 'Features',
    get: function get() {
      return _feature.Features;
    }
  }, {
    key: '$translate',
    get: function get() {
      return this.controllerService.$translate;
    }
  }, {
    key: '$state',
    get: function get() {
      return this.controllerService.$state;
    }
  }, {
    key: '$stateParams',
    get: function get() {
      return this.controllerService.$stateParams;
    }
  }, {
    key: '$window',
    get: function get() {
      return this.controllerService.$window;
    }
  }, {
    key: '$timeout',
    get: function get() {
      return this.controllerService.$timeout;
    }
  }, {
    key: 'isMobile',
    get: function get() {
      return this.$window.innerWidth < 1000;
    }
  }, {
    key: 'config',
    get: function get() {
      return this.appConfig.get();
    }
  }, {
    key: 'appConfig',
    get: function get() {
      return this.controllerService.appConfig;
    }
  }, {
    key: 'appCache',
    get: function get() {
      return this.controllerService.appCache;
    }
  }, {
    key: 'envService',
    get: function get() {
      return this.controllerService.envService;
    }
  }, {
    key: 'errorService',
    get: function get() {
      return this.controllerService.errorService;
    }
  }, {
    key: 'trackingService',
    get: function get() {
      return this.controllerService.trackingService;
    }
  }, {
    key: 'custom',
    get: function get() {
      return this.envService.getCustom();
    }
  }, {
    key: 'environment',
    get: function get() {
      return this.envService.getEnvironment();
    }
  }, {
    key: 'tenant',
    get: function get() {
      // Cut off '-depotwechsel' suffix from host
      return this.environment.tenant.replace(/-depotwechsel$/gi, '');
    }
  }, {
    key: 'isMobileDevice',
    get: function get() {
      return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      );
    }
  }, {
    key: 'currentState',
    get: function get() {
      this.constructor.contractInjection(this, '$state');
      return this.$state.current;
    }
  }, {
    key: 'pageStates',
    get: function get() {
      var hasStatusPage = this.configService.isFeatureActive(this.Features.hasStatusPage);
      return (0, _keys2.default)((0, _app.AppStateFlow)(hasStatusPage));
    }
  }]);
  return BaseController;
}();

exports.BaseController = BaseController;

/***/ }),

/***/ 1475:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 488,
	"./af.js": 488,
	"./ar": 489,
	"./ar-dz": 490,
	"./ar-dz.js": 490,
	"./ar-kw": 491,
	"./ar-kw.js": 491,
	"./ar-ly": 492,
	"./ar-ly.js": 492,
	"./ar-ma": 493,
	"./ar-ma.js": 493,
	"./ar-sa": 494,
	"./ar-sa.js": 494,
	"./ar-tn": 495,
	"./ar-tn.js": 495,
	"./ar.js": 489,
	"./az": 496,
	"./az.js": 496,
	"./be": 497,
	"./be.js": 497,
	"./bg": 498,
	"./bg.js": 498,
	"./bm": 499,
	"./bm.js": 499,
	"./bn": 500,
	"./bn-bd": 501,
	"./bn-bd.js": 501,
	"./bn.js": 500,
	"./bo": 502,
	"./bo.js": 502,
	"./br": 503,
	"./br.js": 503,
	"./bs": 504,
	"./bs.js": 504,
	"./ca": 505,
	"./ca.js": 505,
	"./cs": 506,
	"./cs.js": 506,
	"./cv": 507,
	"./cv.js": 507,
	"./cy": 508,
	"./cy.js": 508,
	"./da": 509,
	"./da.js": 509,
	"./de": 510,
	"./de-at": 511,
	"./de-at.js": 511,
	"./de-ch": 512,
	"./de-ch.js": 512,
	"./de.js": 510,
	"./dv": 513,
	"./dv.js": 513,
	"./el": 514,
	"./el.js": 514,
	"./en-au": 515,
	"./en-au.js": 515,
	"./en-ca": 516,
	"./en-ca.js": 516,
	"./en-gb": 517,
	"./en-gb.js": 517,
	"./en-ie": 518,
	"./en-ie.js": 518,
	"./en-il": 519,
	"./en-il.js": 519,
	"./en-in": 520,
	"./en-in.js": 520,
	"./en-nz": 521,
	"./en-nz.js": 521,
	"./en-sg": 522,
	"./en-sg.js": 522,
	"./eo": 523,
	"./eo.js": 523,
	"./es": 524,
	"./es-do": 525,
	"./es-do.js": 525,
	"./es-mx": 526,
	"./es-mx.js": 526,
	"./es-us": 527,
	"./es-us.js": 527,
	"./es.js": 524,
	"./et": 528,
	"./et.js": 528,
	"./eu": 529,
	"./eu.js": 529,
	"./fa": 530,
	"./fa.js": 530,
	"./fi": 531,
	"./fi.js": 531,
	"./fil": 532,
	"./fil.js": 532,
	"./fo": 533,
	"./fo.js": 533,
	"./fr": 534,
	"./fr-ca": 535,
	"./fr-ca.js": 535,
	"./fr-ch": 536,
	"./fr-ch.js": 536,
	"./fr.js": 534,
	"./fy": 537,
	"./fy.js": 537,
	"./ga": 538,
	"./ga.js": 538,
	"./gd": 539,
	"./gd.js": 539,
	"./gl": 540,
	"./gl.js": 540,
	"./gom-deva": 541,
	"./gom-deva.js": 541,
	"./gom-latn": 542,
	"./gom-latn.js": 542,
	"./gu": 543,
	"./gu.js": 543,
	"./he": 544,
	"./he.js": 544,
	"./hi": 545,
	"./hi.js": 545,
	"./hr": 546,
	"./hr.js": 546,
	"./hu": 547,
	"./hu.js": 547,
	"./hy-am": 548,
	"./hy-am.js": 548,
	"./id": 549,
	"./id.js": 549,
	"./is": 550,
	"./is.js": 550,
	"./it": 551,
	"./it-ch": 552,
	"./it-ch.js": 552,
	"./it.js": 551,
	"./ja": 553,
	"./ja.js": 553,
	"./jv": 554,
	"./jv.js": 554,
	"./ka": 555,
	"./ka.js": 555,
	"./kk": 556,
	"./kk.js": 556,
	"./km": 557,
	"./km.js": 557,
	"./kn": 558,
	"./kn.js": 558,
	"./ko": 559,
	"./ko.js": 559,
	"./ku": 560,
	"./ku.js": 560,
	"./ky": 561,
	"./ky.js": 561,
	"./lb": 562,
	"./lb.js": 562,
	"./lo": 563,
	"./lo.js": 563,
	"./lt": 564,
	"./lt.js": 564,
	"./lv": 565,
	"./lv.js": 565,
	"./me": 566,
	"./me.js": 566,
	"./mi": 567,
	"./mi.js": 567,
	"./mk": 568,
	"./mk.js": 568,
	"./ml": 569,
	"./ml.js": 569,
	"./mn": 570,
	"./mn.js": 570,
	"./mr": 571,
	"./mr.js": 571,
	"./ms": 572,
	"./ms-my": 573,
	"./ms-my.js": 573,
	"./ms.js": 572,
	"./mt": 574,
	"./mt.js": 574,
	"./my": 575,
	"./my.js": 575,
	"./nb": 576,
	"./nb.js": 576,
	"./ne": 577,
	"./ne.js": 577,
	"./nl": 578,
	"./nl-be": 579,
	"./nl-be.js": 579,
	"./nl.js": 578,
	"./nn": 580,
	"./nn.js": 580,
	"./oc-lnc": 581,
	"./oc-lnc.js": 581,
	"./pa-in": 582,
	"./pa-in.js": 582,
	"./pl": 583,
	"./pl.js": 583,
	"./pt": 584,
	"./pt-br": 585,
	"./pt-br.js": 585,
	"./pt.js": 584,
	"./ro": 586,
	"./ro.js": 586,
	"./ru": 587,
	"./ru.js": 587,
	"./sd": 588,
	"./sd.js": 588,
	"./se": 589,
	"./se.js": 589,
	"./si": 590,
	"./si.js": 590,
	"./sk": 591,
	"./sk.js": 591,
	"./sl": 592,
	"./sl.js": 592,
	"./sq": 593,
	"./sq.js": 593,
	"./sr": 594,
	"./sr-cyrl": 595,
	"./sr-cyrl.js": 595,
	"./sr.js": 594,
	"./ss": 596,
	"./ss.js": 596,
	"./sv": 597,
	"./sv.js": 597,
	"./sw": 598,
	"./sw.js": 598,
	"./ta": 599,
	"./ta.js": 599,
	"./te": 600,
	"./te.js": 600,
	"./tet": 601,
	"./tet.js": 601,
	"./tg": 602,
	"./tg.js": 602,
	"./th": 603,
	"./th.js": 603,
	"./tk": 604,
	"./tk.js": 604,
	"./tl-ph": 605,
	"./tl-ph.js": 605,
	"./tlh": 606,
	"./tlh.js": 606,
	"./tr": 607,
	"./tr.js": 607,
	"./tzl": 608,
	"./tzl.js": 608,
	"./tzm": 609,
	"./tzm-latn": 610,
	"./tzm-latn.js": 610,
	"./tzm.js": 609,
	"./ug-cn": 611,
	"./ug-cn.js": 611,
	"./uk": 612,
	"./uk.js": 612,
	"./ur": 613,
	"./ur.js": 613,
	"./uz": 614,
	"./uz-latn": 615,
	"./uz-latn.js": 615,
	"./uz.js": 614,
	"./vi": 616,
	"./vi.js": 616,
	"./x-pseudo": 617,
	"./x-pseudo.js": 617,
	"./yo": 618,
	"./yo.js": 618,
	"./zh-cn": 619,
	"./zh-cn.js": 619,
	"./zh-hk": 620,
	"./zh-hk.js": 620,
	"./zh-mo": 621,
	"./zh-mo.js": 621,
	"./zh-tw": 622,
	"./zh-tw.js": 622
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1475;

/***/ }),

/***/ 1562:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(627);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(70);

var _keys2 = _interopRequireDefault(_keys);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Create application wide cache with the following set of methods:
_core.app.provider('appCache', function () {
  'ngInject';

  var cache = {
    set: function set(key, value) {
      try {
        sessionStorage.setItem(key, angular.toJson(value));
      } catch (ex) {
        // also set value as cookie to access it if sessionStorage is not available
        // eslint-disable-next-line
        document.cookie = key + '=' + (angular.toJson(value) || '') + '; path=/';
        // eslint-disable-next-line
        if (window.Raven) {
          // eslint-disable-next-line
          Raven.captureException(ex);
        }
      }
    },
    get: function get(key) {
      try {
        var value = angular.fromJson(sessionStorage.getItem(key));
        // sometime a exception is may not thrown try it as fallback when not present
        if (!value) {
          // eslint-disable-next-line
          var result = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');

          if (result) {
            value = angular.fromJson(result.pop());
          }
        }
        return value;
      } catch (ex) {
        // session storage not available fallback to cookie
        try {
          // eslint-disable-next-line
          var _result = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');

          if (_result) {
            return angular.fromJson(_result.pop());
          }
        } catch (ex) {
          // eslint-disable-next-line
          if (window.Raven) {
            // eslint-disable-next-line
            Raven.captureException(ex);
          }
        }
      }
      return;
    },
    remove: function remove(key) {
      sessionStorage.removeItem(key);
    },
    clear: function clear() {
      sessionStorage.clear();
    },
    clearExcept: function clearExcept(keysToKeep) {
      var savedValues = {};
      keysToKeep.forEach(function (key) {
        var value = sessionStorage.getItem(key);
        if (value !== null) {
          savedValues[key] = value;
        }
      });

      sessionStorage.clear();

      (0, _keys2.default)(savedValues).forEach(function (key) {
        sessionStorage.setItem(key, savedValues[key]);
      });
    }
  };

  // Assign cache functions to this instance (so we can use appCache at runtime)
  (0, _assign2.default)(this, cache);

  // Fill in the cache as $get method on the provider (so we can use appCacheProvider at configtime)
  this.$get = function () {
    return cache;
  };
});

/***/ }),

/***/ 1566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _app = __webpack_require__(55);

var _app2 = __webpack_require__(1571);

var _appConfig = __webpack_require__(1656);

var _appConfig2 = _interopRequireDefault(_appConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Configure app states
_core.app.config(_app.appState);

// Application component
_core.app.component('app', _app2.appComponent);

// Create application wide configuration
_core.app.factory('appConfig', ["configFactory", function (configFactory) {
  'ngInject';

  return configFactory.create(_appConfig2.default, {});
}]);

// Apply some global configuration...
_core.app.config(["$locationProvider", "$urlRouterProvider", "$httpProvider", "$translateProvider", function ($locationProvider, $urlRouterProvider, $httpProvider, $translateProvider) {
  'ngInject';

  $translateProvider.useMessageFormatInterpolation();

  // Rely on history.pushState to change urls where supported.
  // Will fall back to hash-prefixed paths in browsers that do not support.
  $locationProvider.html5Mode(true).hashPrefix('!');

  // If the user enters a URL that doesn't match any known URL (state),
  // send them to `/` by default.
  $urlRouterProvider.otherwise('/');

  // Error handling
  $httpProvider.interceptors.push('errorInterceptor');

  // Handle Angular IE Caching issue for $http
  // Initialize get if not there
  if (!$httpProvider.defaults.headers.get) {
    $httpProvider.defaults.headers.get = {};
  }

  // Disable IE ajax request caching
  $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
  $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
  $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
}]);

// Application runtime
_core.app.run(["$rootScope", "$log", "$trace", "$transitions", "envService", "configService", "appConfig", "trackingService", function ($rootScope, $log, $trace, $transitions, envService, configService, appConfig, trackingService) {
  'ngInject';

  var config = appConfig.get();

  // Make app configuration globally accessible to all scopes
  $rootScope.$config = configService.config;

  // Enable tracing (for tracking)
  // $trace.enable(1);

  // Enable tracking (only for production!)
  if (configService.isProduction() && config.app.tracking) {
    trackingService.activate(config.app.tracking);
    $transitions.onSuccess(true, function ($transition$) {
      var to = $transition$.to();
      var toParams = $transition$.params('to');
      trackingService.pageTrack(to.url, to.name, toParams);
    });
  }
}]);

/***/ }),

/***/ 1567:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StartController = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

var _bank = __webpack_require__(301);

var _accounts = __webpack_require__(630);

var _app = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StartController = exports.StartController = function (_BaseController) {
  StartController.$inject = ["controllerService", "configService", "accountIdValidationService"];
  (0, _inherits3.default)(StartController, _BaseController);

  function StartController(controllerService, configService, accountIdValidationService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, StartController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (StartController.__proto__ || (0, _getPrototypeOf2.default)(StartController)).call(this, {
      controllerService: controllerService,
      configService: configService,
      accountIdValidationService: accountIdValidationService
    }));

    _this.form = {};


    _this.steps = [{
      title: 'app.start.step.transfer.title',
      description: 'app.start.step.transfer.description'
    }, {
      title: 'app.start.step.data.title',
      description: 'app.start.step.data.description'
    }, {
      title: 'app.start.step.submit.title',
      description: 'app.start.step.submit.description'
    }];
    return _this;
  }

  (0, _createClass3.default)(StartController, [{
    key: 'setupBlzValidations',
    value: function setupBlzValidations() {
      this.blzMessages = {
        required: 'app.start.error.blz.required',
        blz: 'app.start.error.blz'
      };

      this.blzOptions = { validate: 'blz' };
    }
  }, {
    key: 'removeCache',
    value: function removeCache() {
      this.appCache.clearExcept(['config']);
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      // remove all maybe stored user fields which can lead to confusion when flags are prechecked especially when developing
      this.removeCache();

      // this.selection = true;
      this.transferAllSecurities = this.appCache.get('transferAllSecurities');
      this.newBank = new _bank.NewBankModel(this.appCache.get('newBank') || {});
      this.financeTypes = ['portfolioId', 'investmentId'];
      this.accounts = new _accounts.Accounts(this.financeTypes, this.form);
      this.progressbarStates = (0, _app.ProgressableStates)(this.configService.isFeatureActive(this.Features.hasStatusPage));

      // Set default value for transferAllSecurities
      if (typeof this.transferAllSecurities !== 'boolean') {
        this.transferAllSecurities = true;
      }

      this.setupBlzValidations();

      this.translations(this.$translate);

      if (this.configService.isFeatureActive(this.Features.prefillBankCode)) this.blz = this.configService.config && this.configService.config.bankCode;

      // Prefill cached values
      if (this.newBank && this.newBank.orderOfAccountFields) {
        this.accounts.accounts = this.newBank.orderOfAccountFields.accounts;
        this.selection = true;
      }
    }
  }, {
    key: 'submit',
    value: function submit() {
      var _this2 = this;

      // mark form as submitted
      this.form.$submitted = true;
      if (this.accounts.length > 1) {
        if (this.accounts.bothAccountsHaveSameType || this.accounts.bothAccountsHaveSameNumber) {
          this.form.$invalid = true;
          return;
        }
      }

      if (this.form.$valid) {
        this.accounts.copyAccountsToObject(this.newBank);
        if (this.blz) {
          this.newBank.blz = this.blz;
        }
        this.newBank.orderOfAccountFields = this.accounts;

        this.validatingAccountNumber = true;
        this.newAccountIdValidationError = false;

        this.accountIdValidationService.checkAccountId(this.newBank.portfolioId).then(function (success) {
          return _this2.accountValid();
        }, function (error) {
          return _this2.accountInvalid(error);
        }).finally(function () {
          _this2.validatingAccountNumber = false;
        });
      }
    }
  }, {
    key: 'accountValid',
    value: function accountValid() {
      delete this.financeTypes;
      this.newBank.shortName = this.tenantName;
      this.appCache.set('newBank', this.newBank);
      this.appCache.set('transferAllSecurities', !!this.transferAllSecurities);
      this.nextState();
    }
  }, {
    key: 'accountInvalid',
    value: function accountInvalid(error) {
      this.newAccountIdValidationError = error.data;
    }
  }, {
    key: 'translations',
    value: function translations(translate) {
      var self = this;
      translate('app.start.button.exists', { tenant: this.tenantName }).then(function (translation) {
        self.accountExistsLabel = translation;
      });

      translate('app.start.button.open', { tenant: this.tenantName }).then(function (translation) {
        self.accountOpenLabel = translation;
      });
    }
  }, {
    key: 'tenantName',
    get: function get() {
      return this.configService.getName();
    }
  }, {
    key: 'teaserUrl',
    get: function get() {
      return this.appConfig.get().app.teaser;
    }
  }, {
    key: 'bothAccountsHaveSameType',
    get: function get() {
      return this.form.$submitted && this.accounts.bothAccountsHaveSameType;
    }
  }, {
    key: 'bothAccountsHaveSameNumber',
    get: function get() {
      return this.form.$submitted && this.accounts.bothAccountsHaveSameNumber;
    }
  }, {
    key: 'showAddButton',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.additionalAccount);
    }
  }, {
    key: 'showFinanceTypeInfo',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.showFinanceTypeInfo);
    }
  }, {
    key: 'showStartOpenSecuritiesAccountInfo',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.showStartOpenSecuritiesAccountInfo);
    }
  }, {
    key: 'securitiesAccountUrl',
    get: function get() {
      return this.configService.getFeature(this.Features.securitiesAccountUrl);
    }
  }, {
    key: 'investmentAccountUrl',
    get: function get() {
      return this.configService.getFeature(this.Features.investmentAccountUrl);
    }
  }, {
    key: 'showBlzInput',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.showBlzInput);
    }
  }, {
    key: 'helpItem',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.showHelpItem);
    }
  }]);
  return StartController;
}(_controller.BaseController);

/***/ }),

/***/ 1570:
/***/ (function(module, exports) {

module.exports = "<div class=\"start\">\n  <main class=\"flex flex-favorite-child main\">\n    <app-header></app-header>\n\n    <div class=\"flex flex-favorite-child center column\">\n      <div class=\"content\">\n        <h2 class=\"pretitle\" translate=\"app.start.title\"></h2>\n        <h1 class=\"title has-pretitle\" translate=\"app.start.subtitle\"></h1>\n\n        <!-- Toggle depot available -->\n        <div class=\"card\">\n          <div class=\"card-body\">\n            <toggle-control\n              model=\"vm.selection\"\n              label=\"app.start.whatToDo\"\n              control-id=\"selection\"\n              label-values=\"{'tenant': vm.tenantName}\"\n            ></toggle-control>\n          </div>\n        </div>\n\n        <!-- Toggle transfer all securities -->\n        <div class=\"card\">\n          <div class=\"card-body\">\n            <toggle-control\n              model=\"vm.transferAllSecurities\"\n              label=\"app.oldPortfolioState.transferAllSecurities\"\n              control-id=\"transfer-all-securities\"\n              label-values=\"{'transferAllSecurities': vm.transferAllSecurities}\"\n            ></toggle-control>\n          </div>\n        </div>\n\n        <p\n          class=\"text-bold\"\n          ng-if=\"vm.selection\"\n          translate=\"app.start.info\"\n        ></p>\n\n        <!-- Start with available depot -->\n        <div ng-if=\"vm.selection === true\" class=\"fade-if\">\n          <form name=\"vm.form\" class=\"form\">\n            <div ng-if=\"vm.showBlzInput\" class=\"input-wrapper\">\n              <label class=\"blz-label\" translate=\"app.start.blz.label\"></label>\n              <div class=\"form-control-with-suffix\">\n                <fd-form-control\n                  model=\"vm.blz\"\n                  name=\"blz\"\n                  required=\"true\"\n                  form=\"vm.form\"\n                  options=\"vm.blzOptions\"\n                  messages=\"vm.blzMessages\"\n                  label=\"app.start.blz\"\n                >\n                </fd-form-control>\n                <div class=\"form-control-suffix\">\n                  <i\n                    ng-if=\"vm.helpItem\"\n                    class=\"fa fa-info info-icon\"\n                    ng-class=\"{'active': vm.showInfo}\"\n                    ng-click=\"vm.showInfo = !vm.showInfo\"\n                  ></i>\n                </div>\n              </div>\n              <div\n                ng-if=\"vm.helpItem\"\n                ng-show=\"vm.showInfo\"\n                class=\"well fade-if\"\n              >\n                <div translate=\"app.start.blz.helpitem\"></div>\n              </div>\n            </div>\n            <div ng-repeat=\"account in vm.accounts.all\" class=\"input-wrapper\">\n              <account-number\n                account=\"vm.accounts.getItem($index)\"\n                types=\"vm.financeTypes\"\n                form=\"vm.form\"\n                help-item=\"vm.helpItem\"\n                label-key=\"$index > 0 ? 'app.start.oldAccountNumber.second' : 'app.start.oldAccountNumber.first'\"\n                api-validation-error=\"vm.newAccountIdValidationError\"\n              ></account-number>\n            </div>\n            <div\n              ng-if=\"vm.bothAccountsHaveSameType\"\n              class=\"alert alert-warning fade-if\"\n              translate=\"app.start.distinct-account-types-error\"\n            ></div>\n            <div\n              ng-if=\"vm.bothAccountsHaveSameNumber\"\n              class=\"alert alert-warning fade-if\"\n              translate=\"app.start.same-account-number-error\"\n            ></div>\n\n            <nav class=\"buttons\">\n              <fd-form-button\n                ng-if=\"vm.showAddButton\"\n                ng-hide=\"vm.accounts.length > 1\"\n                on-click=\"vm.accounts.add()\"\n                label=\"app.start.additionalAccount\"\n                class=\"fade-if\"\n              >\n              </fd-form-button>\n              <fd-form-button\n                ng-show=\"vm.accounts.length > 1\"\n                on-click=\"vm.accounts.remove()\"\n                label=\"app.start.removeAccount\"\n                class=\"fade-in\"\n              >\n              </fd-form-button>\n              <fd-form-button\n                is-busy=\"vm.validatingAccountNumber\"\n                btn-type=\"submit\"\n                btn-primary=\"true\"\n                on-click=\"vm.submit()\"\n                label=\"app.start.button.continue\"\n                class=\"right\"\n              >\n              </fd-form-button>\n            </nav>\n          </form>\n\n          <!-- Finance type cheat info -->\n          <div ng-if=\"vm.showFinanceTypeInfo\" class=\"media fade-if mt-3\">\n            <div class=\"media-left\">\n              <i class=\"fa fa-question-circle-o fa-3x\"></i>\n            </div>\n            <div class=\"media-body\">\n              <div translate=\"app.cheatsheet.question\" translate-compile></div>\n            </div>\n          </div>\n        </div>\n\n        <!-- Fallback: No depot -> Link away -->\n        <div\n          ng-if=\"!vm.selection && vm.showStartOpenSecuritiesAccountInfo\"\n          class=\"fade-if\"\n        >\n          <span\n            translate=\"app.start.open\"\n            translate-values=\"{\n            'securitiesAccount': vm.securitiesAccountUrl,\n            'investmentAccount': vm.investmentAccountUrl\n          }\"\n          >\n          </span>\n        </div>\n      </div>\n    </div>\n  </main>\n\n  <aside class=\"flex side hidden-xs\">\n    <div class=\"start-background\">\n      <div class=\"background-overlay\"></div>\n      <div class=\"overlay\">\n        <div class=\"content\">\n          <h3 class=\"pretitle\" translate=\"app.start.step.pretitle\"></h3>\n          <h2 class=\"title has-pretitle\" translate=\"app.start.step.title\"></h2>\n          <div class=\"start-steps\">\n            <div class=\"start-step\" ng-repeat=\"step in vm.steps\">\n              <h2 class=\"start-step-title flex align-baseline\">\n                <span class=\"start-step-index\">{{ $index+1 }}</span>\n                <span translate=\"{{ step.title }}\"></span>\n              </h2>\n              <p\n                class=\"start-step-description\"\n                translate=\"{{ step.description }}\"\n              ></p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </aside>\n\n  <ui-modal-declaration\n    modal-key=\"cheatsheet\"\n    modal-url=\"app/common/ui/modals/cheatsheet.tpl.html\"\n    fullscreen=\"true\"\n  >\n  </ui-modal-declaration>\n</div>\n"

/***/ }),

/***/ 1571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appComponent = undefined;

var _app = __webpack_require__(1572);

var _app2 = _interopRequireDefault(_app);

var _app3 = __webpack_require__(1573);

var _app4 = _interopRequireDefault(_app3);

__webpack_require__(1581);

__webpack_require__(1591);

__webpack_require__(1598);

__webpack_require__(1601);

__webpack_require__(1608);

__webpack_require__(1612);

__webpack_require__(1616);

__webpack_require__(1620);

__webpack_require__(1624);

__webpack_require__(1628);

__webpack_require__(1632);

__webpack_require__(1634);

__webpack_require__(1649);

__webpack_require__(1653);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appComponent = exports.appComponent = {
  name: 'app',
  restrict: 'E',
  template: _app2.default,
  controller: _app4.default,
  controllerAs: 'vm',
  bindings: {
    languageOptions: '<'
  }
};

/***/ }),

/***/ 1572:
/***/ (function(module, exports) {

module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<app-header ng-if=\"vm.showHeader\"></app-header>\n\n<progress-bar states=\"vm.progressbarStates\"></progress-bar>\n\n<!-- used that when state changes user can navigate by tabs from start of page-->\n<a tabindex=\"0\" id=\"firstTabableElement\"></a>\n\n<!-- App content -->\n<div class=\"app-body fade-in\">\n  <div class=\"app-content\" ui-view autoscroll=\"false\"></div>\n</div>\n\n<!-- App footer -->\n<app-footer></app-footer>\n"

/***/ }),

/***/ 1573:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

var _app = __webpack_require__(55);

var _app2 = __webpack_require__(1574);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppController = function (_BaseController) {
  AppController.$inject = ["controllerService", "configService", "$http", "$transitions"];
  (0, _inherits3.default)(AppController, _BaseController);

  function AppController(controllerService, configService, $http, $transitions) {
    'ngInject';

    (0, _classCallCheck3.default)(this, AppController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AppController.__proto__ || (0, _getPrototypeOf2.default)(AppController)).call(this, { controllerService: controllerService, configService: configService, $http: $http, $transitions: $transitions }));

    _this.showHeader = true;


    _this.onStateChange();
    return _this;
  }

  (0, _createClass3.default)(AppController, [{
    key: '$onInit',
    value: function $onInit() {
      // Assign the resolved languageOptions to the base controller service,
      // therefor every controller will have access to the languageOptions.
      this.controllerService.languageOptions = this.languageOptions;

      this.$transitions.onSuccess({}, this.onStateChange.bind(this));

      var hasStatusPage = this.configService.isFeatureActive(this.Features.hasStatusPage);

      // Set visible progress states to progressbar
      this.progressbarStates = (0, _app.ProgressableStates)(hasStatusPage);
    }
  }, {
    key: 'onStateChange',
    value: function onStateChange(transition) {
      this.showHeader = !_app2.HIDDEN_HEADER_STATES.includes(this.currentState.name);
    }
  }]);
  return AppController;
}(_controller.BaseController);

exports.default = AppController;

/***/ }),

/***/ 1574:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HIDDEN_HEADER_STATES = undefined;

var _start = __webpack_require__(300);

var _legal = __webpack_require__(302);

var _changelog = __webpack_require__(632);

var HIDDEN_HEADER_STATES = exports.HIDDEN_HEADER_STATES = [_start.startStateName, _legal.legalStateName, _changelog.changelogStateName];

/***/ }),

/***/ 1575:
/***/ (function(module, exports) {

module.exports = "<app-header show-fino-logo=\"true\"></app-header>\n\n<div class=\"legal\">\n  <div class=\"markdown\" ng-if=\"vm.markdown\">\n    <div marked=\"vm.markdown\"></div>\n  </div>\n</div>\n"

/***/ }),

/***/ 1576:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LegalController = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LegalController = exports.LegalController = function (_BaseController) {
  LegalController.$inject = ["controllerService", "configService"];
  (0, _inherits3.default)(LegalController, _BaseController);

  function LegalController(controllerService, configService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, LegalController);
    return (0, _possibleConstructorReturn3.default)(this, (LegalController.__proto__ || (0, _getPrototypeOf2.default)(LegalController)).call(this, {
      controllerService: controllerService,
      configService: configService
    }));
  }

  (0, _createClass3.default)(LegalController, [{
    key: '$onInit',
    value: function $onInit() {
      var config = this.configService.config;
      this.document = config.documents.links[this.$stateParams.document];
      this.getDocument(this.document);
    }
  }, {
    key: 'getDocument',
    value: function getDocument(document) {
      var _this2 = this;

      var tenant = this.configService.config.tenant;

      this.configService.fetchLegalContent(tenant, document).then(function (resp) {
        _this2.markdown = resp.data;
      });
    }
  }]);
  return LegalController;
}(_controller.BaseController);

/***/ }),

/***/ 1577:
/***/ (function(module, exports) {

module.exports = "<app-header show-fino-logo=\"true\"></app-header>\n\n<div class=\"changelog\">\n  <div class=\"content-wrapper\">\n    <h1 class=\"changelog-title\">Changelog</h1>\n\n    <div ng-repeat=\"changelog in vm.changelogs\" class=\"panel panel-default\">\n      <div class=\"panel-body\">\n        <div class=\"content\" markdown-to-html=\"changelog\"></div>\n      </div>\n    </div>\n\n    <div ng-if=\"vm.errorMessage\" class=\"alert alert-danger\" role=\"alert\">\n      {{ vm.errorMessage }}\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ 1578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangelogController = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChangelogController = exports.ChangelogController = function (_BaseController) {
  ChangelogController.$inject = ["controllerService", "$http", "$q"];
  (0, _inherits3.default)(ChangelogController, _BaseController);

  function ChangelogController(controllerService, $http, $q) {
    'ngInject';

    (0, _classCallCheck3.default)(this, ChangelogController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ChangelogController.__proto__ || (0, _getPrototypeOf2.default)(ChangelogController)).call(this, {
      controllerService: controllerService,
      $http: $http,
      $q: $q
    }));

    _this.changelogFiles = ['changelog-2025-03-13.md', 'changelog-2025-03-12.md'];
    _this.changelogs = [];
    _this.errorMessage = '';
    return _this;
  }
  // Update according to the changelog files


  (0, _createClass3.default)(ChangelogController, [{
    key: '$onInit',
    value: function $onInit() {
      this.loadChangelogs();
    }
  }, {
    key: 'loadChangelogs',
    value: function loadChangelogs() {
      var _this2 = this;

      var changelogs = this.changelogFiles.map(function (log) {
        return _this2.loadChangelog(log);
      });
      this.$q.all(changelogs).then(function (changelogs) {
        _this2.changelogs = changelogs;
      }).catch(function (error) {
        return _this2.handleError(error);
      });
    }
  }, {
    key: 'loadChangelog',
    value: function loadChangelog(file) {
      return this.$http.get('assets/changelog/' + file).then(function (response) {
        return response.data;
      }).catch(function (error) {
        return error;
      });
    }
  }, {
    key: 'handleError',
    value: function handleError(error) {
      this.error(error);
      this.errorMessage = error;
    }
  }]);
  return ChangelogController;
}(_controller.BaseController);

/***/ }),

/***/ 1579:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1580);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(23)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/lib/index.js??ref--5-2!../../../../node_modules/sass-loader/lib/loader.js??ref--5-3!./changelog.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/lib/index.js??ref--5-2!../../../../node_modules/sass-loader/lib/loader.js??ref--5-3!./changelog.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1580:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(22)(undefined);
// imports


// module
exports.push([module.i, ".changelog {\n  padding: 20px; }\n  .changelog .content-wrapper {\n    max-width: 800px;\n    margin: 0 auto; }\n  .changelog .content h1 {\n    font-size: 24px;\n    margin-top: 0;\n    margin-bottom: 20px; }\n  .changelog .content h2 {\n    font-size: 20px;\n    margin-top: 0;\n    margin-bottom: 20px; }\n  .changelog .content h3 {\n    font-size: 18px;\n    margin-top: 0;\n    margin-bottom: 20px; }\n", ""]);

// exports


/***/ }),

/***/ 1581:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _accountNumber = __webpack_require__(1582);

var _accountNumber2 = _interopRequireDefault(_accountNumber);

var _accountNumberServiceProvider = __webpack_require__(1589);

var _blzService = __webpack_require__(1590);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core.app.component('accountNumber', _accountNumber2.default);
_core.app.provider('accountNumberService', _accountNumberServiceProvider.AccountNumberServiceProvider);
_core.app.provider('blzService', _blzService.BlzServiceProvider);

/***/ }),

/***/ 1582:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _accountNumber = __webpack_require__(1583);

var _accountNumber2 = _interopRequireDefault(_accountNumber);

var _accountNumber3 = __webpack_require__(1584);

var _accountNumber4 = _interopRequireDefault(_accountNumber3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  restrict: 'E',
  bindings: {
    account: '=',
    types: '<',
    form: '=',
    labelKey: '<',
    helpItem: '<',
    apiValidationError: '<'
  },
  template: _accountNumber2.default,
  controller: _accountNumber4.default,
  controllerAs: 'vm'
};

/***/ }),

/***/ 1583:
/***/ (function(module, exports) {

module.exports = "<div class=\"account-number\" ng-cloak>\n  <label for=\"\" translate=\"{{vm.labelKey}}\"></label>\n  <div ng-class=\"{'form-control-with-suffix': vm.helpItem}\">\n    <fd-form-control\n      form=\"vm.form\"\n      type=\"tel\"\n      name=\"newAccountId\"\n      model=\"vm.account.number\"\n      label=\"app.start.oldAccountNumber.placeholder\"\n      messages=\"vm.messages\"\n      options=\"vm.options\"\n      required=\"true\"\n    >\n    </fd-form-control>\n\n    <div class=\"form-control-suffix\">\n      <i\n        ng-if=\"vm.helpItem\"\n        class=\"fa fa-info info-icon\"\n        ng-class=\"{'active': vm.showInfo}\"\n        ng-click=\"vm.showInfo = !vm.showInfo\"\n      ></i>\n    </div>\n  </div>\n\n  <div ng-if=\"vm.helpItem\" ng-show=\"vm.showInfo\" class=\"well fade-if\">\n    <div translate=\"app.start.oldAccountNumber.helpitem\"></div>\n  </div>\n\n  <div class=\"start-finance-type\" ng-if=\"vm.showFinanceType\">\n    <fd-form-control\n      type=\"radio\"\n      form=\"vm.form\"\n      name=\"financeType_{{vm.$scope.$id}}\"\n      model=\"vm.account.type\"\n      label=\"app.start.financeType.investment\"\n      value=\"vm.types[0]\"\n    >\n    </fd-form-control>\n    <fd-form-control\n      type=\"radio\"\n      form=\"vm.form\"\n      name=\"financeType_{{vm.$scope.$id}}\"\n      model=\"vm.account.type\"\n      label=\"app.start.financeType.security\"\n      value=\"vm.types[1]\"\n    >\n    </fd-form-control>\n  </div>\n</div>\n"

/***/ }),

/***/ 1584:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _each2 = __webpack_require__(1585);

var _each3 = _interopRequireDefault(_each2);

var _controller = __webpack_require__(14);

var _accountNumber = __webpack_require__(1588);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountNumberController = function (_BaseController) {
  AccountNumberController.$inject = ["$scope", "controllerService", "accountNumberService", "validationRules", "configService"];
  (0, _inherits3.default)(AccountNumberController, _BaseController);

  function AccountNumberController($scope, controllerService, accountNumberService, validationRules, configService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, AccountNumberController);
    return (0, _possibleConstructorReturn3.default)(this, (AccountNumberController.__proto__ || (0, _getPrototypeOf2.default)(AccountNumberController)).call(this, {
      $scope: $scope,
      controllerService: controllerService,
      accountNumberService: accountNumberService,
      validationRules: validationRules,
      configService: configService
    }));
  }

  (0, _createClass3.default)(AccountNumberController, [{
    key: '$onChanges',
    value: function $onChanges(changes) {
      // backend recognized error, mark field as errored
      var apiValidationError = changes.apiValidationError;

      if (apiValidationError && apiValidationError.currentValue) {
        this.form.newAccountId.$setValidity(this.apiValidationError, false);
      }
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.id = this.$scope.$id;

      this.messageId = 'app.start.error.accountNumber';
      this.messages = (0, _extends3.default)({
        required: this.messageId + '.required',
        accountNumber: this.messageId + '.invalid',
        accountNumberBlocked: this.messageId + '.blocked',
        blz: this.messageId + '.blocked'
      }, _accountNumber.ErrorsFromApi);

      // remove api error from input when changes are made
      this.$scope.$watch('vm.account.number', function (newValue) {
        if (_this2.form.newAccountId) {
          _this2.form.newAccountId.$setValidity(_this2.apiValidationError, true);
        }
      });

      // Set validation rules (comma separated to set multiple rules)
      this.options = { validate: 'accountNumber,accountNumberBlocked' };

      this.setValidationRules(this.messages);
    }
  }, {
    key: 'setValidationRules',
    value: function setValidationRules(messages) {
      var _this3 = this;

      // Get accountId validation config from tenant config
      // TODO
      var accountNumberConfig = this.configService.getFeature(this.Features.accountNumberValidation);

      // Used to set tenant specific translation key
      var translatePrefix = '';

      if (accountNumberConfig) {
        var translateKey = accountNumberConfig.translateKey;

        // Use given translate key as translate prefix

        if (translateKey) {
          translatePrefix = translateKey;
        }
      }

      // Set validation message for every given message type
      (0, _each3.default)(messages, function (translateKey, messageKey) {
        _this3.setValidationMessage(messageKey, '' + translatePrefix + translateKey);
      });
    }
  }, {
    key: 'setValidationMessage',
    value: function setValidationMessage(messageKey, translateKey) {
      var _this4 = this;

      var name = this.configService.getTenant();
      this.$translate(translateKey, { tenant: name }).then(function (translation) {
        _this4.messages[messageKey] = translation;
      });
    }
  }, {
    key: 'showFinanceType',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.showFinanceType);
    }
  }]);
  return AccountNumberController;
}(_controller.BaseController);

exports.default = AccountNumberController;

/***/ }),

/***/ 1588:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ErrorsFromApi = exports.ErrorsFromApi = {
  'account number must contain exactly 10 digits': 'accountNumberValidation.account number must contain exactly 10 digits',
  'account number is outside the range': 'accountNumberValidation.account number is outside the range',
  'invalid account number': 'accountNumberValidation.invalid account number',
  'account number failed the checksum test': 'accountNumberValidation.account number failed the checksum test',
  'account number must not be null or empty': 'accountNumberValidation.account number must not be null or empty',
  'violates rule blocked': 'accountNumberValidation.violates rule blocked',
  'violates rule': 'accountNumberValidation.violates rule'
};

/***/ }),

/***/ 1589:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountNumberServiceProvider = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _isEmpty2 = __webpack_require__(185);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _libInjection = __webpack_require__(10);

var _accountIdValidation = __webpack_require__(186);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SKIP_ACCOUNT_ID_VALIDATION = false;

var AccountNumberServiceProvider = exports.AccountNumberServiceProvider = function (_InjectableClass) {
  AccountNumberServiceProvider.$inject = ["validationRulesProvider", "appCacheProvider"];
  (0, _inherits3.default)(AccountNumberServiceProvider, _InjectableClass);

  function AccountNumberServiceProvider(validationRulesProvider, appCacheProvider) {
    'ngInject';

    (0, _classCallCheck3.default)(this, AccountNumberServiceProvider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AccountNumberServiceProvider.__proto__ || (0, _getPrototypeOf2.default)(AccountNumberServiceProvider)).call(this, { validationRulesProvider: validationRulesProvider, appCacheProvider: appCacheProvider }));

    _this.activate();
    return _this;
  }

  (0, _createClass3.default)(AccountNumberServiceProvider, [{
    key: '$get',
    value: function $get() {
      'ngInject';

      return {};
    }
  }, {
    key: 'activate',
    value: function activate() {
      var _this2 = this;

      this.validationRulesProvider.addRule('accountNumber', function (value) {
        if (SKIP_ACCOUNT_ID_VALIDATION) return true;

        var _appCacheProvider$get = _this2.appCacheProvider.get('config'),
            features = _appCacheProvider$get.features;

        var _features$accountNumb = features.accountNumberValidation,
            rules = _features$accountNumb.rules,
            ranges = _features$accountNumb.ranges;


        var rulesValid = !(0, _isEmpty3.default)(rules) ? _accountIdValidation.AccountIdValidationService.fullfillsPattern(value, rules) : true;

        var rangesValid = !(0, _isEmpty3.default)(ranges) ? _accountIdValidation.AccountIdValidationService.fullfillsRanges(value, ranges) : true;

        return rulesValid && rangesValid;
      });

      this.validationRulesProvider.addRule('accountNumberBlocked', function (value) {
        var _appCacheProvider$get2 = _this2.appCacheProvider.get('config'),
            features = _appCacheProvider$get2.features;

        var rulesBlocked = features.accountNumberValidation.rulesBlocked;


        return !(0, _isEmpty3.default)(rulesBlocked) ? !_accountIdValidation.AccountIdValidationService.fullfillsPattern(value, rulesBlocked) : true;
      });
    }
  }]);
  return AccountNumberServiceProvider;
}(_libInjection.InjectableClass);

/***/ }),

/***/ 1590:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlzServiceProvider = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _libInjection = __webpack_require__(10);

var _accountIdValidation = __webpack_require__(186);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlzServiceProvider = exports.BlzServiceProvider = function (_InjectableClass) {
  BlzServiceProvider.$inject = ["validationRulesProvider", "appCacheProvider"];
  (0, _inherits3.default)(BlzServiceProvider, _InjectableClass);

  function BlzServiceProvider(validationRulesProvider, appCacheProvider) {
    'ngInject';

    (0, _classCallCheck3.default)(this, BlzServiceProvider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BlzServiceProvider.__proto__ || (0, _getPrototypeOf2.default)(BlzServiceProvider)).call(this, { validationRulesProvider: validationRulesProvider, appCacheProvider: appCacheProvider }));

    _this.activate();
    return _this;
  }

  (0, _createClass3.default)(BlzServiceProvider, [{
    key: '$get',
    value: function $get() {
      'ngInject';

      return {};
    }
  }, {
    key: 'activate',
    value: function activate() {
      var _this2 = this;

      this.validationRulesProvider.addRule('blz', function (value) {
        var _appCacheProvider$get = _this2.appCacheProvider.get('config'),
            features = _appCacheProvider$get.features;

        var pattern = features.bankNumberValidation;
        return pattern ? _accountIdValidation.AccountIdValidationService.fullfillsPattern(value, pattern) : true;
      });
    }
  }]);
  return BlzServiceProvider;
}(_libInjection.InjectableClass);

/***/ }),

/***/ 1591:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _addSecurities = __webpack_require__(634);

var _addSecurities2 = __webpack_require__(1594);

var _addSecurities3 = _interopRequireDefault(_addSecurities2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core.app.component('addSecuritiesComponent', _addSecurities.addSecuritiesComponent);
_core.app.service('addSecuritiesService', _addSecurities3.default);

/***/ }),

/***/ 1592:
/***/ (function(module, exports) {

module.exports = "<ui-modal>\n  <content>\n    <h2 class=\"ui-modal-header\">\n      <span translate=\"app.addSecurities.title\"></span>\n      <a href ng-click=\"vm.dismiss()\"><i class=\"fa fa-close\"></i></a>\n    </h2>\n\n    <div class=\"confirm-body\">\n      <form name=\"vm.form\">\n        <div ng-repeat=\"field in vm.fields\">\n          <div class=\"form-control-with-suffix\">\n            <fd-form-control\n              type=\"{{field.type}}\"\n              model=\"vm.security[field.name]\"\n              required=\"field.required\"\n              form=\"vm.form\"\n              name=\"{{field.name}}\"\n              messages=\"vm.messages[field.name]\"\n              label=\"{{ 'app.addSecurities.input.' + field.name }}\"\n            >\n            </fd-form-control>\n            <div class=\"form-control-suffix\">\n              <i\n                ng-if=\"field.showInfo\"\n                class=\"fa fa-info info-icon\"\n                ng-class=\"{'active': field.showInfo}\"\n                ng-click=\"vm.info[field.name] = !vm.info[field.name]\"\n              ></i>\n            </div>\n          </div>\n\n          <div\n            ng-if=\"field.showInfo\"\n            ng-show=\"vm.info[field.name]\"\n            class=\"well fade-in\"\n          >\n            <div translate=\"{{ 'app.addSecurities.info.' + field.name }}\"></div>\n          </div>\n        </div>\n      </form>\n    </div>\n  </content>\n  <actions>\n    <fd-form-button on-click=\"vm.dismiss()\" label=\"button.abort\">\n    </fd-form-button>\n    <fd-form-button\n      btn-primary=\"true\"\n      on-click=\"vm.close()\"\n      is-disabled=\"vm.isInvalid()\"\n      label=\"app.addSecurities.submit\"\n    >\n    </fd-form-button>\n  </actions>\n</ui-modal>\n"

/***/ }),

/***/ 1593:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddSecuritiesController = function (_BaseController) {
  AddSecuritiesController.$inject = ["controllerService", "addSecuritiesService", "$scope"];
  (0, _inherits3.default)(AddSecuritiesController, _BaseController);

  function AddSecuritiesController(controllerService, addSecuritiesService, $scope) {
    'ngInject';

    (0, _classCallCheck3.default)(this, AddSecuritiesController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AddSecuritiesController.__proto__ || (0, _getPrototypeOf2.default)(AddSecuritiesController)).call(this, {
      controllerService: controllerService,
      addSecuritiesService: addSecuritiesService,
      $scope: $scope
    }));

    _this.info = {};
    _this.messages = {};
    return _this;
  }

  (0, _createClass3.default)(AddSecuritiesController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.fields = [{
        name: 'name',
        showInfo: false,
        type: 'text',
        required: true
      }, {
        name: 'isin',
        showInfo: true,
        type: 'text',
        required: true
      }, {
        name: 'quantity',
        showInfo: true,
        type: 'number',
        required: true
      }, {
        name: 'price',
        showInfo: true,
        type: 'number'
      }];

      this.security = this.addSecuritiesService.initEmptySecurity();

      this.fields.forEach(function (field) {
        _this2.messages[field.name] = {
          required: 'app.addSecurities.input.' + field.name + '.required'
        };
      });
    }
  }, {
    key: 'close',
    value: function close() {
      this.modalInstance.close(this.security);
    }
  }, {
    key: 'dismiss',
    value: function dismiss() {
      this.modalInstance.dismiss();
    }
  }, {
    key: 'isInvalid',
    value: function isInvalid() {
      return this.form.$invalid;
    }
  }]);
  return AddSecuritiesController;
}(_controller.BaseController);

exports.default = AddSecuritiesController;

/***/ }),

/***/ 1594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _libInjection = __webpack_require__(10);

var _addSecurities = __webpack_require__(634);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uuidv1 = __webpack_require__(1595);

var AddSecuritiesService = function (_InjectableClass) {
  AddSecuritiesService.$inject = ["$q", "$uibModal"];
  (0, _inherits3.default)(AddSecuritiesService, _InjectableClass);

  function AddSecuritiesService($q, $uibModal) {
    'ngInject';

    (0, _classCallCheck3.default)(this, AddSecuritiesService);
    return (0, _possibleConstructorReturn3.default)(this, (AddSecuritiesService.__proto__ || (0, _getPrototypeOf2.default)(AddSecuritiesService)).call(this, { $q: $q, $uibModal: $uibModal }));
  }

  (0, _createClass3.default)(AddSecuritiesService, [{
    key: 'open',
    value: function open() {
      var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return this.$uibModal.open({
        component: _addSecurities.addSecuritiesComponent.name,
        size: 'modal-lg',
        windowClass: 'add-securities-modal'
      }).result;
    }
  }, {
    key: 'initEmptySecurity',
    value: function initEmptySecurity() {
      return {
        currency: 'EUR',
        securityId: uuidv1()
      };
    }
  }]);
  return AddSecuritiesService;
}(_libInjection.InjectableClass);

exports.default = AddSecuritiesService;

/***/ }),

/***/ 1598:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _appHeader = __webpack_require__(1599);

var _appHeader2 = _interopRequireDefault(_appHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core.app.component('appHeader', _appHeader2.default);

/***/ }),

/***/ 1599:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _libInjection = __webpack_require__(10);

var _feature = __webpack_require__(184);

var _appHeader = __webpack_require__(1600);

var _appHeader2 = _interopRequireDefault(_appHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppHeaderController = function (_InjectableClass) {
  AppHeaderController.$inject = ["appConfig", "configService"];
  (0, _inherits3.default)(AppHeaderController, _InjectableClass);

  function AppHeaderController(appConfig, configService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, AppHeaderController);
    return (0, _possibleConstructorReturn3.default)(this, (AppHeaderController.__proto__ || (0, _getPrototypeOf2.default)(AppHeaderController)).call(this, { appConfig: appConfig, configService: configService }));
  }

  (0, _createClass3.default)(AppHeaderController, [{
    key: 'config',
    get: function get() {
      return this.configService.getConfig();
    }
  }, {
    key: 'brandLogo',
    get: function get() {
      return this.useFinoLogo ? 'https://s3.eu-central-1.amazonaws.com/fino-tenant-assets/fino/images/logo.complete.png' : this.tenantLogo;
    }
  }, {
    key: 'useFinoLogo',
    get: function get() {
      return this.showFinoLogo || this.configService.isFeatureActive(_feature.Features.showFinoLogoInHeader);
    }
  }, {
    key: 'tenantLogo',
    get: function get() {
      return this.config && this.config.logo;
    }
  }]);
  return AppHeaderController;
}(_libInjection.InjectableClass);

exports.default = {
  restrict: 'E',
  bindings: {
    showFinoLogo: '<'
  },
  template: _appHeader2.default,
  controllerAs: 'vm',
  controller: AppHeaderController
};

/***/ }),

/***/ 1600:
/***/ (function(module, exports) {

module.exports = "<header class=\"header\">\n  <div class=\"header-content\">\n    <div class=\"header-brand\">\n      <!-- Brand logo -->\n      <img\n        ng-if=\"!vm.showFinoLogo\"\n        ng-src=\"{{vm.brandLogo}}\"\n        class=\"logo\"\n        alt=\"{{ 'app.header.brandlogo.alt' | translate }}\"\n      />\n\n      <!-- Brand logo & title -->\n      <div ng-if=\"vm.showFinoLogo\">\n        <h1 class=\"title\" translate=\"header.title\"></h1>\n        <a ui-sref=\"app.home\" class=\"header-brand-title\" tabindex=\"-1\">\n          <span translate>powered by</span>\n          <img\n            ng-src=\"{{vm.brandLogo}}\"\n            class=\"logo-fino\"\n            alt=\"{{ 'app.header.brandlogo.alt' | translate }}\"\n          />\n        </a>\n      </div>\n    </div>\n\n    <div class=\"header-end\">\n      <!-- Tenant logo -->\n      <img\n        ng-if=\"vm.showFinoLogo\"\n        ng-src=\"{{vm.tenantLogo}}\"\n        class=\"logo-tenant\"\n        alt=\"{{ 'app.header.tenantLogo.alt' | translate }}\"\n      />\n    </div>\n  </div>\n</header>\n"

/***/ }),

/***/ 1601:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _faq = __webpack_require__(1602);

var _faq2 = __webpack_require__(1605);

var _faq3 = __webpack_require__(1606);

__webpack_require__(1607);

_core.app.component('faq', _faq.faqComponent);
_core.app.service('faqService', _faq2.FaqService);
_core.app.constant('faqUrls', _faq3.faqUrls);
_core.app.value('freshdeskApiConfig', {
  apiHost: 'https://finorun.freshdesk.com/api/v2',
  apiKey: 'kB7TuW8dubC7WVrinQC'
});

/***/ }),

/***/ 1602:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.faqComponent = undefined;

var _faq = __webpack_require__(1603);

var _faq2 = _interopRequireDefault(_faq);

var _faq3 = __webpack_require__(1604);

var _faq4 = _interopRequireDefault(_faq3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var faqComponent = exports.faqComponent = {
  restrict: 'E',
  bindings: {},
  template: _faq2.default,
  controller: _faq4.default,
  controllerAs: 'vm'
};

/***/ }),

/***/ 1603:
/***/ (function(module, exports) {

module.exports = "<div class=\"faq\">\n  <div class=\"header\">\n    <h1 class=\"title\" translate=\"app.faq.title\"></h1>\n    <div class=\"search-field btn-group btn-block\">\n      <input\n        class=\"form-control\"\n        type=\"text\"\n        ng-model=\"vm.search\"\n        ng-change=\"vm.searchChanged()\"\n        uib-typeahead=\"title for title in vm.titles | filter:vm.search\"\n        typeahead-on-select=\"vm.selectFromTypeahead($item)\"\n        placeholder=\"{{ 'app.faq.placeholder' | translate }}\"\n      />\n      <span\n        ng-show=\"vm.search\"\n        ng-click=\"vm.resetSearch()\"\n        class=\"search-icon right fa fa-close fade-in\"\n      >\n      </span>\n      <span class=\"search-icon left fa fa-search\"></span>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-4 navigation\" ng-show=\"vm.displayCategories.length > 1\">\n      <h3 class=\"title\" translate=\"COMPONENTS.FAQ.NAVIGATION_TITLE\"></h3>\n      <ul>\n        <li\n          ng-repeat=\"category in vm.displayCategories\"\n          ng-class=\"{ 'selected': category === vm.selectedCategory }\"\n          ng-click=\"vm.selectCategory(category, $event)\"\n        >\n          <h3 class=\"category\">{{ category.name }}</h3>\n        </li>\n      </ul>\n    </div>\n    <div\n      class=\"content\"\n      ng-class=\"(vm.displayCategories.length > 1) ? 'col-sm-8' : 'col-sm-12'\"\n    >\n      <div ng-if=\"vm.selectedCategory\">\n        <div class=\"folder-container row\">\n          <div ng-repeat=\"folder in vm.selectedCategory.folders\" class=\"folder\">\n            <div class=\"article-container\">\n              <h4 class=\"folder-title\">{{ folder.name }}</h4>\n              <div\n                ng-repeat=\"article in folder.articles\"\n                ng-class=\"{ 'open': article.open }\"\n                class=\"article\"\n              >\n                <h5 class=\"article-title\">\n                  <i\n                    ng-class=\"{ 'fa-chevron-right': !article.open, 'fa-chevron-down': article.open }\"\n                    class=\"fa\"\n                  ></i>\n                  <a ng-click=\"vm.toggle(article, $event)\"\n                    >{{ article.title }}</a\n                  >\n                </h5>\n                <div class=\"panel panel-default\" ng-if=\"article.open\">\n                  <div\n                    class=\"panel-body\"\n                    ng-bind-html=\"article.description\"\n                  ></div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ 1604:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _map2 = __webpack_require__(293);

var _map3 = _interopRequireDefault(_map2);

var _filter2 = __webpack_require__(292);

var _filter3 = _interopRequireDefault(_filter2);

var _includes2 = __webpack_require__(465);

var _includes3 = _interopRequireDefault(_includes2);

var _controller = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Do not display categories with the following titles
// in the faq modal
var CategoryFilter = ['Für Zahlungspartner', 'Für Banken'];

var FaqController = function (_BaseController) {
  FaqController.$inject = ["controllerService", "freshdeskFaqsService", "$uibModalStack", "$scope"];
  (0, _inherits3.default)(FaqController, _BaseController);

  function FaqController(controllerService, freshdeskFaqsService, $uibModalStack, $scope) {
    'ngInject';

    (0, _classCallCheck3.default)(this, FaqController);
    return (0, _possibleConstructorReturn3.default)(this, (FaqController.__proto__ || (0, _getPrototypeOf2.default)(FaqController)).call(this, { controllerService: controllerService, freshdeskFaqsService: freshdeskFaqsService, $uibModalStack: $uibModalStack, $scope: $scope }));
  }

  (0, _createClass3.default)(FaqController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.freshdeskFaqsService.getFaqs([80000314642]).then(function (result) {
        _this2.activate(result.faqs);
      });
    }
  }, {
    key: 'activate',
    value: function activate(faq) {
      var _this3 = this;

      this.displayCategories = this.categories = this.cleanCategories(faq.categories);
      this.titles = [];
      this.traverse(this.categories, ['folders', 'articles'], function (e) {
        if (e.title && !(0, _includes3.default)(_this3.titles, e.title)) {
          _this3.titles.push(e.title);
        }
      });
      this.resetSearch();
    }
  }, {
    key: 'cleanCategories',
    value: function cleanCategories(categories) {
      return (0, _filter3.default)(categories, function (cat) {
        return CategoryFilter.indexOf(cat.name) === -1;
      });
    }
  }, {
    key: 'selectFromTypeahead',
    value: function selectFromTypeahead(value) {
      this.search = value;
      this.searchChanged();
    }
  }, {
    key: 'resetSearch',
    value: function resetSearch() {
      this.search = '';
      this.searchChanged();
    }
  }, {
    key: 'searchChanged',
    value: function searchChanged() {
      if (this.search) {
        this.displayCategories = [this.getFiltered(angular.copy(this.categories))];
        this.traverse(this.displayCategories, ['folders', 'articles'], function (e) {
          e.open = true;
        });
      } else {
        this.displayCategories = this.categories;
      }
      this.selectCategory(this.displayCategories[0]);
    }
  }, {
    key: 'traverse',
    value: function traverse(array, traverseProperties, action) {
      var _this4 = this;

      var nextProp = traverseProperties[0];
      array.forEach(function (e) {
        action(e, nextProp);
        if (traverseProperties.length > 0 && angular.isArray(e[nextProp])) {
          _this4.traverse(e[nextProp], traverseProperties.slice(1), action);
        }
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e, $event) {
      $event.stopPropagation();
      e.open = !e.open;
    }
  }, {
    key: 'selectCategory',
    value: function selectCategory(cat, $event) {
      if ($event) {
        $event.stopPropagation();
      }
      this.selectedCategory = cat;
      if (this.selectedCategory && !this.selectedCategory.selectedFolder) {
        this.selectFolder(this.selectedCategory, this.selectedCategory.folders[0]);
      }
    }
  }, {
    key: 'selectFolder',
    value: function selectFolder(cat, fol, $event) {
      if ($event) {
        $event.stopPropagation();
      }
      cat.selectedFolder = fol;
    }
  }, {
    key: 'getFiltered',
    value: function getFiltered(array) {
      var _this5 = this;

      var filtered = { folders: [{ articles: [] }] };
      (0, _map3.default)(array, function (category) {
        (0, _map3.default)(category.folders, function (folder) {
          (0, _map3.default)(folder.articles, function (article) {
            if (_this5.containsSearch(article)) {
              filtered.folders[0].articles.push(article);
            }
          });
        });
      });
      return filtered;
    }
  }, {
    key: 'containsSearch',
    value: function containsSearch(a) {
      var titleContains = a.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
      var descContains = a.description.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
      return titleContains || descContains;
    }
  }, {
    key: 'getArrayKeys',
    value: function getArrayKeys(e) {
      return (0, _map3.default)(e, function (value, key) {
        if (angular.isArray(value)) {
          return key;
        }
      }).filter(function (key) {
        return key != null;
      });
    }
  }, {
    key: 'close',
    value: function close() {
      this.$uibModalStack.dismissAll('close');
    }
  }]);
  return FaqController;
}(_controller.BaseController);

exports.default = FaqController;

/***/ }),

/***/ 1605:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FaqService = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _libInjection = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaqService = exports.FaqService = function (_InjectableClass) {
  FaqService.$inject = ["$http", "faqUrls", "appConfig", "configService"];
  (0, _inherits3.default)(FaqService, _InjectableClass);

  function FaqService($http, faqUrls, appConfig, configService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, FaqService);
    return (0, _possibleConstructorReturn3.default)(this, (FaqService.__proto__ || (0, _getPrototypeOf2.default)(FaqService)).call(this, { $http: $http, faqUrls: faqUrls, appConfig: appConfig, configService: configService }));
  }

  (0, _createClass3.default)(FaqService, [{
    key: 'getFaq',
    value: function getFaq() {
      var stage = this.configService.getStage() || 'dev';
      var config = this.appConfig.config;

      var tenantName = config.tenant.name;
      var themeName = config.theme.name;
      return this.$http({
        method: 'GET',
        url: this.faqUrls[stage] + '/faq?project=dws&tenant=' + tenantName + '&theme=' + themeName + '&escape=false'
      });
    }
  }]);
  return FaqService;
}(_libInjection.InjectableClass);

/***/ }),

/***/ 1606:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var faqUrls = exports.faqUrls = {
  dev: 'https://content-dev.meinkontowechsel.de/api',
  testing: 'https://content-testing.meinkontowechsel.de/api',
  production: 'https://content.meinkontowechsel.de/api'
};

/***/ }),

/***/ 1607:
/***/ (function(module, exports) {

var path = 'app/common/ui/modals/faq.tpl.html';
var html = "<div class=\"modal-close-icon\" ng-click=\"$modal.close()\">\n  <i class=\"fa fa-close\"></i>\n</div>\n<faq></faq>\n<fd-form-button\n  btn-primary=\"true\"\n  ng-click=\"$modal.close()\"\n  label=\"{{'button.close' | translate}}\"\n  class=\"pull-right\"\n></fd-form-button>\n";
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 1608:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _appFooter = __webpack_require__(1609);

var _appFooter2 = _interopRequireDefault(_appFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core.app.component('appFooter', _appFooter2.default);

/***/ }),

/***/ 1609:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appFooter = __webpack_require__(1610);

var _appFooter2 = __webpack_require__(1611);

var _appFooter3 = _interopRequireDefault(_appFooter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  restrict: 'E',
  bindings: {},
  template: _appFooter3.default,
  controller: _appFooter.AppFooterController,
  controllerAs: 'vm'
};

/***/ }),

/***/ 1610:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppFooterController = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

var _legal = __webpack_require__(302);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppFooterController = exports.AppFooterController = function (_BaseController) {
  AppFooterController.$inject = ["controllerService", "uiModalDeclarationService", "$scope", "configService"];
  (0, _inherits3.default)(AppFooterController, _BaseController);

  function AppFooterController(controllerService, uiModalDeclarationService, $scope, configService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, AppFooterController);
    return (0, _possibleConstructorReturn3.default)(this, (AppFooterController.__proto__ || (0, _getPrototypeOf2.default)(AppFooterController)).call(this, {
      controllerService: controllerService,
      uiModalDeclarationService: uiModalDeclarationService,
      $scope: $scope,
      configService: configService
    }));
  }

  (0, _createClass3.default)(AppFooterController, [{
    key: '$onInit',
    value: function $onInit() {
      this.agbStateName = _legal.agbStateName;
      this.privacyStateName = _legal.privacyStateName;
      this.imprintStateName = _legal.imprintStateName;
    }
  }, {
    key: 'contactFromConfig',
    get: function get() {
      return this.configService.getFeature(this.Features.footerContact);
    }
  }]);
  return AppFooterController;
}(_controller.BaseController);

/***/ }),

/***/ 1611:
/***/ (function(module, exports) {

module.exports = "<footer class=\"footer\">\n  <ul class=\"footer-links\">\n    <li>\n      <a\n        href\n        ui-modal-trigger=\"faq\"\n        translate=\"footer.frequentlyAskedQuestions\"\n      ></a>\n    </li>\n    <li>\n      <a\n        ui-sref=\"app.legal({ document: 'terms' })\"\n        target=\"_blank\"\n        translate=\"footer.termsAndConditions\"\n      ></a>\n    </li>\n    <li>\n      <a\n        ui-sref=\"app.legal({ document: 'privacy' })\"\n        target=\"_blank\"\n        translate=\"footer.privacy\"\n      ></a>\n    </li>\n    <li>\n      <a\n        ui-sref=\"app.legal({ document: 'imprint'})\"\n        target=\"_blank\"\n        translate=\"footer.imprint\"\n      ></a>\n    </li>\n    <li\n      ng-if=\"vm.contactFromConfig\"\n      class=\"footer-contact\"\n      translate=\"footer.contact\"\n      translate-values=\"{'contact': vm.contactFromConfig}\"\n    ></li>\n  </ul>\n</footer>\n\n<ui-modal-declaration\n  modal-key=\"faq\"\n  fullscreen=\"true\"\n  modal-url=\"app/common/ui/modals/faq.tpl.html\"\n>\n</ui-modal-declaration>\n\n<ui-modal-declaration\n  modal-key=\"termsAndConditions\"\n  fullscreen=\"true\"\n  modal-url=\"app/common/ui/modals/termsAndConditions.tpl.html\"\n>\n</ui-modal-declaration>\n\n<ui-modal-declaration\n  modal-key=\"privacy\"\n  fullscreen=\"true\"\n  modal-url=\"app/common/ui/modals/privacy.tpl.html\"\n>\n</ui-modal-declaration>\n\n<ui-modal-declaration\n  modal-key=\"imprint\"\n  fullscreen=\"true\"\n  modal-url=\"app/common/ui/modals/imprint.tpl.html\"\n>\n</ui-modal-declaration>\n\n<ui-modal-declaration\n  modal-key=\"info\"\n  modal-url=\"app/common/ui/modals/info.tpl.html\"\n>\n</ui-modal-declaration>\n\n<ui-modal-declaration\n  modal-key=\"confirmation\"\n  modal-url=\"app/common/ui/modals/confirmation.tpl.html\"\n>\n</ui-modal-declaration>\n"

/***/ }),

/***/ 1612:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _sellFragments = __webpack_require__(1613);

var _sellFragments2 = _interopRequireDefault(_sellFragments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core.app.component('sellFragments', _sellFragments2.default);

/***/ }),

/***/ 1613:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sellFragments = __webpack_require__(1614);

var _sellFragments2 = _interopRequireDefault(_sellFragments);

var _sellFragments3 = __webpack_require__(1615);

var _sellFragments4 = _interopRequireDefault(_sellFragments3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  restrict: 'E',
  template: _sellFragments2.default,
  controllerAs: 'vm',
  bindings: {
    form: '=',
    portfolio: '=',
    uncheckable: '@',
    asCard: '@'
  },
  controller: _sellFragments4.default
};

/***/ }),

/***/ 1614:
/***/ (function(module, exports) {

module.exports = "<form name=\"vm.form\" novalidate>\n  <div ng-class=\"{ 'card': vm.asCard }\">\n    <div ng-class=\"{ 'card-body': vm.asCard }\">\n      <toggle-control\n        form=\"vm.form\"\n        model=\"vm.portfolio.sellFragments\"\n        options=\"vm.sellFragmentsOptions\"\n        label=\"{{ vm.sellFragmentsOptions.label }}\"\n        info-text-key=\"{{ vm.sellFragmentsOptions.infoTextKey }}\"\n        control-id=\"{{ vm.sellFragmentsOptions.name }}\"\n      >\n        <div\n          ng-if=\"vm.portfolio.sellFragments && !vm.portfolio.proceedsOnClearingAccountEnabled\"\n        >\n          <div class=\"bank\">\n            <p\n              class=\"sellFragments-title\"\n              translate=\"app.oldPortfolio.sellFragments.title\"\n            ></p>\n\n            <fd-form-control\n              type=\"text\"\n              options=\"{validate:'iban'}\"\n              name=\"fragmentsProceedsDestinationIban\"\n              label=\"app.oldPortfolioState.fragmentsProceedsDestinationIban\"\n              model=\"vm.portfolio.fragmentsProceedsDestinationIban\"\n              form=\"vm.form\"\n              required=\"vm.portfolio.sellFragments\"\n              messages=\"vm.messages.fragmentsProceedsDestinationIban\"\n            >\n            </fd-form-control>\n\n            <fd-form-control\n              type=\"text\"\n              options=\"{validate:'bic'}\"\n              name=\"fragmentsProceedsDestinationBic\"\n              label=\"app.oldPortfolioState.fragmentsProceedsDestinationBic\"\n              model=\"vm.portfolio.fragmentsProceedsDestinationBic\"\n              form=\"vm.form\"\n              required=\"vm.portfolio.sellFragments\"\n              messages=\"vm.messages.fragmentsProceedsDestinationBic\"\n            >\n            </fd-form-control>\n            <fd-form-control\n              name=\"fragmentsProceedsDestinationBankName\"\n              label=\"app.oldPortfolioState.fragmentsProceedsDestinationBankName\"\n              model=\"vm.portfolio.fragmentsProceedsDestinationBankName\"\n              form=\"vm.form\"\n              required=\"vm.portfolio.sellFragments\"\n              messages=\"vm.messages.fragmentsProceedsDestinationBankName\"\n            >\n            </fd-form-control>\n\n            <fd-form-control\n              label=\"app.oldPortfolioState.fragmentsProceedsDestinationAccountOwner\"\n              model=\"vm.portfolio.fragmentsProceedsDestinationAccountOwner\"\n              name=\"fragmentsProceedsDestinationAccountOwner\"\n              messages=\"vm.messages.fragmentsProceedsDestinationAccountOwner\"\n              required=\"vm.portfolio.sellFragments\"\n              form=\"vm.form\"\n            >\n            </fd-form-control>\n          </div>\n          <div class=\"col-md-6\"></div>\n        </div>\n      </toggle-control>\n    </div>\n  </div>\n</form>\n"

/***/ }),

/***/ 1615:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SellFragmentsController = function (_BaseController) {
  SellFragmentsController.$inject = ["configService", "controllerService", "bankSourceService", "$scope"];
  (0, _inherits3.default)(SellFragmentsController, _BaseController);

  function SellFragmentsController(configService, controllerService, bankSourceService, $scope) {
    'ngInject';

    (0, _classCallCheck3.default)(this, SellFragmentsController);
    return (0, _possibleConstructorReturn3.default)(this, (SellFragmentsController.__proto__ || (0, _getPrototypeOf2.default)(SellFragmentsController)).call(this, { configService: configService, controllerService: controllerService, bankSourceService: bankSourceService, $scope: $scope }));
  }

  (0, _createClass3.default)(SellFragmentsController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.sellFragmentsOptions = {
        type: 'checkbox',
        iconPath: this.iconPath,
        infoTextKey: 'app.oldPortfolioState.sellFragments.info',
        label: 'app.oldPortfolioState.sellFragments',
        name: 'app.oldPortfolioState.sellFragments',
        model: 'sellFragments',
        checked: this.portfolio.sellFragments
      };

      this.messages = {
        fragmentsProceedsDestinationIban: {
          required: 'app.required',
          iban: 'app.oldPortfolioState.error.invalidIban'
        },
        fragmentsProceedsDestinationBic: {
          required: 'app.required'
        },
        fragmentsProceedsDestinationBankName: {
          required: 'app.required'
        },
        fragmentsProceedsDestinationAccountOwner: {
          required: 'app.required'
        }
      };

      // Prevent initial watch trigger
      this.$timeout(function () {
        return _this2.watchModelBindings = true;
      });

      // fragmentsProceedsDestinationIban -> fill bank properties
      this.$scope.$watch('vm.portfolio.fragmentsProceedsDestinationIban', function (newValue) {
        if (!_this2.watchModelBindings) return;
        _this2.fillBankProperties(newValue);
      });
    }
  }, {
    key: 'fillBankProperties',
    value: function fillBankProperties(iban) {
      var _this3 = this;

      var destinationIban = this.form.fragmentsProceedsDestinationIban;
      if (destinationIban && destinationIban.$invalid || !iban) {
        return;
      }
      var legacyBankIdentifier = this.extractLegacyBankIdentifier(iban);
      this.bankSourceService.resourceSearch(legacyBankIdentifier).then(function (response) {
        var bank = response[0];
        _this3.portfolio.fragmentsProceedsDestinationBic = bank.BIC;
        _this3.portfolio.fragmentsProceedsDestinationBankName = bank.description;
      });
    }
  }, {
    key: 'extractLegacyBankIdentifier',
    value: function extractLegacyBankIdentifier(iban) {
      return iban.replace(/\s/g, '').slice(4, 12);
    }
  }, {
    key: 'iconPath',
    get: function get() {
      return this.configService.getFeature(this.Features.infoIconPath);
    }
  }]);
  return SellFragmentsController;
}(_controller.BaseController);

exports.default = SellFragmentsController;

/***/ }),

/***/ 1616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _infoCheckbox = __webpack_require__(1617);

var _infoCheckbox2 = _interopRequireDefault(_infoCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core.app.component('infoCheckbox', _infoCheckbox2.default);

/***/ }),

/***/ 1617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _infoCheckbox = __webpack_require__(1618);

var _infoCheckbox2 = _interopRequireDefault(_infoCheckbox);

var _infoCheckbox3 = __webpack_require__(1619);

var _infoCheckbox4 = _interopRequireDefault(_infoCheckbox3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  restrict: 'E',
  bindings: {
    options: '=',
    form: '<',
    model: '='
  },
  transclude: true,
  template: _infoCheckbox2.default,
  controller: _infoCheckbox4.default,
  controllerAs: 'vm'
};

/***/ }),

/***/ 1618:
/***/ (function(module, exports) {

module.exports = "<div class=\"info-checkbox\">\n  <div class=\"flex justify-between align-baseline\">\n    <!-- Checkbox + Label -->\n    <fd-form-control\n      type=\"{{vm.options.type}}\"\n      value=\"vm.options.value\"\n      label=\"{{vm.options.label}}\"\n      model=\"vm.model\"\n      form=\"vm.form\"\n      options=\"vm.options\"\n      name=\"{{vm.options.name}}\"\n      class=\"flex-1\"\n    >\n    </fd-form-control>\n\n    <!-- Info Toggle -->\n    <div ng-if=\"vm.options.infoTextKey\" ng-click=\"vm.showInfo = !vm.showInfo\">\n      <img ng-if=\"vm.options.iconPath\" ng-src=\"{{vm.options.iconPath}}\" />\n      <i ng-if=\"!vm.options.iconPath\" class=\"fa fa-info info-icon\"></i>\n    </div>\n  </div>\n\n  <!-- Info Box (toggled) -->\n  <div\n    ng-if=\"vm.options.infoTextKey\"\n    ng-show=\"vm.showInfo\"\n    class=\"well fade-in\"\n  >\n    <div translate=\"{{vm.options.infoTextKey}}\"></div>\n  </div>\n\n  <ng-transclude></ng-transclude>\n</div>\n"

/***/ }),

/***/ 1619:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfoCheckboxController = function (_BaseController) {
  InfoCheckboxController.$inject = ["controllerService"];
  (0, _inherits3.default)(InfoCheckboxController, _BaseController);

  function InfoCheckboxController(controllerService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, InfoCheckboxController);
    return (0, _possibleConstructorReturn3.default)(this, (InfoCheckboxController.__proto__ || (0, _getPrototypeOf2.default)(InfoCheckboxController)).call(this, { controllerService: controllerService }));
  }

  (0, _createClass3.default)(InfoCheckboxController, [{
    key: '$onInit',
    value: function $onInit() {
      this.showInfo = false;
    }
  }]);
  return InfoCheckboxController;
}(_controller.BaseController);

exports.default = InfoCheckboxController;

/***/ }),

/***/ 1620:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _oldBankInput = __webpack_require__(1621);

_core.app.component('oldBankInput', _oldBankInput.oldBankInputComponent);

/***/ }),

/***/ 1621:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oldBankInputComponent = undefined;

var _oldBankInput = __webpack_require__(1622);

var _oldBankInput2 = _interopRequireDefault(_oldBankInput);

var _oldBankInput3 = __webpack_require__(1623);

var _oldBankInput4 = _interopRequireDefault(_oldBankInput3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var oldBankInputComponent = exports.oldBankInputComponent = {
  name: 'oldBankInput',
  restrict: 'E',
  bindings: {
    form: '<',
    model: '=',
    title: '<',
    pretitle: '<'
  },
  template: _oldBankInput2.default,
  controllerAs: 'vm',
  controller: _oldBankInput4.default
};

/***/ }),

/***/ 1622:
/***/ (function(module, exports) {

module.exports = "<div class=\"old-bank-input\">\n  <header>\n    <h2 ng-if=\"vm.pretitle\" class=\"pretitle\">{{ vm.pretitle | translate }}</h2>\n    <h1 class=\"title\" ng-class=\"{'has-pretitle': !!vm.pretitle}\">\n      {{ vm.title | translate }}\n    </h1>\n  </header>\n  <bank-search\n    form=\"vm.form\"\n    model=\"vm.model\"\n    name=\"oldBank\"\n    label=\"app.login.resource\"\n    bind-label=\"shortName\"\n    on-select=\"vm.selectBank($item)\"\n    url=\"api\"\n    messages=\"vm.messages.oldBankIdentifier\"\n    required=\"true\"\n  >\n  </bank-search>\n  <fd-form-control\n    type=\"tel\"\n    form=\"vm.form\"\n    model=\"vm.model.oldAccountNumber\"\n    name=\"oldAccountNumber\"\n    label=\"guidedTour.oldAccountNumber.label\"\n    messages=\"vm.messages.oldAccountNumber\"\n    required=\"true\"\n  >\n  </fd-form-control>\n</div>\n"

/***/ }),

/***/ 1623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

var _oldPortfolio = __webpack_require__(635);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OldBankInputController = function (_BaseController) {
  OldBankInputController.$inject = ["controllerService", "$scope"];
  (0, _inherits3.default)(OldBankInputController, _BaseController);

  function OldBankInputController(controllerService, $scope) {
    'ngInject';

    (0, _classCallCheck3.default)(this, OldBankInputController);
    return (0, _possibleConstructorReturn3.default)(this, (OldBankInputController.__proto__ || (0, _getPrototypeOf2.default)(OldBankInputController)).call(this, {
      controllerService: controllerService,
      $scope: $scope
    }));
  }

  (0, _createClass3.default)(OldBankInputController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.messages = _oldPortfolio.OldPortfolioMessages;

      this.$scope.$watch('vm.model.oldAccountNumber', function (newValue) {
        if (!_this2.form.oldAccountNumber) return;

        _this2.form.oldAccountNumber.$setValidity('oldAccountNumberEqualsNewAccountNumber', _this2.oldAccountNumberNotEqualsNewAccountNumber(_this2.model.oldAccountNumber));
      });

      this.$scope.$watch('vm.model.shortName', function (newValue) {
        if (!_this2.form.oldBank) return;

        _this2.form.oldBank.$setValidity('invalidBankIdentifier', _this2.oldBankIsValid(_this2.model));
      });
    }
  }, {
    key: 'selectBank',
    value: function selectBank(bank) {
      // banksearch returns blz as legacyBankIdentifier and bankCode, fallback if one of them dont exist
      this.model.legacyBankIdentifier = bank.legacyBankIdentifier ? bank.legacyBankIdentifier : bank.bankCode;
    }
  }, {
    key: 'oldBankIsValid',
    value: function oldBankIsValid(bank) {
      return bank && !!bank.legacyBankIdentifier;
    }
  }, {
    key: 'oldAccountNumberNotEqualsNewAccountNumber',
    value: function oldAccountNumberNotEqualsNewAccountNumber(oldAccountNumber) {
      var newBank = this.appCache.get('newBank');
      if (!newBank) {
        return;
      }

      // Compare old and new account number without considering spaces and case of string
      var newAccountNumber = newBank.portfolioId;
      return ('' + oldAccountNumber).replace(/\s+/g, '').toLowerCase() !== ('' + newAccountNumber).replace(/\s+/g, '').toLowerCase();
    }
  }]);
  return OldBankInputController;
}(_controller.BaseController);

exports.default = OldBankInputController;

/***/ }),

/***/ 1624:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _positions = __webpack_require__(1625);

var _positions2 = _interopRequireDefault(_positions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core.app.component('positions', _positions2.default);

/***/ }),

/***/ 1625:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _positions = __webpack_require__(1626);

var _positions2 = _interopRequireDefault(_positions);

var _positions3 = __webpack_require__(1627);

var _positions4 = _interopRequireDefault(_positions3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  restrict: 'E',
  bindings: {
    oldPositions: '<',
    transfer: '<'
  },
  template: _positions2.default,
  controller: _positions4.default,
  controllerAs: 'vm'
};

/***/ }),

/***/ 1626:
/***/ (function(module, exports) {

module.exports = "<div class=\"positions\">\n  <header class=\"header\" ng-click=\"vm.toggle()\">\n    <span translate=\"app.positions.header\"></span>\n    <i class=\"pull-right fa\" ng-class=\"{'fa-chevron-down': !vm.show, 'fa-chevron-up': vm.show}\"></i>\n  </header>\n  <div class=\"list-container\" ng-show=\"vm.show\">\n    <ul class=\"no-list-style\" ng-if=\"vm.transfer.funds.length > 0\">\n      <li class=\"row\" ng-repeat=\"tranny in vm.transfer.funds\" title=\"{{vm.oldPositions.funds[$index].name}} / {{vm.oldPositions.funds[$index].isin}}\">\n        <span class=\"pull-left credentials\">\n          <span class=\"name\">{{vm.oldPositions.funds[$index].name}}</span>\n          <span class=\"isin\"> / {{vm.oldPositions.funds[$index].isin}}</span>\n        </span>\n        <span class=\"pull-right quants\">\n          <span class=\"transQuan\">{{tranny.quantity}}</span><span class=\"oldQuan\">/{{vm.oldPositions.funds[$index].quantity}}</span>\n        </span>\n      </li>\n    </ul>\n    <ul class=\"no-list-style\" ng-if=\"vm.transfer.securities.length > 0\">\n      <li class=\"row\" ng-repeat=\"tranny in vm.transfer.securities\" title=\"{{vm.oldPositions.securities[$index].name}} / {{vm.oldPositions.securities[$index].isin}}\">\n        <span class=\"pull-left credentials\">\n          <span class=\"name\">{{vm.oldPositions.securities[$index].name}}</span>\n          <span class=\"isin\"> / {{vm.oldPositions.securities[$index].isin}}</span>\n        </span>\n        <span class=\"pull-right quants\">\n          <span class=\"transQuan\">{{tranny.quantity}}</span>\n          <span class=\"oldQuan\">/{{vm.oldPositions.securities[$index].quantity}}</span>\n          <b translate=\"app.positions.pieces\"></b>\n        </span>\n      </li>\n    </ul>\n  </div>\n</div>\n"

/***/ }),

/***/ 1627:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PositionsController = function (_BaseController) {
  PositionsController.$inject = ["controllerService", "$scope"];
  (0, _inherits3.default)(PositionsController, _BaseController);

  function PositionsController(controllerService, $scope) {
    'ngInject';

    (0, _classCallCheck3.default)(this, PositionsController);
    return (0, _possibleConstructorReturn3.default)(this, (PositionsController.__proto__ || (0, _getPrototypeOf2.default)(PositionsController)).call(this, { controllerService: controllerService, $scope: $scope }));
  }

  (0, _createClass3.default)(PositionsController, [{
    key: '$onInit',
    value: function $onInit() {
      this.transferPositions = {};
      this.show = false;
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      this.show = !this.show;
    }
  }]);
  return PositionsController;
}(_controller.BaseController);

exports.default = PositionsController;

/***/ }),

/***/ 1628:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _positionsTable = __webpack_require__(1629);

var _positionsTable2 = _interopRequireDefault(_positionsTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core.app.component('positionsTable', _positionsTable2.default);

/***/ }),

/***/ 1629:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _positionsTable = __webpack_require__(1630);

var _positionsTable2 = _interopRequireDefault(_positionsTable);

var _positionsTable3 = __webpack_require__(1631);

var _positionsTable4 = _interopRequireDefault(_positionsTable3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  restrict: 'E',
  bindings: {
    oldPositions: '<',
    transfer: '<'
  },
  template: _positionsTable2.default,
  controller: _positionsTable4.default,
  controllerAs: 'vm'
};

/***/ }),

/***/ 1630:
/***/ (function(module, exports) {

module.exports = "<div class=\"table-container positions-table\">\n  <table class=\"table\">\n    <thead>\n      <tr>\n        <th translate=\"app.addSecurities.input.name\"></th>\n        <th translate=\"app.addSecurities.input.quantity\"></th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"tranny in vm.transfer.funds\">\n        <td class=\"credentials\">\n          <span class=\"name\">{{vm.oldPositions.funds[$index].name}}</span>\n          <span class=\"isin\"> / {{vm.oldPositions.funds[$index].isin}}</span>\n        </td>\n        <td>\n          <span class=\"transQuan\">{{tranny.quantity}}</span\n          ><span class=\"oldQuan\"\n            >/{{vm.oldPositions.funds[$index].quantity}}</span\n          >\n        </td>\n      </tr>\n      <tr ng-repeat=\"tranny in vm.transfer.securities\">\n        <td class=\"credentials\">\n          <span class=\"name\">{{vm.oldPositions.securities[$index].name}}</span>\n          <span class=\"isin\">\n            / {{vm.oldPositions.securities[$index].isin}}</span\n          >\n        </td>\n        <td class=\"quants\">\n          <span class=\"transQuan\">{{tranny.quantity}}</span>\n          <span class=\"oldQuan\"\n            >/{{vm.oldPositions.securities[$index].quantity}}</span\n          >\n          <b translate=\"app.positions.pieces\"></b>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n"

/***/ }),

/***/ 1631:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PositionsTableController = function (_BaseController) {
  PositionsTableController.$inject = ["controllerService", "$scope"];
  (0, _inherits3.default)(PositionsTableController, _BaseController);

  function PositionsTableController(controllerService, $scope) {
    'ngInject';

    (0, _classCallCheck3.default)(this, PositionsTableController);
    return (0, _possibleConstructorReturn3.default)(this, (PositionsTableController.__proto__ || (0, _getPrototypeOf2.default)(PositionsTableController)).call(this, { controllerService: controllerService, $scope: $scope }));
  }

  (0, _createClass3.default)(PositionsTableController, [{
    key: '$onInit',
    value: function $onInit() {
      this.transferPositions = {};
      this.show = false;
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      this.show = !this.show;
    }
  }]);
  return PositionsTableController;
}(_controller.BaseController);

exports.default = PositionsTableController;

/***/ }),

/***/ 1632:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _progressBar = __webpack_require__(1633);

var _progressBar2 = _interopRequireDefault(_progressBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core.app.component('progressBar', _progressBar2.default);

/***/ }),

/***/ 1633:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _progressBar = __webpack_require__(636);

var _progressBar2 = _interopRequireDefault(_progressBar);

var _progressBar3 = __webpack_require__(637);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  restrict: 'E',
  bindings: {
    states: '<',
    show: '@'
  },
  template: _progressBar2.default,
  controller: _progressBar3.ProgressBarController,
  controllerAs: 'vm'
};

/***/ }),

/***/ 1634:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _stockList = __webpack_require__(1635);

var _stockList2 = _interopRequireDefault(_stockList);

var _partCalculator = __webpack_require__(1642);

var _partCalculator2 = _interopRequireDefault(_partCalculator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core.app.component('stockList', _stockList2.default);
_core.app.component('partCalculator', _partCalculator2.default);

/***/ }),

/***/ 1635:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stockList = __webpack_require__(1636);

var _stockList2 = _interopRequireDefault(_stockList);

var _stockList3 = __webpack_require__(1637);

var _stockList4 = _interopRequireDefault(_stockList3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  restrict: 'E',
  bindings: {
    list: '=',
    toTransfer: '='
  },
  template: _stockList2.default,
  controller: _stockList4.default,
  controllerAs: 'vm'
};

/***/ }),

/***/ 1636:
/***/ (function(module, exports) {

module.exports = "<div class=\"table-container stock-list\">\n  <table class=\"table\">\n    <thead>\n      <tr>\n        <th translate=\"app.stocklist.table.nameOfStock\"></th>\n        <th translate=\"app.stocklist.table.transferParts\"></th>\n        <th\n          translate=\"app.stocklist.table.transferValue\"\n          class=\"text-right\"\n        ></th>\n        <th translate=\"app.stocklist.table.total\" class=\"text-right\"></th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"(key, value) in vm.list track by $index\">\n        <td>\n          <span><strong>{{value.name}}</strong></span>\n          <br />\n          <span><small>{{value.isin}}</small></span>\n        </td>\n        <td>\n          <part-calculator\n            price=\"value.price\"\n            quantity=\"value.quantity\"\n            currency=\"value.currency\"\n            model-transfer-quantity=\"vm.toTransfer[$index].quantity\"\n          >\n          </part-calculator>\n        </td>\n        <td class=\"text-right\">\n          <span class=\"text-meta\">\n            à {{value.price | number:2}} {{vm.currency}}\n          </span>\n          <br />\n          <span class=\"text-highlight\">\n            {{vm.getSum(vm.toTransfer[$index], value.price) | number:2}}\n            {{value.currency}}\n          </span>\n        </td>\n        <td class=\"text-right\">\n          <span class=\"text-meta\">\n            {{vm.getRest(value, vm.toTransfer[$index]) | number:2}}\n            {{value.currency}}\n          </span>\n          <br />\n          <span class=\"text-bold\">\n            {{vm.getSum(value) | number:2}} {{value.currency}}\n          </span>\n        </td>\n        <td>\n          <i\n            class=\"fa fa-trash info-icon\"\n            ng-click=\"vm.removeStockEntry(key)\"\n          ></i>\n        </td>\n      </tr>\n    </tbody>\n    <tfoot ng-if=\"true\">\n      <tr>\n        <td colspan=\"2\" class=\"sum-label\">\n          <span translate=\"app.stocklist.table.sum\"></span>\n        </td>\n        <td class=\"text-highlight text-right\">\n          <span class=\"text-meta\"> - </span>\n          <br />\n          <i\n            ng-if=\"vm.helpItem\"\n            class=\"fa fa-info info-icon\"\n            ng-class=\"{'active': vm.showInfo}\"\n            ng-click=\"vm.showInfo = !vm.showInfo\"\n          ></i>\n          <span> {{vm.sum | number:2}} {{vm.currency}} </span>\n        </td>\n        <td class=\"text-right\">\n          <span class=\"text-meta\">\n            {{vm.rest | number:2}} {{vm.currency}}\n          </span>\n          <br />\n          <span class=\"text-bold\">\n            {{vm.total | number:2}} {{vm.currency}}\n          </span>\n        </td>\n      </tr>\n    </tfoot>\n  </table>\n</div>\n"

/***/ }),

/***/ 1637:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = __webpack_require__(1638);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StockListController = function (_BaseController) {
  StockListController.$inject = ["controllerService", "$scope", "$rootScope"];
  (0, _inherits3.default)(StockListController, _BaseController);

  function StockListController(controllerService, $scope, $rootScope) {
    'ngInject';

    (0, _classCallCheck3.default)(this, StockListController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (StockListController.__proto__ || (0, _getPrototypeOf2.default)(StockListController)).call(this, { controllerService: controllerService, $scope: $scope, $rootScope: $rootScope }));

    _this.toTransfer = [];
    _this.currency = 'EUR';
    return _this;
  }

  (0, _createClass3.default)(StockListController, [{
    key: '$onInit',
    value: function $onInit() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (this.toTransfer.length !== this.list.length) {
            this.toTransfer.push((0, _extends3.default)({}, item));
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: 'getSum',
    value: function getSum(item) {
      var price = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : item.price;

      price = parseFloat(price) || 0;
      return item.quantity * price;
    }
  }, {
    key: 'getRest',
    value: function getRest(total, item) {
      return (total.quantity - item.quantity) * total.price;
    }
  }, {
    key: 'removeStockEntry',
    value: function removeStockEntry(index) {
      this.list.splice(index, 1);
      this.toTransfer.splice(index, 1);
      this.$rootScope.$broadcast('stockListChanged', {
        list: this.list,
        toTransfer: this.toTransfer
      });
    }
  }, {
    key: 'total',
    get: function get() {
      var total = 0.0;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(this.list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          total += this.getSum(item);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return total;
    }
  }, {
    key: 'sum',
    get: function get() {
      var sum = 0;
      for (var i = this.toTransfer.length - 1; i >= 0; i--) {
        sum += this.getSum(this.toTransfer[i]);
      }
      return sum;
    }
  }, {
    key: 'rest',
    get: function get() {
      return this.total.toFixed(3) - this.sum.toFixed(3);
    }
  }]);
  return StockListController;
}(_controller.BaseController);

exports.default = StockListController;

/***/ }),

/***/ 1642:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _partCalculator = __webpack_require__(1643);

var _partCalculator2 = _interopRequireDefault(_partCalculator);

var _partCalculator3 = __webpack_require__(1644);

var _partCalculator4 = _interopRequireDefault(_partCalculator3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  restrict: 'E',
  bindings: {
    price: '<',
    quantity: '=',
    currency: '<',
    modelTransferQuantity: '='
  },
  template: _partCalculator2.default,
  controller: _partCalculator4.default,
  controllerAs: 'vm'
};

/***/ }),

/***/ 1643:
/***/ (function(module, exports) {

module.exports = "<form name=\"partCalculatorForm\" class=\"form-inline part-calculator\">\n  <div class=\"form-group\">\n    <div class=\"flex align-center\">\n      <!-- Transfer input -->\n      <fd-form-control\n        type=\"number\"\n        name=\"partCalculatorInput\"\n        type-options=\"vm.options\"\n        model=\"vm.modelTransferQuantity\"\n        on-change=\"vm.modelChanged()\"\n        class-name=\"part-calculator-transfer-quantity-input\"\n      >\n      </fd-form-control>\n      <!-- Quantity addon -->\n      <div class=\"quantity\">von {{vm.quantity }}</div>\n      <!-- In-/decrease button -->\n      <div class=\"part-calculator-buttons\">\n        <div class=\"split-buttons\">\n          <button\n            ng-click=\"vm.increase()\"\n            class=\"button increase\"\n            type=\"button\"\n            ng-class=\"{disabled: vm.increaseDisabled}\"\n            ng-disabled=\"vm.increaseDisabled\"\n          ></button>\n          <button\n            ng-click=\"vm.decrease()\"\n            class=\"button decrease\"\n            type=\"button\"\n            ng-class=\"{disabled: vm.decreaseDisabled}\"\n            ng-disabled=\"vm.decreaseDisabled\"\n          ></button>\n        </div>\n      </div>\n    </div>\n    <!-- <label class=\"part-calculator-price\">\n      à {{vm.price | number:3}} {{vm.currency}}\n    </label> -->\n  </div>\n  <ng-messages for=\"partCalculatorForm.partCalculatorInput.$error\">\n    <ng-message when=\"min\" class=\"alert alert-danger\">\n      {{ 'app.partcalculator.error.min' | translate }}\n    </ng-message>\n    <ng-message when=\"max\" class=\"alert alert-danger\">\n      {{ 'app.partcalculator.error.max' | translate }}\n    </ng-message>\n  </ng-messages>\n</form>\n"

/***/ }),

/***/ 1644:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInteger = __webpack_require__(1645);

var _isInteger2 = _interopRequireDefault(_isInteger);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PartCalculatorController = function (_BaseController) {
  PartCalculatorController.$inject = ["controllerService", "$scope", "$rootScope"];
  (0, _inherits3.default)(PartCalculatorController, _BaseController);

  function PartCalculatorController(controllerService, $scope, $rootScope) {
    'ngInject';

    (0, _classCallCheck3.default)(this, PartCalculatorController);
    return (0, _possibleConstructorReturn3.default)(this, (PartCalculatorController.__proto__ || (0, _getPrototypeOf2.default)(PartCalculatorController)).call(this, { controllerService: controllerService, $scope: $scope, $rootScope: $rootScope }));
  }

  (0, _createClass3.default)(PartCalculatorController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      // fractals of depot are not allowed:
      // - floor them
      // -  show hint with option to check sellFragments
      this.$scope.$watch('vm.modelTransferQuantity', function (newValue) {
        if (!(0, _isInteger2.default)(_this2.modelTransferQuantity)) {
          _this2.modelTransferQuantity = Math.floor(_this2.modelTransferQuantity);
          _this2.$rootScope.$broadcast('hasFragments', true);
        }
      });
    }

    // important: form must updates its min and max ranges when model changes

  }, {
    key: '$onChanges',
    value: function $onChanges() {
      this.options = {
        min: 0,
        max: this.quantity
      };
    }
  }, {
    key: 'increase',
    value: function increase() {
      if (this.modelTransferQuantity < this.quantity) {
        this.modelTransferQuantity = Math.floor(this.modelTransferQuantity) + 1;
      }
    }
  }, {
    key: 'decrease',
    value: function decrease() {
      if (this.modelTransferQuantity > 0) {
        this.modelTransferQuantity = Math.ceil(this.modelTransferQuantity) - 1;
      }
    }
  }, {
    key: 'increaseDisabled',
    get: function get() {
      return this.modelTransferQuantity + 1 > this.options.max;
    }
  }, {
    key: 'decreaseDisabled',
    get: function get() {
      return this.modelTransferQuantity - 1 < this.options.min;
    }
  }]);
  return PartCalculatorController;
}(_controller.BaseController);

exports.default = PartCalculatorController;

/***/ }),

/***/ 1649:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _toggleControl = __webpack_require__(1650);

var _toggleControl2 = _interopRequireDefault(_toggleControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core.app.component('toggleControl', _toggleControl2.default);

/***/ }),

/***/ 1650:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toggleControl = __webpack_require__(1651);

var _toggleControl2 = _interopRequireDefault(_toggleControl);

var _toggleControl3 = __webpack_require__(1652);

var _toggleControl4 = _interopRequireDefault(_toggleControl3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  restrict: 'E',
  bindings: {
    model: '=',
    controlId: '@',
    label: '@',
    labelValues: '<',
    infoTextKey: '@',
    isDisabled: '='
  },
  transclude: true,
  template: _toggleControl2.default,
  controller: _toggleControl4.default,
  controllerAs: 'vm'
};

/***/ }),

/***/ 1651:
/***/ (function(module, exports) {

module.exports = "<div class=\"toggle-control\">\n  <label\n    class=\"tgl-label\"\n    for=\"{{ vm.controlId || 'selection' }}\"\n    ng-class=\"{'tgl-label-disabled': vm.isDisabled}\"\n    translate=\"{{ vm.label }}\"\n    translate-values=\"vm.labelValues\"\n  ></label>\n  <div class=\"checkbox-container\">\n    <input\n      type=\"checkbox\"\n      id=\"{{ vm.controlId || 'selection' }}\"\n      ng-disabled=\"vm.isDisabled\"\n      ng-model=\"vm.model\"\n      class=\"tgl tgl-input\"\n    />\n    <label\n      class=\"tgl-btn\"\n      ng-class=\"{'tgl-btn-disabled': vm.isDisabled}\"\n      for=\"{{ vm.controlId || 'selection' }}\"\n    ></label>\n  </div>\n\n  <!-- Info Toggle -->\n  <a\n    ng-if=\"vm.infoTextKey\"\n    class=\"btn-show-info\"\n    aria-label=\"{{'app.aria.infoToggle' | translate}}\"\n    ng-click=\"vm.showInfo = !vm.showInfo\"\n    href\n  >\n    <i ng-if=\"!vm.options.iconPath\" class=\"fa fa-info info-icon\"></i>\n  </a>\n</div>\n\n<!-- Info Box (toggled) -->\n<div\n  ng-if=\"vm.infoTextKey && vm.showInfo\"\n  class=\"well fade-in toggle-control-info\"\n>\n  <div tabindex=\"0\" translate=\"{{vm.infoTextKey}}\"></div>\n</div>\n\n<ng-transclude></ng-transclude>\n"

/***/ }),

/***/ 1652:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleControlController = function (_BaseController) {
  ToggleControlController.$inject = ["controllerService"];
  (0, _inherits3.default)(ToggleControlController, _BaseController);

  function ToggleControlController(controllerService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, ToggleControlController);
    return (0, _possibleConstructorReturn3.default)(this, (ToggleControlController.__proto__ || (0, _getPrototypeOf2.default)(ToggleControlController)).call(this, { controllerService: controllerService }));
  }

  (0, _createClass3.default)(ToggleControlController, [{
    key: '$onInit',
    value: function $onInit() {
      this.showInfo = false;
    }
  }]);
  return ToggleControlController;
}(_controller.BaseController);

exports.default = ToggleControlController;

/***/ }),

/***/ 1653:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _loadingOverlay = __webpack_require__(1654);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core.app.component('loadingOverlay', _loadingOverlay2.default);

/***/ }),

/***/ 1654:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _libInjection = __webpack_require__(10);

var _loadingOverlay = __webpack_require__(1655);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingOverlayController = function (_InjectableClass) {
  LoadingOverlayController.$inject = ["appConfig", "configService"];
  (0, _inherits3.default)(LoadingOverlayController, _InjectableClass);

  function LoadingOverlayController(appConfig, configService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, LoadingOverlayController);
    return (0, _possibleConstructorReturn3.default)(this, (LoadingOverlayController.__proto__ || (0, _getPrototypeOf2.default)(LoadingOverlayController)).call(this, { appConfig: appConfig, configService: configService }));
  }

  return LoadingOverlayController;
}(_libInjection.InjectableClass);

exports.default = {
  restrict: 'E',
  template: _loadingOverlay2.default,
  controllerAs: 'vm',
  bindings: {
    loading: '='
  },
  controller: LoadingOverlayController
};

/***/ }),

/***/ 1655:
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"vm.loading\" class=\"loading-overlay\">\n  <div class=\"loading-container\">\n    <h1 translate=\"app.status.loading\"></h1>\n    <i class=\"fa fa-spinner rotating\"></i>\n  </div>\n</div>\n"

/***/ }),

/***/ 1656:
/***/ (function(module, exports) {

module.exports = {
	"app.name": "Depotwechsel",
	"api.path": "/api",
	"api.version": "v0",
	"assetsUrl": "https://s3.eu-central-1.amazonaws.com/fino-tenant-assets"
}

/***/ }),

/***/ 1657:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchConfig = undefined;

var _core = __webpack_require__(7);

var _config = __webpack_require__(1658);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable angular/window-service */
_core.app.service('configService', _config2.default);

var fetchConfig = exports.fetchConfig = function fetchConfig() {
  var $http = angular.injector(['ng']).get('$http');
  return $http({
    method: 'GET',
    url: 'https://tenants.fino.cloud/conf/dws/byUrl/' + window.location.hostname,
    error: {
      silent: true
    }
  });
};

/***/ }),

/***/ 1658:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _kebabCase2 = __webpack_require__(639);

var _kebabCase3 = _interopRequireDefault(_kebabCase2);

var _request = __webpack_require__(129);

var _env = __webpack_require__(1668);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfigService = function (_ApiRequest) {
  ConfigService.$inject = ["$http", "$q", "appCache"];
  (0, _inherits3.default)(ConfigService, _ApiRequest);

  function ConfigService($http, $q, appCache) {
    'ngInject';

    (0, _classCallCheck3.default)(this, ConfigService);
    return (0, _possibleConstructorReturn3.default)(this, (ConfigService.__proto__ || (0, _getPrototypeOf2.default)(ConfigService)).call(this, { $http: $http, $q: $q, appCache: appCache }));
  }

  (0, _createClass3.default)(ConfigService, [{
    key: 'storeConfig',
    value: function storeConfig(config) {
      this.appCache.set('config', config);
    }
  }, {
    key: 'getConfig',
    value: function getConfig() {
      return this.appCache.get('config');
    }
  }, {
    key: 'fetchLegalContent',
    value: function fetchLegalContent(tenant, document) {
      var loweredKebab = (0, _kebabCase3.default)(tenant);

      return this.$http({
        url: 'https://tenants.fino.cloud/conf/dws/' + loweredKebab + '/' + document
      });
    }
  }, {
    key: 'getStage',
    value: function getStage() {
      // eslint-disable-next-line angular/window-service
      var host = window.location.host;
      if (host.includes('localhost') || host.includes('.dev')) {
        return _env.ENVIRONMENTS.DEV;
      } else if (host.includes('.test')) {
        return _env.ENVIRONMENTS.TESTING;
      } else {
        return _env.ENVIRONMENTS.PRODUCTION;
      }
    }
  }, {
    key: 'isDevelopment',
    value: function isDevelopment() {
      return this.getStage() === _env.ENVIRONMENTS.DEV;
    }
  }, {
    key: 'isTesting',
    value: function isTesting() {
      return this.getStage() === _env.ENVIRONMENTS.TESTING;
    }
  }, {
    key: 'isProduction',
    value: function isProduction() {
      return this.getStage() === _env.ENVIRONMENTS.PRODUCTION;
    }
  }, {
    key: 'getName',
    value: function getName() {
      if (!this.config) return null;
      return this.config.name;
    }
  }, {
    key: 'getTenant',
    value: function getTenant() {
      if (!this.config) return null;
      return this.config.tenant;
    }
  }, {
    key: 'isFeatureActive',
    value: function isFeatureActive(feature) {
      return !!this.getFeature(feature);
    }
  }, {
    key: 'getFeature',
    value: function getFeature(feature) {
      if (!this.config) return false;
      return this.config.features[feature];
    }
  }, {
    key: '$get',
    value: function $get() {
      return this;
    }
  }, {
    key: 'config',
    get: function get() {
      return this.getConfig();
    }
  }]);
  return ConfigService;
}(_request.ApiRequest);

exports.default = ConfigService;

/***/ }),

/***/ 1668:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ENVIRONMENTS = exports.ENVIRONMENTS = {
  DEV: 'dev',
  TESTING: 'testing',
  PRODUCTION: 'production'
};

/***/ }),

/***/ 1669:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _dataSource = __webpack_require__(1670);

_core.app.service('securitiesService', _dataSource.SecuritiesService);
_core.app.service('bankSourceService', _dataSource.BankSearchService);

/***/ }),

/***/ 1670:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BankSearchService = exports.SecuritiesService = undefined;

var _securitiesSource = __webpack_require__(1671);

var _bankSearchSource = __webpack_require__(1672);

/**
 * Collect all data sources and export their services.
 */
exports.SecuritiesService = _securitiesSource.SecuritiesService;
exports.BankSearchService = _bankSearchSource.BankSearchService;

/***/ }),

/***/ 1671:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecuritiesService = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _request = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SecuritiesService = exports.SecuritiesService = function (_ApiRequest) {
  SecuritiesService.$inject = ["$http", "$q"];
  (0, _inherits3.default)(SecuritiesService, _ApiRequest);

  function SecuritiesService($http, $q) {
    'ngInject';

    (0, _classCallCheck3.default)(this, SecuritiesService);
    return (0, _possibleConstructorReturn3.default)(this, (SecuritiesService.__proto__ || (0, _getPrototypeOf2.default)(SecuritiesService)).call(this, { $http: $http, $q: $q }));
  }

  (0, _createClass3.default)(SecuritiesService, [{
    key: 'loginAndFetch',
    value: function loginAndFetch(resource, credentials) {
      return this.$http({
        method: 'POST',
        data: {
          bankCode: resource.identifier,
          username: credentials[0],
          password: credentials[1]
        },
        url: '/api/securities'
      });
    }
  }, {
    key: 'loginWithUBA',
    value: function loginWithUBA() {
      return this.$http.get('/api/uba/login');
    }
  }, {
    key: 'fetchWithUBA',
    value: function fetchWithUBA(userIdentifier) {
      return this.$http({
        method: 'POST',
        data: {
          userIdentifier: userIdentifier
        },
        url: '/api/uba/transactions'
      });
    }
  }]);
  return SecuritiesService;
}(_request.ApiRequest);

/***/ }),

/***/ 1672:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BankSearchService = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _request = __webpack_require__(129);

var _lib = __webpack_require__(303);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BankSearchService = exports.BankSearchService = function (_ApiRequest) {
  BankSearchService.$inject = ["$http", "$q"];
  (0, _inherits3.default)(BankSearchService, _ApiRequest);

  function BankSearchService($http, $q) {
    'ngInject';

    (0, _classCallCheck3.default)(this, BankSearchService);
    return (0, _possibleConstructorReturn3.default)(this, (BankSearchService.__proto__ || (0, _getPrototypeOf2.default)(BankSearchService)).call(this, { $http: $http, $q: $q }));
  }

  (0, _createClass3.default)(BankSearchService, [{
    key: 'resourceSearch',
    value: function resourceSearch(search) {
      return this.$http({
        method: 'GET',
        url: '/api/banks/' + search + '?limit=10',
        error: {
          silent: true
        }
      }).then(_lib.DataResponse.transform('data.banks'));
    }
  }, {
    key: 'getDisplayName',
    value: function getDisplayName(entry) {
      return entry.shortName || entry.name;
    }
  }, {
    key: 'getIdentifier',
    value: function getIdentifier(entry) {
      // bankCode is filled when bank selected from list, otherwise using user entered data
      return entry.bankCode || entry.name;
    }
  }]);
  return BankSearchService;
}(_request.ApiRequest);

/***/ }),

/***/ 1674:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1675);

/***/ }),

/***/ 1675:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _angular = __webpack_require__(65);

var _angular2 = _interopRequireDefault(_angular);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core.app.directive('trackEvent', ["trackingService", function (trackingService) {
  'ngInject';

  return {
    link: function link(scope, elem, attrs) {
      elem.on('click', function (ev) {
        var trackEvent = attrs.trackEvent,
            trackData = attrs.trackData;

        trackingService.trackEvent(trackEvent, {
          props: (0, _extends3.default)({}, _angular2.default.fromJson(trackData))
        });
      });
    }
  };
}]);

/***/ }),

/***/ 1676:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _accountIdValidation = __webpack_require__(186);

_core.app.service('accountIdValidationService', _accountIdValidation.AccountIdValidationService);

/***/ }),

/***/ 1677:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ravenJs = __webpack_require__(1678);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _core = __webpack_require__(7);

var _ravenHttpInterceptor = __webpack_require__(1684);

var _ravenHttpInterceptor2 = _interopRequireDefault(_ravenHttpInterceptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Configure and install raven to the angular application for sentry error tracking.
_ravenJs2.default.config('https://03ead89f43e946868523f6a941e64394@o46994.ingest.sentry.io/6311010', {
  release: {"build":"20250720.1-9c9532dd","apiHost":"https://demo.dev.meindepotwechsel.de","apiPort":"443","env":"development","stages":{"dev":"dev","testing":"test"},"custom":{"1822direkt":"1822direkt","bw-bank":"bw-bank","consorsbank":"consorsbank","fino":"fino","gls-bank":"gls-bank","ing":"ing","psd":"psd","santander":"santander","sbroker":"sbroker","sparkasse":"sparkasse","vrba":"vrba"}}.build,
  ignoreErrors: [/\$rootScope:inprog.*/]
}).install();

// Log HTTP response errors to Sentry
_core.app.config(_ravenHttpInterceptor2.default);

_core.app.run(["$window", function ($window) {
  'ngInject';

  $window.Raven = _ravenJs2.default;
}]);

_core.app.factory('errorTrackingService', ["$raven", function ($raven) {
  'ngInject';

  return {
    captureMessage: $raven.captureMessage,
    captureException: $raven.captureException,
    setUserContext: $raven.setUserContext
  };
}]);

/***/ }),

/***/ 1684:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ravenHttpInterceptor.$inject = ["$provide", "$httpProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ravenHttpInterceptor;
function ravenHttpInterceptor($provide, $httpProvider) {
  'ngInject';

  // Log HTTP response errors to Sentry

  $provide.factory('ravenHttpInterceptor', ["$q", "errorTrackingService", function ($q, errorTrackingService) {
    'ngInject';

    return {
      responseError: function responseError(rejection) {
        // Ignore http error for status 4xx except Bad requests
        var config = rejection.config,
            status = rejection.status,
            data = rejection.data;

        if (status <= 499 && status !== 400) {
          return $q.reject(rejection);
        }
        var headers = rejection.headers();
        var requestID = headers ? headers['x-request-id'] : '';
        var originalMessage = data.originalMessage;

        var sentryMessage = new Error('HTTP Error: X-Request-ID ' + requestID + ' with message ' + (originalMessage || data.message));

        errorTrackingService.captureException(sentryMessage, {
          extra: {
            config: config,
            status: status,
            data: data,
            requestID: requestID,
            httpErrorMessage: originalMessage
          }
        });
        return $q.reject(rejection);
      }
    };
  }]);

  $httpProvider.interceptors.push('ravenHttpInterceptor');
}

/***/ }),

/***/ 1685:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _plausible = __webpack_require__(1686);

_core.app.service('trackingService', _plausible.PlausibleService);

/***/ }),

/***/ 1686:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlausibleService = undefined;

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _libInjection = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlausibleService = exports.PlausibleService = function (_InjectableClass) {
  PlausibleService.$inject = ["$window", "envService"];
  (0, _inherits3.default)(PlausibleService, _InjectableClass);
  (0, _createClass3.default)(PlausibleService, [{
    key: 'tenant',
    get: function get() {
      return this.envService.getTenant();
    }
  }]);

  function PlausibleService($window, envService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, PlausibleService);
    return (0, _possibleConstructorReturn3.default)(this, (PlausibleService.__proto__ || (0, _getPrototypeOf2.default)(PlausibleService)).call(this, { $window: $window, envService: envService }));
  }

  (0, _createClass3.default)(PlausibleService, [{
    key: 'trackPageview',
    value: function trackPageview() {
      if (!this.$window.plausible) return;
      this.$window.plausible('pageview');
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent(eventName, properties) {
      if (!this.$window.plausible) return;
      // console.log('PlausibleService.trackEvent', { eventName, properties }, this.tenant, this.$window);
      this.$window.plausible(eventName, (0, _extends3.default)({
        tenant: this.tenant
      }, properties));
    }
  }]);
  return PlausibleService;
}(_libInjection.InjectableClass);

/***/ }),

/***/ 1687:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _changelog = __webpack_require__(633);

var _changelog2 = __webpack_require__(632);

_core.app.config(_changelog2.changelogState);
_core.app.component(_changelog.changelogComponent.name, _changelog.changelogComponent);

/***/ }),

/***/ 1688:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _finish = __webpack_require__(641);

var _finish2 = __webpack_require__(642);

var _finish3 = __webpack_require__(1696);

_core.app.config(_finish.finishState);
_core.app.component(_finish2.finishComponent.name, _finish2.finishComponent);
_core.app.service('finishService', _finish3.FinishService);

/***/ }),

/***/ 1689:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FinishController = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FinishController = exports.FinishController = function (_BaseController) {
  FinishController.$inject = ["$scope", "$q", "controllerService", "uiModalDeclarationService", "finishService", "configService"];
  (0, _inherits3.default)(FinishController, _BaseController);

  function FinishController($scope, $q, controllerService, uiModalDeclarationService, finishService, configService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, FinishController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FinishController.__proto__ || (0, _getPrototypeOf2.default)(FinishController)).call(this, {
      $scope: $scope,
      $q: $q,
      controllerService: controllerService,
      uiModalDeclarationService: uiModalDeclarationService,
      finishService: finishService,
      configService: configService
    }));

    _this.steps = [];
    _this.loadTime = 3000;
    _this.percentProgress = 0;


    _this.steps = [{
      title: 'shipmentOfChange'
    }, {
      title: 'durationOfChange'
    }, {
      title: 'duplicationPrevention'
    }];
    return _this;
  }

  (0, _createClass3.default)(FinishController, [{
    key: '$onInit',
    value: function $onInit() {
      // eslint-disable-next-line angular/window-service
      window.scrollTo(0, 0);

      this.documentId = this.appCache.get('documentId');
      if (this.showOtherFinish) {
        this.shipmentStarted = this.appCache.get('shipmentStarted');
      }

      this.investmentApplicationRedirect = this.appCache.get('investmentApplicationRedirect');
      this.portfolioApplicationRedirect = this.appCache.get('portfolioApplicationRedirect');

      if (this.applicationPageRedirectUrl) {
        this.redirectLinkMessage = this.investmentApplicationRedirect ? 'app.finish.redirectLinkText.investment' : 'app.finish.redirectLinkText.portfolio';
        this.redirectText = this.investmentApplicationRedirect ? 'app.finish.redirectText.investment' : 'app.finish.redirectText.portfolio';
      }

      this.abdicationCancellationRight = this.appCache.get('abdicationCancellationRight');

      this.rating = 0;
      this.message = null;
      this.pdfDownloaded = false;

      this.setBeforeUnloadEvent();
      if (this.finishService.isAsyncProccessingActive) {
        this.awaitDocuments();
      }
    }
  }, {
    key: 'awaitDocuments',
    value: function awaitDocuments() {
      var _this2 = this;

      this.finishService.askForDocuments(this.orderId).then(function (res) {
        var documentId = res.data.documentId;


        if (documentId) {
          _this2.appCache.set('documentId', documentId);
          _this2.documentId = documentId;
        } else {
          _this2.nextLoad();
        }
      }).catch(function (res) {
        if (_this2.percentProgress < 80) {
          _this2.percentProgress += 20;
        }
        _this2.nextLoad();
      });
    }
  }, {
    key: 'cancelNextLoad',
    value: function cancelNextLoad() {
      this.$timeout.cancel(this.loadPromise);
    }
  }, {
    key: 'nextLoad',
    value: function nextLoad() {
      //Always make sure the last timeout is cleared before starting a new one
      this.cancelNextLoad();
      this.loadPromise = this.$timeout(this.awaitDocuments.bind(this), this.loadTime);
    }
  }, {
    key: 'setBeforeUnloadEvent',
    value: function setBeforeUnloadEvent() {
      var _this3 = this;

      this.$translate('app.finish.confirmationMessage').then(function (text) {
        var onbefore = function onbefore(event) {
          if (_this3.pdfDownloaded) {
            return;
          }
          (event || _this3.$window.event).returnValue = text;
          return text;
        };

        _this3.$window.onbeforeunload = onbefore.bind(_this3);
        _this3.$window.addEventListener('beforeunload', onbefore.bind(_this3));
      });
    }
  }, {
    key: 'downloadLetter',
    value: function downloadLetter() {
      this.pdfDownloaded = true;
      var url = this.api + '/letters/' + this.documentId;
      return this.finishService.downloadLetter(url);
    }
  }, {
    key: 'api',
    get: function get() {
      return this.appConfig.get().api.path;
    }
  }, {
    key: 'applicationPageRedirectUrl',
    get: function get() {
      return this.investmentApplicationRedirect || this.portfolioApplicationRedirect;
    }
  }, {
    key: 'PromotionImage',
    get: function get() {
      var promotion = this.configService.getFeature(this.Features.promotionImage);
      return promotion ? promotion : false;
    }
  }, {
    key: 'PromotionUrl',
    get: function get() {
      var promotion = this.configService.getFeature(this.Features.promotionLink);
      return promotion ? promotion : false;
    }
  }, {
    key: 'orderId',
    get: function get() {
      return this.appCache.get('orderId');
    }
  }, {
    key: 'documentIsPresent',
    get: function get() {
      return this.appCache.get('documentId') || this.documentId;
    }
  }]);
  return FinishController;
}(_controller.BaseController);

/***/ }),

/***/ 1690:
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n  <div class=\"content\">\n    <div class=\"steps\">\n      <h2 translate=\"app.finish.other.title\"></h2>\n\n      <div ng-if=\"!vm.documentIsPresent\">\n        <p translate=\"app.finish.loading.description\"></p>\n\n        <uib-progressbar\n          class=\"progress-striped active\"\n          max=\"100\"\n          value=\"vm.percentProgress\"\n        ></uib-progressbar>\n      </div>\n\n      <div class=\"finish-steps\">\n        <div class=\"finish-step\" ng-repeat=\"step in vm.steps\">\n          <h2 class=\"finish-step-title flex align-baseline\">\n            <span class=\"finish-step-index\">{{ $index+1 }}</span>\n            <span\n              translate=\"{{ 'app.finish.step.' + step.title + '.title' }}\"\n            ></span>\n          </h2>\n          <p\n            class=\"finish-step-description\"\n            translate=\"{{ 'app.finish.step.' + step.title + '.description' }}\"\n          ></p>\n        </div>\n      </div>\n\n      <nav class=\"buttons no-border\">\n        <fd-form-button\n          ng-if=\"vm.documentIsPresent\"\n          btn-primary=\"true\"\n          on-click=\"vm.downloadLetter()\"\n          label=\"app.finish.other.downloadLetter\"\n          icon=\"fa fa-download\"\n          class=\"center\"\n        >\n        </fd-form-button>\n      </nav>\n    </div>\n\n    <div class=\"section\">\n      <div class=\"panel panel-default\">\n        <div class=\"panel-body\">\n          <feedback-component></feedback-component>\n        </div>\n      </div>\n\n      <div ng-if=\"vm.PromotionImage\">\n        <div class=\"panel panel-default\">\n          <div class=\"panel-body\">\n            <h3 class=\"text-center\" translate=\"app.finish.promotion\"></h3>\n            <a\n              ng-href=\"{{ vm.PromotionUrl }}\"\n              target=\"_blank\"\n              class=\"promotion-image\"\n            >\n              <img ng-src=\"{{ vm.PromotionImage }}\" />\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ 1691:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _feedback = __webpack_require__(1692);

var _feedback2 = _interopRequireDefault(_feedback);

var _feedback3 = __webpack_require__(305);

var _feedback4 = __webpack_require__(1695);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core.app.component('feedbackComponent', _feedback2.default);
_core.app.factory('FeedbackModel', function () {
  return _feedback3.FeedbackModel;
});
_core.app.service('feedbackService', _feedback4.FeedbackService);

/***/ }),

/***/ 1692:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _feedback = __webpack_require__(1693);

var _feedback2 = __webpack_require__(1694);

var _feedback3 = _interopRequireDefault(_feedback2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'feedbackComponent',
  restrict: 'E',
  bindings: {},
  controller: _feedback.FeedbackController,
  controllerAs: 'vm',
  template: _feedback3.default
};

/***/ }),

/***/ 1693:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackController = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

var _feedback = __webpack_require__(305);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeedbackController = exports.FeedbackController = function (_BaseController) {
  FeedbackController.$inject = ["$scope", "controllerService", "feedbackService"];
  (0, _inherits3.default)(FeedbackController, _BaseController);

  function FeedbackController($scope, controllerService, feedbackService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, FeedbackController);
    return (0, _possibleConstructorReturn3.default)(this, (FeedbackController.__proto__ || (0, _getPrototypeOf2.default)(FeedbackController)).call(this, {
      $scope: $scope,
      controllerService: controllerService,
      feedbackService: feedbackService
    }));
  }

  (0, _createClass3.default)(FeedbackController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.submitted = false;

      this.model = new _feedback.FeedbackModel({
        orderId: this.appCache.get('orderId')
      });

      // Watch and store feedback in cache
      this.$scope.$watch('vm.model', function (value) {
        return _this2.feedbackService.storeFeedback(value);
      }, true);
    }
  }, {
    key: 'sendFeedback',
    value: function sendFeedback() {
      var _this3 = this;

      this.feedbackService.sendFeedback(this.model).then(function () {
        return _this3.sendFeedbackDone(_this3.model);
      });

      this.submitted = true;
    }
  }, {
    key: 'sendFeedbackDone',
    value: function sendFeedbackDone(feedback) {
      // Track event for feedback
      this.feedbackService.trackFeedback(feedback, true);
    }
  }]);
  return FeedbackController;
}(_controller.BaseController);

/***/ }),

/***/ 1694:
/***/ (function(module, exports) {

module.exports = "<div class=\"feedback\">\n  <form ng-if=\"!vm.submitted\">\n    <h3 class=\"text-center\" translate=\"app.feedback.title\"></h3>\n\n    <div class=\"rating-wrapper clearfix\">\n      <div class=\"rating\">\n        <input\n          type=\"radio\"\n          id=\"star5\"\n          name=\"rating\"\n          value=\"5\"\n          ng-model=\"vm.model.rating\"\n        />\n        <label\n          class=\"star\"\n          for=\"star5\"\n          title=\"Awesome\"\n          aria-hidden=\"true\"\n        ></label>\n        <input\n          type=\"radio\"\n          id=\"star4\"\n          name=\"rating\"\n          value=\"4\"\n          ng-model=\"vm.model.rating\"\n        />\n        <label\n          class=\"star\"\n          for=\"star4\"\n          title=\"Great\"\n          aria-hidden=\"true\"\n        ></label>\n        <input\n          type=\"radio\"\n          id=\"star3\"\n          name=\"rating\"\n          value=\"3\"\n          ng-model=\"vm.model.rating\"\n        />\n        <label\n          class=\"star\"\n          for=\"star3\"\n          title=\"Very good\"\n          aria-hidden=\"true\"\n        ></label>\n        <input\n          type=\"radio\"\n          id=\"star2\"\n          name=\"rating\"\n          value=\"2\"\n          ng-model=\"vm.model.rating\"\n        />\n        <label class=\"star\" for=\"star2\" title=\"Good\" aria-hidden=\"true\"></label>\n        <input\n          type=\"radio\"\n          id=\"star1\"\n          name=\"rating\"\n          value=\"1\"\n          ng-model=\"vm.model.rating\"\n        />\n        <label class=\"star\" for=\"star1\" title=\"Bad\" aria-hidden=\"true\"></label>\n      </div>\n    </div>\n\n    <div class=\"message\">\n      <fd-form-control\n        type=\"textarea\"\n        form=\"vm.form\"\n        label=\"app.feedback.feedback\"\n        model=\"vm.model.message\"\n        rows=\"5\"\n      >\n      </fd-form-control>\n    </div>\n    <div class=\"actions\">\n      <fd-form-button\n        btn-primary=\"true\"\n        btn-class=\"btn-sm\"\n        on-click=\"vm.sendFeedback()\"\n        is-disabled=\"vm.isDisabled()\"\n        label=\"app.feedback.btn\"\n      >\n      </fd-form-button>\n    </div>\n  </form>\n\n  <div ng-if=\"vm.submitted\">\n    <h2 translate=\"app.feedback.thanks\"></h2>\n  </div>\n</div>\n"

/***/ }),

/***/ 1695:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackService = undefined;

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _request = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeedbackService = exports.FeedbackService = function (_ApiRequest) {
  FeedbackService.$inject = ["$http", "appCache", "trackingService"];
  (0, _inherits3.default)(FeedbackService, _ApiRequest);

  function FeedbackService($http, appCache, trackingService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, FeedbackService);
    return (0, _possibleConstructorReturn3.default)(this, (FeedbackService.__proto__ || (0, _getPrototypeOf2.default)(FeedbackService)).call(this, { $http: $http, appCache: appCache, trackingService: trackingService }));
  }

  (0, _createClass3.default)(FeedbackService, [{
    key: 'sendFeedback',
    value: function sendFeedback(feedback) {
      return this.$http({
        method: 'POST',
        data: feedback,
        url: '/api/feedback',
        error: {
          silent: true
        }
      });
    }
  }, {
    key: 'trackFeedback',
    value: function trackFeedback(feedback, clear) {
      this.trackingService.trackEvent('feedback', (0, _extends3.default)({
        category: 'feedback'
      }, feedback));

      if (clear) {
        this.clearFeedback();
      }
    }
  }, {
    key: 'storeFeedback',
    value: function storeFeedback(feedback) {
      this.appCache.set('feedback', feedback);
    }
  }, {
    key: 'clearFeedback',
    value: function clearFeedback() {
      this.appCache.remove('feedback');
    }
  }]);
  return FeedbackService;
}(_request.ApiRequest);

/***/ }),

/***/ 1696:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FinishService = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _libInjection = __webpack_require__(10);

var _feature = __webpack_require__(184);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FinishService = exports.FinishService = function (_InjectableClass) {
  FinishService.$inject = ["$http", "FileSaver", "$timeout", "configService", "appConfig"];
  (0, _inherits3.default)(FinishService, _InjectableClass);

  function FinishService($http, FileSaver, $timeout, configService, appConfig) {
    'ngInject';

    (0, _classCallCheck3.default)(this, FinishService);
    return (0, _possibleConstructorReturn3.default)(this, (FinishService.__proto__ || (0, _getPrototypeOf2.default)(FinishService)).call(this, {
      $http: $http,
      $timeout: $timeout,
      FileSaver: FileSaver,
      configService: configService,
      appConfig: appConfig
    }));
  }

  (0, _createClass3.default)(FinishService, [{
    key: 'askForDocuments',
    value: function askForDocuments(orderId) {
      return this.$http.get(this.api + '/orders/' + orderId);
    }
  }, {
    key: 'downloadLetter',
    value: function downloadLetter(url) {
      var _this2 = this;

      return this.$http({
        method: 'GET',
        url: url,
        responseType: 'arraybuffer'
      }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/pdf' });
        _this2.FileSaver.saveAs(blob, 'depotuebertrag.pdf');
      });
    }
  }, {
    key: 'isAsyncProccessingActive',
    get: function get() {
      return this.configService.isFeatureActive(_feature.Features.asyncProcessing);
    }
  }, {
    key: 'api',
    get: function get() {
      return this.appConfig.get().api.path;
    }
  }]);
  return FinishService;
}(_libInjection.InjectableClass);

/***/ }),

/***/ 1697:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _legal = __webpack_require__(302);

var _legal2 = __webpack_require__(631);

_core.app.config(_legal.legalState);
_core.app.component(_legal2.legalComponent.name, _legal2.legalComponent);

/***/ }),

/***/ 1698:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _newPortfolio = __webpack_require__(1699);

var _newPortfolio2 = __webpack_require__(643);

var _newPortfolio3 = __webpack_require__(306);

_core.app.config(_newPortfolio.newPortfolioState);
_core.app.component(_newPortfolio2.newPortfolioComponent.name, _newPortfolio2.newPortfolioComponent);
_core.app.factory('NewPortfolioModel', function () {
  return _newPortfolio3.NewPortfolioModel;
});

/***/ }),

/***/ 1699:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newPortfolioState = exports.newPortfolioStateName = undefined;

var _newPortfolio = __webpack_require__(643);

var _app = __webpack_require__(55);

var newPortfolioStateName = exports.newPortfolioStateName = 'app.newPortfolio';

var newPortfolioState = exports.newPortfolioState = ["$stateProvider", function newPortfolioState($stateProvider) {
  'ngInject';

  $stateProvider.state({
    url: '/newPortfolio',
    name: newPortfolioStateName,
    component: _newPortfolio.newPortfolioComponent.name,
    resolve: { stateResolver: (0, _app.stateResolver)(newPortfolioStateName) }
  });
}];

/***/ }),

/***/ 1700:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewPortfolioController = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _mapKeys2 = __webpack_require__(1701);

var _mapKeys3 = _interopRequireDefault(_mapKeys2);

var _isEmpty2 = __webpack_require__(185);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _defaults2 = __webpack_require__(183);

var _defaults3 = _interopRequireDefault(_defaults2);

var _get2 = __webpack_require__(290);

var _get3 = _interopRequireDefault(_get2);

var _controller = __webpack_require__(14);

var _newPortfolio = __webpack_require__(306);

var _bank = __webpack_require__(644);

var _bank2 = __webpack_require__(301);

var _oldPortfolio = __webpack_require__(645);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewPortfolioController = exports.NewPortfolioController = function (_BaseController) {
  NewPortfolioController.$inject = ["$scope", "$q", "controllerService", "securitiesService", "addSecuritiesService", "uiModalDeclarationService", "configService"];
  (0, _inherits3.default)(NewPortfolioController, _BaseController);
  (0, _createClass3.default)(NewPortfolioController, [{
    key: 'hasFunds',
    get: function get() {
      return (0, _get3.default)(this, 'oldPortfolio.data.funds.length', 0) > 0;
    }
  }, {
    key: 'hasSecurities',
    get: function get() {
      return (0, _get3.default)(this, 'oldPortfolio.data.securities.length', 0) > 0;
    }
  }, {
    key: 'isGuidedComplete',
    get: function get() {
      return this.guidedTourIsActive && this.oldBank.legacyBankIdentifier && this.oldBank.oldAccountNumber;
    }
  }, {
    key: 'portfolioAccountIsAvailable',
    get: function get() {
      return !!this.newBank.portfolioId;
    }
  }, {
    key: 'investmentAccountIsAvailable',
    get: function get() {
      return !!this.newBank.investmentId;
    }
  }, {
    key: 'newAccountForPortfolioIsNeeded',
    get: function get() {
      var showNewPortfolioNeededInfo = this.configService.isFeatureActive(this.Features.showNewPortfolioNeededInfo);

      return this.hasSecurities && !this.portfolioAccountIsAvailable && showNewPortfolioNeededInfo;
    }
  }, {
    key: 'newAccountForInvestmentIsNeeded',
    get: function get() {
      return this.hasFunds && !this.investmentAccountIsAvailable;
    }
  }, {
    key: 'showHeadline',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.showHeadline);
    }
  }, {
    key: 'hasNoEntries',
    get: function get() {
      return !this.hasFunds && !this.hasSecurities;
    }
  }, {
    key: 'hasRemainingPositionsToTransfer',
    get: function get() {
      return this.appCache.get('oldPortfolio').disposeSecuritiesAccount && (this.hasFunds && !this.newPortfolio.transferAllFunds || this.hasSecurities && !this.newPortfolio.transferAllSecurities);
    }
  }, {
    key: 'transferAllSecurities',
    get: function get() {
      return this.oldPortfolio.transferAllSecurities;
    }
  }]);

  function NewPortfolioController($scope, $q, controllerService, securitiesService, addSecuritiesService, uiModalDeclarationService, configService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, NewPortfolioController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NewPortfolioController.__proto__ || (0, _getPrototypeOf2.default)(NewPortfolioController)).call(this, {
      $scope: $scope,
      $q: $q,
      controllerService: controllerService,
      securitiesService: securitiesService,
      addSecuritiesService: addSecuritiesService,
      uiModalDeclarationService: uiModalDeclarationService,
      configService: configService
    }));

    _this.loading = false;
    _this.guidedTourIsActive = false;
    return _this;
  }

  (0, _createClass3.default)(NewPortfolioController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.oldBank = this.appCache.get('oldBank') || new _bank.OldBankModel();
      this.newBank = this.appCache.get('newBank') || new _bank2.NewBankModel();
      this.oldPortfolio = this.appCache.get('oldPortfolio') || new _oldPortfolio.OldPortfolioModel();
      this.newPortfolio = this.appCache.get('newPortfolio') || new _newPortfolio.NewPortfolioModel();
      this.guidedTourIsActive = this.appCache.get('guidedTourIsActive');

      this.$scope.$on('stockListChanged', function (scope, changes) {
        _this2.appCache.set('oldPortfolio', _this2.oldPortfolio);
        _this2.appCache.set('newPortfolio', _this2.newPortfolio);
      });

      // if depot has fragments and user did not check sell fragments before show a info and the sell fragments box
      this.$scope.$on('hasFragments', function (scope, changes) {
        if (!_this2.oldPortfolio.sellFragments) {
          _this2.showFragmentsNotification = true;
          _this2.oldPortfolio.sellFragments = true;
        }
      });

      this.initState();
    }
  }, {
    key: 'initState',
    value: function initState() {
      // Start guided tour if it is active
      if (this.guidedTourIsActive) {
        return this.startGuidedTour();
      }

      // Fetch securities with UBA if not all securities should be transferred
      if (!this.transferAllSecurities) {
        return this.fetchSecuritiesWithUBA();
      }
    }
  }, {
    key: 'startGuidedTour',
    value: function startGuidedTour() {
      this.guidedTourIsActive = true;

      // Initiatize empty portfolio lists
      if (!this.oldPortfolio.data) {
        this.oldPortfolio;
      }
      (0, _defaults3.default)(this.oldPortfolio, {
        data: {
          accounts: [],
          securities: [],
          funds: []
        }
      });

      (0, _defaults3.default)(this.newPortfolio, {
        securities: [],
        funds: []
      });

      this.appCache.set('guidedTourIsActive', this.guidedTourIsActive);
      this.appCache.set('oldPortfolio', this.oldPortfolio);
    }
  }, {
    key: 'fetchSecuritiesWithUBA',
    value: function fetchSecuritiesWithUBA() {
      var _this3 = this;

      this.guidedTourIsActive = false;
      this.loading = true;
      var userIdentifier = this.appCache.get('UBAUserIdentifier');

      if (!userIdentifier) {
        this.return;
      }

      this.securitiesService.fetchWithUBA(userIdentifier).then(function (response) {
        // Handle empty response and load guided
        if ((0, _isEmpty3.default)(response.data.securities)) {
          _this3.showEmptyMessage = true;
          _this3.startGuidedTour();
          return;
        }

        var _response$data$accoun = response.data.accounts[0],
            accountNumber = _response$data$accoun.accountNumber,
            legacyBankIdentifier = _response$data$accoun.legacyBankIdentifier;


        _this3.oldPortfolio.data = angular.copy(response.data);
        _this3.newPortfolio = angular.copy(response.data);

        _this3.oldBank.oldAccountNumber = accountNumber;
        _this3.oldBank.legacyBankIdentifier = legacyBankIdentifier;
        _this3.updateCache();
      }).catch(function () {
        _this3.showEmptyMessage = true;
        _this3.startGuidedTour();
      }).finally(function () {
        _this3.loading = false;
      });
    }
  }, {
    key: 'updateCache',
    value: function updateCache() {
      this.appCache.set('oldBank', this.oldBank);
      this.appCache.set('oldPortfolio', this.oldPortfolio);
      this.appCache.set('transferAllSecurities', this.oldPortfolio.transferAllSecurities);
    }
  }, {
    key: 'next',
    value: function next() {
      var _this4 = this;

      this.updateCache();

      if (this.oldPortfolioForm) {
        this.oldPortfolioForm.$setSubmitted();
        if (this.oldPortfolioForm.$invalid) return;
      }

      if (this.oldPortfolio.transferAllSecurities) {
        return this.nextState();
      }

      if (this.oldBankForm) {
        this.oldBankForm.$setSubmitted();
        if (!this.oldBankForm.$valid) {
          return;
        }
      }

      if (!this.hasDataToTransfer()) {
        this.informMissingTransferOfPositions();
        return;
      }

      if (this.stockListForm && this.stockListForm.$invalid) {
        return;
      }

      this.setNewPortfolioData();

      if (this.hasRemainingPositionsToTransfer) {
        this.informRemainingPositionsToTransfer().then(function () {
          return _this4.cancelDisposingSecuritiesAccount();
        }).catch(function () {
          return _this4.fillUpSecurities();
        }).finally(function () {
          return _this4.nextState();
        });
      } else {
        this.nextState();
      }
    }
  }, {
    key: 'prev',
    value: function prev() {
      if (!this.oldPortfolio.transferAllSecurities) {
        return this.go('app.transfer');
      }

      // Don't know if and why we need this
      if (!this.hasFunds && !this.hasSecurities) {
        this.appCache.remove('oldPortfolio');
        this.oldPortfolio = null;
      }

      this.setNewPortfolioData();
      this.prevState();
    }
  }, {
    key: 'fillUpSecurities',
    value: function fillUpSecurities() {
      var _this5 = this;

      (0, _mapKeys3.default)(this.newPortfolio.securities, function (securitie, index) {
        return securitie.quantity = _this5.oldPortfolio.data.securities[parseInt(index)].quantity;
      });
      this.setNewPortfolioData();
    }
  }, {
    key: 'cancelDisposingSecuritiesAccount',
    value: function cancelDisposingSecuritiesAccount() {
      var oldPortfolio = this.appCache.get('oldPortfolio');
      oldPortfolio.disposeSecuritiesAccount = false;
      this.appCache.set('oldPortfolio', oldPortfolio);
    }
  }, {
    key: 'setNewPortfolioData',
    value: function setNewPortfolioData() {
      this.appCache.set('newPortfolio', this.newPortfolio);
    }
  }, {
    key: 'setOldPortfolioData',
    value: function setOldPortfolioData() {
      this.appCache.set('oldPortfolio', this.oldPortfolio);
    }
  }, {
    key: 'hasDataToTransfer',
    value: function hasDataToTransfer() {
      if (!this.newPortfolio || !this.newPortfolio.funds && !this.newPortfolio.securities) {
        return false;
      }

      return this.hasSecurities || this.hasFunds;
    }
  }, {
    key: 'informMissingTransferOfPositions',
    value: function informMissingTransferOfPositions() {
      this.$scope.confirmTitle = 'app.newPortfolioState.confirm.title';
      this.$scope.confirmBody = 'app.newPortfolioState.confirm.missing.positions.body';
      this.$scope.confirmOk = 'app.confirmation.ok';
      this.$scope.showDismissBtn = false;

      this.uiModalDeclarationService.openUrl({
        url: 'app/common/ui/modals/confirmation.tpl.html',
        options: {
          scope: this.$scope,
          modalClass: 'confirmation-modal'
        }
      });
    }
  }, {
    key: 'addSecurities',
    value: function addSecurities() {
      var _this6 = this;

      this.addSecuritiesService.open().then(function (result) {
        _this6.oldPortfolio.data.securities.push(result);
        _this6.newPortfolio.securities.push(angular.copy(result));
        _this6.setOldPortfolioData();
        _this6.setNewPortfolioData();
      });
    }
  }, {
    key: 'informRemainingPositionsToTransfer',
    value: function informRemainingPositionsToTransfer() {
      var $scope = this.$scope,
          $q = this.$q;

      $scope.confirmTitle = 'app.newPortfolioState.confirm.title';
      $scope.confirmBody = 'app.newPortfolioState.confirm.remaining.positions.body';
      $scope.showDismissBtn = true;
      $scope.confirmDismiss = 'app.newPortfolioState.confirm.remaining.positions.dismiss';
      $scope.confirmOk = 'app.newPortfolioState.confirm.remaining.positions.confirm';

      var defer = $q.defer();
      this.uiModalDeclarationService.openUrl({
        url: 'app/common/ui/modals/confirmation.tpl.html',
        options: {
          scope: $scope,
          onSuccess: function onSuccess() {
            return defer.resolve();
          },
          onDissmiss: function onDissmiss() {
            return defer.reject();
          },
          modalClass: 'confirmation-modal'
        }
      });
      return defer.promise;
    }
  }]);
  return NewPortfolioController;
}(_controller.BaseController);

/***/ }),

/***/ 1702:
/***/ (function(module, exports) {

module.exports = "<div class=\"container\" ng-if=\"!vm.loading\">\n  <div class=\"content\">\n    <div ng-if=\"vm.guidedTourIsActive\">\n      <header>\n        <h2 class=\"pretitle\" translate=\"app.newPortfolioState.pretitle\"></h2>\n        <h1\n          class=\"title has-pretitle\"\n          translate=\"app.newPortfolioState.title\"\n        ></h1>\n      </header>\n\n      <!-- On guided we need the oldBank from the user since we skipped UBA -->\n      <section class=\"mb-5\">\n        <div class=\"card\">\n          <div class=\"card-header\">\n            <h3\n              class=\"card-title\"\n              translate=\"app.newPortfolioState.headline.oldBank\"\n            ></h3>\n          </div>\n          <div class=\"card-body\">\n            <span\n              translate=\"app.newPortfolioState.guidedTourDescription\"\n            ></span>\n            <form name=\"vm.oldBankForm\" novalidate>\n              <old-bank-input form=\"vm.oldBankForm\" model=\"vm.oldBank\">\n              </old-bank-input>\n            </form>\n          </div>\n        </div>\n      </section>\n    </div>\n\n    <div ng-if=\"!vm.guidedTourIsActive\">\n      <header>\n        <h2\n          class=\"pretitle\"\n          translate=\"app.newPortfolioState{{ vm.transferAllSecurities ? '.transferAll' : '' }}.pretitle\"\n        ></h2>\n        <h1\n          class=\"title has-pretitle\"\n          translate=\"app.newPortfolioState{{ vm.transferAllSecurities ? '.transferAll' : '' }}.title\"\n        ></h1>\n      </header>\n\n      <!-- No entries warning -->\n      <div ng-if=\"vm.hasNoEntries && !vm.transferAllSecurities\" class=\"card\">\n        <div\n          class=\"card-body\"\n          translate=\"app.newPortfolioState.noEntries\"\n        ></div>\n      </div>\n    </div>\n  </div>\n\n  <!-- Stocklist -->\n  <div ng-if=\"!vm.transferAllSecurities\" class=\"content-fluid embedded\">\n    <div class=\"card\">\n      <div class=\"card-header\">\n        <h3\n          ng-if=\"!vm.guidedTourIsActive && vm.hasSecurities\"\n          class=\"card-title\"\n          translate=\"app.newPortfolioState.headline.portfolio\"\n        ></h3>\n        <h3\n          ng-if=\"!vm.guidedTourIsActive && vm.hasFunds\"\n          class=\"card-title\"\n          translate=\"app.newPortfolioState.headline.investmentdepot\"\n        ></h3>\n        <h3\n          ng-if=\"!vm.guidedTourIsActive && vm.hasNoEntries\"\n          class=\"card-title\"\n          translate=\"app.newPortfolioState.headline.guidedTour\"\n        ></h3>\n        <h3\n          ng-if=\"vm.guidedTourIsActive\"\n          class=\"card-title\"\n          translate=\"app.newPortfolioState.headline.guidedTour\"\n        ></h3>\n        <span\n          ng-if=\"vm.showHeadline\"\n          translate=\"app.newPortfolioState.headline\"\n        ></span>\n      </div>\n      <div class=\"card-body\">\n        <div\n          ng-if=\"vm.hasNoEntries\"\n          translate=\"app.newPortfolioState.table.empty\"\n        ></div>\n\n        <!-- Old portfolio stock list data -->\n        <div ng-if=\"vm.oldPortfolio.data\">\n          <!-- Securities stock list -->\n          <div ng-if=\"vm.hasSecurities\">\n            <p\n              ng-if=\"vm.newAccountForPortfolioIsNeeded\"\n              translate=\"app.newPortfolioState.missing.portfolio.account\"\n            ></p>\n            <stock-list\n              ng-form=\"vm.stockListForm\"\n              list=\"vm.oldPortfolio.data.securities\"\n              to-transfer=\"vm.newPortfolio.securities\"\n            >\n            </stock-list>\n          </div>\n\n          <!-- Funds stock list -->\n          <div\n            ng-if=\"vm.hasFunds\"\n            ng-class=\"{'card-body-separator': vm.hasSecurities}\"\n          >\n            <p\n              ng-if=\"vm.newAccountForInvestmentIsNeeded\"\n              translate=\"app.newPortfolioState.missing.investment.account\"\n            ></p>\n            <stock-list\n              list=\"vm.oldPortfolio.data.funds\"\n              to-transfer=\"vm.newPortfolio.funds\"\n            >\n            </stock-list>\n          </div>\n        </div>\n      </div>\n      <div class=\"card-footer\">\n        <!-- Add securities button -->\n        <nav class=\"label-button m-0 mt-3\">\n          <p\n            class=\"label\"\n            translate=\"app.newPortfolioState.addSecuritiesLabel\"\n          ></p>\n          <fd-form-button\n            on-click=\"vm.addSecurities()\"\n            label=\"app.newPortfolioState.addSecurities\"\n            icon=\"fa fa-plus\"\n          >\n          </fd-form-button>\n        </nav>\n      </div>\n    </div>\n\n    <div class=\"card\" ng-if=\"vm.showFragmentsNotification\">\n      <div class=\"card-header\">\n        <h3\n          class=\"card-title\"\n          translate=\"app.newPortfolioState.fragments.hint\"\n        ></h3>\n      </div>\n      <div class=\"card-body\">\n        <sell-fragments\n          portfolio=\"vm.oldPortfolio\"\n          form=\"vm.oldPortfolioForm\"\n          uncheckable=\"true\"\n        >\n        </sell-fragments>\n      </div>\n    </div>\n\n    <div class=\"card-footer\">\n      <p translate=\"app.newPortfolioState.hint\"></p>\n    </div>\n  </div>\n\n  <!-- Buttons -->\n  <div class=\"content\">\n    <nav class=\"buttons\">\n      <fd-form-button on-click=\"vm.prev()\" label=\"button.back\">\n      </fd-form-button>\n      <fd-form-button\n        btn-primary=\"true\"\n        is-disabled=\"!vm.oldPortfolio.data && !vm.isGuidedComplete\"\n        on-click=\"vm.next()\"\n        label=\"button.continue\"\n        class=\"right\"\n      >\n      </fd-form-button>\n    </nav>\n  </div>\n</div>\n\n<loading-overlay loading=\"vm.loading\"></loading-overlay>\n"

/***/ }),

/***/ 1703:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _oldPortfolio = __webpack_require__(1704);

var _oldPortfolio2 = __webpack_require__(646);

_core.app.config(_oldPortfolio.oldPortfolioState);
_core.app.component(_oldPortfolio2.oldPortfolioComponent.name, _oldPortfolio2.oldPortfolioComponent);

/***/ }),

/***/ 1704:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oldPortfolioState = exports.oldPortfolioStateName = undefined;

var _oldPortfolio = __webpack_require__(646);

var _app = __webpack_require__(55);

var oldPortfolioStateName = exports.oldPortfolioStateName = 'app.oldPortfolio';

var oldPortfolioState = exports.oldPortfolioState = ["$stateProvider", function oldPortfolioState($stateProvider) {
  'ngInject';

  $stateProvider.state({
    url: '/oldPortfolio',
    name: oldPortfolioStateName,
    component: _oldPortfolio.oldPortfolioComponent.name,
    resolve: { stateResolver: (0, _app.stateResolver)(oldPortfolioStateName) }
  });
}];

/***/ }),

/***/ 1705:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OldPortfolioController = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _merge2 = __webpack_require__(124);

var _merge3 = _interopRequireDefault(_merge2);

var _isEmpty2 = __webpack_require__(185);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _controller = __webpack_require__(14);

var _oldPortfolio = __webpack_require__(635);

var _oldPortfolio2 = __webpack_require__(645);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OldPortfolioController = exports.OldPortfolioController = function (_BaseController) {
  OldPortfolioController.$inject = ["$scope", "controllerService", "securitiesService", "configService"];
  (0, _inherits3.default)(OldPortfolioController, _BaseController);

  function OldPortfolioController($scope, controllerService, securitiesService, configService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, OldPortfolioController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (OldPortfolioController.__proto__ || (0, _getPrototypeOf2.default)(OldPortfolioController)).call(this, {
      $scope: $scope,
      controllerService: controllerService,
      securitiesService: securitiesService,
      configService: configService
    }));

    _this.oldPortfolioForm = {};
    return _this;
  }

  (0, _createClass3.default)(OldPortfolioController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      // Set cached or initial models
      var oldPortfolioCached = this.appCache.get('oldPortfolio') || {};
      this.oldPortfolio = new _oldPortfolio2.OldPortfolioModel(oldPortfolioCached);

      this.transferAllSecurities = this.appCache.get('transferAllSecurities') || false;

      // dont precheck when cached version is available and user goes backwards
      // otherwise all checks get corrupted
      if ((0, _isEmpty3.default)(oldPortfolioCached)) {
        this.oldPortfolio.precheckAllOptions(this.transferAllSecurities);
      }

      // Setup options
      this.oldPortfolioOptions = _oldPortfolio.OldPortfolioOptions.map(function (option) {
        return (0, _merge3.default)(option, {
          type: 'checkbox',
          iconPath: _this2.iconPath,
          isDisabled: _this2.isToggleOptionDisabled(option)
        });
      });

      this.disposeSecuritiesAccountOption = {
        type: 'checkbox',
        infoTextKey: 'app.oldPortfolioState.disposeSecuritiesAccount.info',
        label: 'app.oldPortfolioState.disposeSecuritiesAccount',
        name: 'app.oldPortfolioState.disposeSecuritiesAccount',
        model: 'disposeSecuritiesAccount',
        checked: this.oldPortfolio.disposeSecuritiesAccount
      };

      this.setModelBindings();
    }
  }, {
    key: 'isToggleOptionDisabled',
    value: function isToggleOptionDisabled(option) {
      return option.model == 'transferCapitalLoss' && !this.transferAllSecurities;
    }
  }, {
    key: 'setModelBindings',
    value: function setModelBindings() {
      var _this3 = this;

      this.$scope.$watch('vm.oldPortfolio.disposeSecuritiesAccount', function (newValue) {
        if (!_this3.watchModelBindings) return;
        _this3.oldPortfolio.precheckAllOptions(newValue);
      });

      // Prevent initial watch trigger
      this.$timeout(function () {
        return _this3.watchModelBindings = true;
      });
    }
  }, {
    key: 'prev',
    value: function prev() {
      this.updateCache();
      this.prevState();
    }
  }, {
    key: 'next',
    value: function next() {
      // in this case the switch can not be performed
      if (this.FeatureUSWithholdingTaxCheck && !this.USWithholdingTax) {
        this.appCache.set('USWithholdingTax', true);
        return this.go('app.switchNotAllowed');
      }

      // in this case the switch can not be performed
      if (this.FeatureForeignResidenceCheck && !this.foreignResidence) {
        this.appCache.set('foreignResidence', true);
        return this.go('app.switchNotAllowed');
      }

      // TODO: Warning! Backend does not ignore bank account properties even though sell fragments is not checked!
      if (!this.oldPortfolio.sellFragments) {
        this.resetBankProperties();
      }

      this.updateCache();

      this.oldPortfolioForm.$submitted = true;
      if (!this.oldPortfolioForm.$valid) {
        return;
      }

      this.nextState();
    }
  }, {
    key: 'updateCache',
    value: function updateCache() {
      this.appCache.set('oldPortfolio', this.oldPortfolio);

      // Set old bank only if it is defined
      if (this.oldBank) {
        this.appCache.set('oldBank', this.oldBank);
      }
    }
  }, {
    key: 'resetBankProperties',
    value: function resetBankProperties() {
      this.oldPortfolio.fragmentsProceedsDestinationIban = null;
      this.oldPortfolio.fragmentsProceedsDestinationBic = null;
      this.oldPortfolio.fragmentsProceedsDestinationBankName = null;
      this.oldPortfolio.fragmentsProceedsDestinationAccountOwner = null;
    }
  }, {
    key: 'guidedTourIsActive',
    get: function get() {
      return this.appCache.get('guidedTourIsActive');
    }
  }, {
    key: 'iconPath',
    get: function get() {
      return this.configService.getFeature(this.Features.infoIconPath);
    }
  }, {
    key: 'FeatureUSWithholdingTaxCheck',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.USWithholdingTaxCheck);
    }
  }, {
    key: 'FeatureForeignResidenceCheck',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.foreignResidenceCheck);
    }
  }, {
    key: 'proceedsOnClearingAccountEnabled',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.proceedsOnClearingAccount);
    }
  }]);
  return OldPortfolioController;
}(_controller.BaseController);

/***/ }),

/***/ 1706:
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n  <div class=\"content\">\n    <form name=\"vm.oldPortfolioForm\" novalidate>\n      <h2 class=\"pretitle\" translate=\"app.oldPortfolioState.pretitle\"></h2>\n      <h1\n        translate=\"app.oldPortfolioState.title\"\n        class=\"title has-pretitle\"\n        ng-class=\"{'lower-margin-top': vm.loading}\"\n      ></h1>\n      <div class=\"card\">\n        <div class=\"card-body\">\n          <toggle-control\n            model=\"vm.oldPortfolio.disposeSecuritiesAccount\"\n            label=\"app.oldPortfolioState.disposeSecuritiesAccount\"\n            info-text-key=\"app.oldPortfolioState.disposeSecuritiesAccount.info\"\n            control-id=\"dispose-securities-account\"\n            label-values=\"{'disposeSecuritiesAccount': vm.oldPortfolio.disposeSecuritiesAccount}\"\n          ></toggle-control>\n        </div>\n      </div>\n\n      <div ng-if=\"!vm.oldPortfolio[vm.disposeSecuritiesAccountOption.model]\">\n        <div class=\"card\" ng-repeat=\"option in vm.oldPortfolioOptions\">\n          <div class=\"card-body\">\n            <toggle-control\n              label=\"{{ option.label }}\"\n              info-text-key=\"{{ option.infoTextKey }}\"\n              is-disabled=\"option.isDisabled\"\n              control-id=\"{{ option.name }}\"\n              model=\"vm.oldPortfolio[option.model]\"\n              form=\"vm.oldPortfolioForm\"\n            ></toggle-control>\n          </div>\n        </div>\n        <sell-fragments\n          portfolio=\"vm.oldPortfolio\"\n          form=\"vm.oldPortfolioForm\"\n          as-card=\"true\"\n        >\n        </sell-fragments>\n      </div>\n      <div class=\"card\">\n        <div class=\"card-body\">\n          <toggle-control\n            model=\"vm.oldPortfolio.disposeExemptionOrder\"\n            label=\"app.oldPortfolioState.disposeExemptionOrder\"\n            control-id=\"disposeExemptionOrder\"\n            info-text-key=\"app.oldPortfolioState.disposeExemptionOrder.info\"\n          ></toggle-control>\n        </div>\n      </div>\n      <div class=\"card\" ng-if=\"vm.FeatureForeignResidenceCheck\">\n        <div class=\"card-body\">\n          <toggle-control\n            model=\"vm.foreignResidence\"\n            label=\"app.oldPortfolioState.foreignResidence\"\n            control-id=\"foreignResidence\"\n            info-text-key=\"app.oldPortfolioState.foreignResidence.info\"\n          ></toggle-control>\n        </div>\n      </div>\n\n      <div class=\"card\" ng-if=\"vm.FeatureUSWithholdingTaxCheck\">\n        <div class=\"card-body\">\n          <toggle-control\n            model=\"vm.USWithholdingTax\"\n            control-id=\"USWithholdingTax\"\n            label=\"app.oldPortfolioState.USWithholdingTax\"\n            info-text-key=\"app.oldPortfolioState.USWithholdingTax.info\"\n          ></toggle-control>\n        </div>\n      </div>\n\n      <nav class=\"buttons\">\n        <fd-form-button on-click=\"vm.prev()\" label=\"button.back\">\n        </fd-form-button>\n        <fd-form-button\n          btn-primary=\"true\"\n          on-click=\"vm.next()\"\n          is-busy=\"vm.loading\"\n          label=\"button.continue\"\n          class=\"right\"\n        >\n        </fd-form-button>\n      </nav>\n    </form>\n  </div>\n</div>\n"

/***/ }),

/***/ 1707:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _accountTransfer = __webpack_require__(1708);

var _order = __webpack_require__(1710);

var _overview = __webpack_require__(647);

var _overview2 = __webpack_require__(1729);

var _overview3 = __webpack_require__(1730);

__webpack_require__(1731);

__webpack_require__(1732);

__webpack_require__(1733);

__webpack_require__(1736);

_core.app.config(_overview3.overviewState);
_core.app.component(_overview.overviewComponent.name, _overview.overviewComponent);
_core.app.component(_accountTransfer.accountTransferComponent.name, _accountTransfer.accountTransferComponent);
_core.app.service('overviewService', _overview2.OverviewService);
_core.app.service('orderService', _order.OrderService);

/***/ }),

/***/ 1708:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountTransferComponent = undefined;

var _accountTransfer = __webpack_require__(1709);

var _accountTransfer2 = _interopRequireDefault(_accountTransfer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var accountTransferComponent = exports.accountTransferComponent = {
  name: 'accountTransfer',
  restrict: 'E',
  template: _accountTransfer2.default,
  controllerAs: 'vm',
  bindings: {
    oldBank: '<',
    newBank: '<'
  }
};

/***/ }),

/***/ 1709:
/***/ (function(module, exports) {

module.exports = "<div class=\"account-transfer\">\n  <div tabindex=\"0\" class=\"account-container\">\n    <h4 ng-if=\"vm.oldBank.shortName\" class=\"m-0\">{{ vm.oldBank.shortName }}</h4>\n    <dl class=\"m-0\">\n      <dt ng-if=\"vm.oldBank.bankCode\" translate>app.overviewState.bankCode</dt>\n      <dd ng-if=\"vm.oldBank.bankCode\">{{ vm.oldBank.bankCode }}</dd>\n      <dt ng-if=\"vm.oldBank.oldAccountNumber\" translate>\n        app.overviewState.oldAccountId\n      </dt>\n      <dd ng-if=\"vm.oldBank.oldAccountNumber\">\n        {{ vm.oldBank.oldAccountNumber }}\n      </dd>\n    </dl>\n  </div>\n\n  <div class=\"is-divider\">\n    <i class=\"fa fa-chevron-down divider-content mt-1\"></i>\n  </div>\n\n  <div tabindex=\"0\" class=\"account-container\">\n    <h4 ng-if=\"vm.newBank.shortName\" class=\"m-0\">{{ vm.newBank.shortName }}</h4>\n    <dl class=\"m-0\">\n      <dt ng-if=\"vm.newBank.blz\" translate>app.overviewState.bankCode</dt>\n      <dd ng-if=\"vm.newBank.blz\">{{ vm.newBank.blz }}</dd>\n      <dt ng-if=\"vm.newBank.newAccountNumber\" translate>\n        app.overviewState.newAccountId\n      </dt>\n      <dd ng-if=\"vm.newBank.newAccountNumber\">\n        {{ vm.newBank.newAccountNumber }}\n      </dd>\n      <dt ng-if=\"vm.newBank.investmentId\" translate>\n        app.overviewState.investmentId\n      </dt>\n      <dd>{{ vm.newBank.investmentId }}</dd>\n      <dt ng-if=\"vm.newBank.portfolioId\" translate>\n        app.overviewState.portfolioId\n      </dt>\n      <dd>{{ vm.newBank.portfolioId }}</dd>\n    </dl>\n  </div>\n</div>\n"

/***/ }),

/***/ 1710:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderService = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defaults2 = __webpack_require__(183);

var _defaults3 = _interopRequireDefault(_defaults2);

var _omit2 = __webpack_require__(282);

var _omit3 = _interopRequireDefault(_omit2);

var _libInjection = __webpack_require__(10);

var _order = __webpack_require__(1711);

var _newPortfolio = __webpack_require__(306);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderService = exports.OrderService = function (_InjectableClass) {
  (0, _inherits3.default)(OrderService, _InjectableClass);

  function OrderService() {
    'ngInject';

    (0, _classCallCheck3.default)(this, OrderService);
    return (0, _possibleConstructorReturn3.default)(this, (OrderService.__proto__ || (0, _getPrototypeOf2.default)(OrderService)).call(this));
  }

  (0, _createClass3.default)(OrderService, [{
    key: 'createOrder',
    value: function createOrder(data) {
      // pick all but `data` options from the oldPortfolio model
      var options = (0, _omit3.default)(data.oldPortfolio, 'data');

      // Create order model with default values
      var order = this.createOrderWithDefaults(data.oldBank, data.newBank, options);

      this.mapCustomers(order, data.oldOwners, data.newOwners);

      // Set new portfolio values
      order.toTransfer = new _newPortfolio.NewPortfolioModel(data.newPortfolio);
      order.toTransfer.type = data.transfer.type;
      order.toTransfer.transferAllSecurities = options.transferAllSecurities;

      // Set revocation value
      order.options.waiveRightOfRevocation = data.overview.abdicationCancellationRight;

      // Set order deadline date
      order.options.deadline = data.overview.deadline;

      // only adds signature, if signature is committed
      this.addSignatureImages(order);

      return order;
    }
  }, {
    key: 'createOrderWithDefaults',
    value: function createOrderWithDefaults(oldBank, newBank, options) {
      var _ref = oldBank || {},
          legacyBankIdentifier = _ref.legacyBankIdentifier,
          oldAccountNumber = _ref.oldAccountNumber;

      var _ref2 = newBank || {},
          portfolioId = _ref2.portfolioId,
          investmentId = _ref2.investmentId,
          blz = _ref2.blz;

      return new _order.OrderModel({
        bankData: {
          legacyBankIdentifier: this.sanitizeValue(legacyBankIdentifier),
          oldAccountNumber: this.sanitizeValue(oldAccountNumber),
          portfolioId: this.sanitizeValue(portfolioId),
          investmentId: this.sanitizeValue(investmentId),
          newBlz: this.sanitizeValue(blz)
        },
        options: (0, _defaults3.default)(options, {
          transferAllSecurities: true,
          transferCapitalLoss: false,
          transferCapitalLossFromShares: false,
          transferCapitalLossFromForeignTaxes: false,
          disposeExemptionOrder: false,
          disposeSecuritiesAccount: false,
          disposeSavingsPlan: false,
          sellFragments: false
        })
      });
    }
  }, {
    key: 'mapCustomers',
    value: function mapCustomers(order, oldOwners, newOwners) {
      order.oldOwners = oldOwners.map(this.mapCustomerSalutation);
      order.newOwners = newOwners.map(this.mapCustomerSalutation);
      return order;
    }
  }, {
    key: 'mapCustomerSalutation',
    value: function mapCustomerSalutation(customer) {
      var fixedCustomer = {};
      for (var key in customer) {
        fixedCustomer[key] = customer[key];
      }

      // fixedCustomer.salutation = customer.salutation.value;
      // fixedCustomer.title = customer.title ? customer.title.value : '';
      return fixedCustomer;
    }
  }, {
    key: 'addSignatureImages',
    value: function addSignatureImages(order) {
      if (order.oldOwners[0].firstName) {
        order.oldOwners.forEach(function (customer) {
          if (!customer.signature || !customer.signature.dataUrl) {
            return;
          }
          customer.signature = customer.signature.dataUrl;
        });
      } else {
        order.newOwners.forEach(function (customer) {
          if (!customer.signature || !customer.signature.dataUrl) {
            return;
          }
          customer.signature = customer.signature.dataUrl;
        });
      }
      return order;
    }
  }, {
    key: 'sanitizeValue',
    value: function sanitizeValue(value) {
      // Remove whitespace from given string value
      return ('' + value).replace(/\s/g, '');
    }
  }]);
  return OrderService;
}(_libInjection.InjectableClass);

/***/ }),

/***/ 1711:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderModel = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _model = __webpack_require__(71);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderModel = exports.OrderModel = function (_BaseModel) {
  (0, _inherits3.default)(OrderModel, _BaseModel);

  function OrderModel(data) {
    (0, _classCallCheck3.default)(this, OrderModel);
    return (0, _possibleConstructorReturn3.default)(this, (OrderModel.__proto__ || (0, _getPrototypeOf2.default)(OrderModel)).call(this, data, {
      oldOwners: null,
      newOwners: null,
      toTransfer: {
        funds: null,
        securities: null,
        type: null
      },
      bankData: {
        legacyBankIdentifier: null,
        oldAccountNumber: null,
        portfolioId: null,
        investmentId: null,
        newBlz: null
      },
      options: {
        deadline: null,
        disposeSecuritiesAccount: null,
        transferCapitalLoss: null,
        transferCapitalLossFromShares: null,
        transferCapitalLossFromForeignTaxes: null,
        disposeExemptionOrder: null,
        disposeSavingsPlan: null,
        sellFragments: null,
        fragmentsProceedsDestinationBankName: null,
        fragmentsProceedsDestinationAccount: null
      }
    }));
  }

  return OrderModel;
}(_model.BaseModel);

/***/ }),

/***/ 1712:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverviewController = undefined;

var _keys = __webpack_require__(70);

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__(1713);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _find2 = __webpack_require__(288);

var _find3 = _interopRequireDefault(_find2);

var _controller = __webpack_require__(14);

var _feedback = __webpack_require__(305);

var _finish = __webpack_require__(641);

var _status = __webpack_require__(307);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OverviewController = exports.OverviewController = function (_BaseController) {
  OverviewController.$inject = ["$q", "$scope", "configService", "controllerService", "feedbackService", "orderService", "overviewService", "uiModalDeclarationService"];
  (0, _inherits3.default)(OverviewController, _BaseController);

  function OverviewController($q, $scope, configService, controllerService, feedbackService, orderService, overviewService, uiModalDeclarationService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, OverviewController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (OverviewController.__proto__ || (0, _getPrototypeOf2.default)(OverviewController)).call(this, {
      $q: $q,
      $scope: $scope,
      configService: configService,
      controllerService: controllerService,
      feedbackService: feedbackService,
      orderService: orderService,
      overviewService: overviewService,
      uiModalDeclarationService: uiModalDeclarationService
    }));

    _this.feedback = new _feedback.FeedbackModel();


    _this.dateOptions = { minDate: new Date() };
    _this.setLanguageOptions().then(function () {
      _this.dateOptions.dateFormat = _this.languageOptions.mediumDate;
    });
    return _this;
  }

  (0, _createClass3.default)(OverviewController, [{
    key: '$onInit',
    value: function $onInit() {
      // eslint-disable-next-line angular/window-service
      window.scrollTo(0, 0);

      // dont show mobile sign option when already be on a mobile device
      this.mobileSignUrl = this.isMobileDevice ? '' : this.overviewService.getSignUrl();
      this.signatureServiceUrl = this.overviewService.getSignatureUrl();
      this.appName = 'DW Service';

      this.oldPortfolio = this.appCache.get('oldPortfolio');
      this.newPortfolio = this.appCache.get('newPortfolio');
      this.oldOwners = this.appCache.get('oldOwners');
      this.newOwners = this.appCache.get('newOwners');
      this.oldBank = this.appCache.get('oldBank');
      this.newBank = this.appCache.get('newBank');
      this.transfer = this.appCache.get('transfer');
      this.model = {
        deadline: this.appCache.get('deadline')
      };

      this.appCache.remove('abdicationCancellationRight');

      this.setupLayout();

      if (this.showSignaturePad) {
        this.setSignatureValidators();
      }
    }
  }, {
    key: 'setupLayout',
    value: function setupLayout() {
      this.columnsClass = { 'is-multiline': !this.isOwnAccount };
      this.columnClass = { 'is-6': !this.isOwnAccount };
      this.columnClassOwner = {
        'is-6': !this.isOwnAccount,
        'is-12': this.isOwnAccount
      };
    }
  }, {
    key: 'prev',
    value: function prev() {
      this.prevState();
    }
  }, {
    key: 'submit',
    value: function submit() {
      var _this2 = this;

      if (this.oldPortfolio.data) {
        delete this.oldPortfolio.data;
      }

      if (this.showSignaturePad) {
        // Check for missing signature
        var hasMissingSignatures = false;
        for (var customer in this.ownerData) {
          if (this.signatureIsMissing(this.ownerData[customer])) {
            this.missingSignatures[customer] = hasMissingSignatures = true;
          }
        }
        if (hasMissingSignatures) {
          return;
        }
      }

      this.appCache.set('abdicationCancellationRight', this.model.abdicationCancellationRight || true);

      // Check signature
      if (!this.showSignaturePad) {
        this.trySendOrder();
        return;
      }

      // Check abdication cancellation right (reject right of withdrawal)
      var abdicationCancellationRight = this.abdicationCancellationRight;

      if (abdicationCancellationRight || this.model.abdicationCancellationRight) {
        this.trySendOrder();
        return;
      }

      // Confirm for missing abdication cancellation right
      if (!this.model.abdicationCancellationRight) {
        // Confirm for missing abdication cancellation right
        this.confirmMissingAbdicationCancellationRight().then(function () {
          _this2.trySendOrder();
        });
        return;
      }
    }
  }, {
    key: 'trySendOrder',
    value: function trySendOrder() {
      var data = {
        oldBank: this.oldBank,
        newBank: this.newBank,
        oldPortfolio: this.oldPortfolio,
        newPortfolio: this.newPortfolio,
        oldOwners: this.oldOwners,
        newOwners: this.newOwners,
        transfer: this.transfer,
        overview: this.model
      };

      var order = this.orderService.createOrder(data);

      this.postOrder(order);
    }
  }, {
    key: 'postOrder',
    value: function postOrder(order) {
      var _this3 = this;

      this.orderError = null;

      // Track event for posting order
      this.trackingService.trackEvent('order-init', {
        category: 'overview',
        label: 'request',
        tenant: this.tenant
      });

      return this.overviewService.postOrder(order).busy(this, 'isBusy').then(function (data) {
        return _this3.postOrderDone(data);
      }, function (error) {
        return _this3.postOrderError(error);
      });
    }
  }, {
    key: 'postOrderDone',
    value: function postOrderDone(data) {
      var _this4 = this;

      // Store config to reset before clearing cache
      var config = this.appCache.get('config');
      var abdicationCancellationRight = this.appCache.get('abdicationCancellationRight');

      var orderId = data.orderId,
          documentId = data.documentId,
          investmentApplicationRedirect = data.investmentApplicationRedirect,
          portfolioApplicationRedirect = data.portfolioApplicationRedirect;

      // get the birthday of the user where the status link is send to via email

      var maybeUserWithStatusEmail = (0, _find3.default)([].concat((0, _toConsumableArray3.default)(this.newOwners), (0, _toConsumableArray3.default)(this.oldOwners)), function (o) {
        return o.email;
      });

      // when userEmail feature is disabled there is no user
      var birthday = null;
      if (maybeUserWithStatusEmail) {
        birthday = maybeUserWithStatusEmail.birthday;
      }

      // Track event for successfully posted order
      this.trackingService.trackEvent('order-success', {
        category: 'overview',
        label: 'request',
        tenant: this.tenant
      });

      this.prepareCache({
        config: config,
        orderId: orderId,
        documentId: documentId,
        birthday: birthday,
        abdicationCancellationRight: abdicationCancellationRight,
        investmentApplicationRedirect: investmentApplicationRedirect,
        portfolioApplicationRedirect: portfolioApplicationRedirect
      });

      if (this.hasStatusPage) {
        if (this.hasFeedbackModal) {
          return this.askForFeedback().finally(function () {
            // When feedback has not been submitted, track event for skipped feedback
            var feedback = _this4.appCache.get('feedback');
            if (feedback) {
              _this4.feedbackService.trackFeedback(feedback, true);
            }
            _this4.go(_status.statusStateName, { orderId: orderId });
          });
        }
        return this.go(_status.statusStateName, { orderId: orderId });
      }
      return this.go(_finish.finishStateName);
    }
  }, {
    key: 'postOrderError',
    value: function postOrderError(error) {
      this.$log.error(error);

      var data = error.data,
          status = error.status,
          statusText = error.statusText;

      this.orderError = { data: data, status: status, statusText: statusText };

      // Track event for failed posted order
      this.trackingService.trackEvent('order-error', {
        category: 'overview',
        label: 'request',
        value: error.message,
        tenant: this.tenant
      });
    }
  }, {
    key: 'prepareCache',
    value: function prepareCache(cacheValues) {
      var _this5 = this;

      // Clear complete process cache before setting finish values
      this.appCache.clear();

      (0, _keys2.default)(cacheValues).forEach(function (key) {
        if (cacheValues[key]) {
          _this5.appCache.set(key, cacheValues[key]);
        }
      });
    }
  }, {
    key: 'askForFeedback',
    value: function askForFeedback() {
      this.appCache.set('feedback', null);

      var defer = this.$q.defer();

      this.uiModalDeclarationService.openUrl({
        url: 'app/common/ui/modals/feedback.tpl.html',
        options: {
          scope: this.$scope,
          modalClass: 'feedback-modal',
          onSuccess: function onSuccess() {
            return defer.resolve();
          },
          onDissmiss: function onDissmiss() {
            return defer.reject();
          }
        }
      });

      return defer.promise;
    }
  }, {
    key: 'confirmMissingAbdicationCancellationRight',
    value: function confirmMissingAbdicationCancellationRight() {
      var $q = this.$q,
          $scope = this.$scope;


      $scope.confirmTitle = 'app.overviewState.abdicationCancellationRight.confirm.title';
      $scope.confirmBody = 'app.overviewState.abdicationCancellationRight.confirm.body';
      $scope.confirmDismiss = 'app.overviewState.abdicationCancellationRight.confirm.dismiss';
      $scope.confirmOk = 'app.overviewState.abdicationCancellationRight.confirm.ok';
      $scope.showAbdicationCancellationRight = true;

      var defer = $q.defer();
      this.uiModalDeclarationService.openUrl({
        url: 'app/common/ui/modals/confirmation.tpl.html',
        options: {
          scope: $scope,
          onSuccess: function onSuccess() {
            return defer.resolve();
          },
          onDissmiss: function onDissmiss() {
            return defer.reject();
          },
          modalClass: 'confirmation-modal'
        }
      });
      return defer.promise;
    }
  }, {
    key: 'signatureIsMissing',
    value: function signatureIsMissing(customer) {
      return !customer.signature || customer.signature.dataUrl === 'data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=';
    }
  }, {
    key: 'setSignatureValidators',
    value: function setSignatureValidators() {
      var _this6 = this;

      // manage visibility of missing signature messages
      this.missingSignatures = {};

      var _loop = function _loop(user) {
        _this6.ownerData[user].signature = null;
        _this6.missingSignatures[user] = false;

        // this is to toggle missing signature message, if signature was made.
        _this6.$scope.$watch('vm.' + (_this6.oldOwners.length >= 1 && _this6.oldOwners[0].firstName ? 'oldOwners' : 'newOwners') + '[' + user + '].signature', function (newVal, oldVal) {
          if (oldVal) {
            _this6.missingSignatures[user] = _this6.signatureIsMissing({
              signature: newVal
            });
          }
        });
      };

      for (var user in this.ownerData) {
        _loop(user);
      }
    }
  }, {
    key: 'showDeadline',
    get: function get() {
      return this.isPSD;
    }
  }, {
    key: 'showSignaturePad',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.showSignaturePad);
    }
  }, {
    key: 'hasStatusPage',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.hasStatusPage);
    }
  }, {
    key: 'hasFeedbackModal',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.hasFeedbackModal);
    }
  }, {
    key: 'abdicationCancellationRight',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.abdicationCancellationRight);
    }
  }, {
    key: 'isOwnAccount',
    get: function get() {
      return this.transfer.type === 'ownAccount';
    }
  }, {
    key: 'ownerData',
    get: function get() {
      // use oldOwners if there is data into - quick check
      return this.oldOwners.length >= 1 && this.oldOwners[0].firstName ? this.oldOwners : this.newOwners;
    }
  }, {
    key: 'hasMultipleOwners',
    get: function get() {
      return this.ownerData.length > 1;
    }
  }, {
    key: 'oldAccountOwnerTitle',
    get: function get() {
      return this.isOwnAccount ? 'app.overviewState.securityAccountOwner' : 'app.overviewState.securityAccountOldOwner' + (this.oldOwners.length > 1 ? 's' : '');
    }
  }, {
    key: 'newAccountOwnerTitle',
    get: function get() {
      return this.isOwnAccount ? 'app.overviewState.securityAccountOwner' : 'app.overviewState.securityAccountNewOwner' + (this.newOwners.length > 1 ? 's' : '');
    }
  }, {
    key: 'transferAllSecurities',
    get: function get() {
      var oldPortfolio = this.appCache.get('oldPortfolio');
      return oldPortfolio && oldPortfolio.transferAllSecurities;
    }
  }, {
    key: 'isPSD',
    get: function get() {
      return this.tenant.indexOf('psd') >= 0;
    }
  }, {
    key: 'isCommerzbank',
    get: function get() {
      return this.tenant.indexOf('commerzbank') >= 0;
    }
  }, {
    key: 'tenant',
    get: function get() {
      return this.envService.getTenant();
    }
  }, {
    key: 'theme',
    get: function get() {
      var _configService$config = this.configService.config,
          logo = _configService$config.logo,
          primaryColor = _configService$config.primaryColor;

      return encodeURIComponent(angular.toJson({
        primaryColor: primaryColor,
        logo: logo
      }));
    }
  }]);
  return OverviewController;
}(_controller.BaseController);

/***/ }),

/***/ 1721:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusController = undefined;

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

var _verify = __webpack_require__(649);

var _status = __webpack_require__(1726);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusController = exports.StatusController = function (_BaseController) {
  StatusController.$inject = ["$location", "configService", "controllerService", "errorTrackingService", "statusService"];
  (0, _inherits3.default)(StatusController, _BaseController);

  function StatusController($location, configService, controllerService, errorTrackingService, statusService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, StatusController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (StatusController.__proto__ || (0, _getPrototypeOf2.default)(StatusController)).call(this, {
      $location: $location,
      configService: configService,
      controllerService: controllerService,
      errorTrackingService: errorTrackingService,
      statusService: statusService
    }));

    _this.dateFormat = 'dd.MM.yyyy';
    _this.deadlineLimit = 21;
    _this.progressbarStates = _status.PROGRESS_STATES;
    _this.progressState = 'app.status.started';
    _this.showConfirmationButton = false;
    return _this;
  }

  (0, _createClass3.default)(StatusController, [{
    key: '$onInit',
    value: function $onInit() {
      this.setupValidation();
      this.loadStatus();
    }
  }, {
    key: 'downloadPackage',
    value: function downloadPackage() {
      this.$window.open(this.documentLink, '_blank');
    }
  }, {
    key: 'determineProgressState',
    value: function determineProgressState() {
      if (this.documentId) {
        this.progressState = 'app.status.transmitted';
      }

      if (this.submissionTimestamp) {
        this.progressbarStates[0].translateParams = {
          submissionTimestamp: (0, _moment2.default)(this.submissionTimestamp).format('DD.MM.yyyy')
        };
      }

      if (this.shipmentStatus.shipmentDone) {
        this.progressState = 'app.status.shipped';
        this.progressbarStates[2].stepTitleKey = 'app.status.shipped';
        this.progressbarStates[2].translateParams = {
          shipmentTimestamp: (0, _moment2.default)(this.shipmentStatus.shipmentTimestamp).format('DD.MM.yyyy')
        };
      }
    }
  }, {
    key: 'setupValidation',
    value: function setupValidation() {
      var params = this.$location.search();

      // Read the orderId from the URL
      if (params.id) {
        this.orderId = params.id;
      }

      // Read the token from the URL and format it as a date
      if (params.token) {
        this.birthday = _moment2.default.unix(params.token).format('DD.MM.yyyy');
      }

      if (params.birthday) {
        this.birthday = params.birthday;
      }

      var birthday = this.appCache.get('birthday');
      if (birthday) {
        this.appCache.remove('birthday');
        this.birthday = (0, _moment2.default)(birthday).format('DD.MM.yyyy');
      }
    }
  }, {
    key: 'loadStatus',
    value: function loadStatus() {
      var _this2 = this;

      var inBackground = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.loading = !inBackground;

      this.statusService.getStatus(this.orderId, this.birthday).then(function (resp) {
        _this2.oldPortfolio = resp.options;
        _this2.newOwners = resp.owners;
        _this2.oldOwners = resp.previousOwners;
        _this2.documentId = resp.documentId;
        _this2.oldBank = (0, _extends3.default)({}, resp.oldBank, {
          oldAccountNumber: resp.sourceAccount,
          shortName: resp.oldBank && resp.oldBank.name
        });
        _this2.newBank = (0, _extends3.default)({}, resp.newBank, {
          newAccountNumber: resp.destinationAccount,
          shortName: _this2.tenantName
        });
        _this2.submissionTimestamp = resp.submissionTimestamp;

        _this2.shipmentStatus = {
          shipmentFailed: resp.shipmentFailed,
          shipmentDone: resp.shipmentDone,
          shipmentTimestamp: resp.shipmentTimestamp
        };

        // NOTE: Due to confusion, we are no longer displaying the confirmation button
        // this.showConfirmationButton = resp.showConfirmationButton;

        // we need order id and dates, since we have an asynchronous process in api it is
        // not directly present, show loading spinner and try again a few seconds later
        if (!_this2.minimalInfosPresent()) {
          _this2.$timeout(function () {
            return _this2.loadStatus();
          }, 2000);
          return;
        }

        _this2.loading = false;
        _this2.determineProgressState();

        var deadline = new Date(_this2.oldPortfolio.deadline);
        var today = new Date();

        var remainingDays = _this2.deadlineLimit - Math.round((today - deadline) / (1000 * 60 * 60 * 24));

        _this2.value = remainingDays;

        // Calculate the progress by the percentage of the remaining days of the 21 day period
        _this2.progress = Math.round(remainingDays / _this2.deadlineLimit * 100);
        _this2.timelimitExceeded = remainingDays <= 0;

        // Track event for status page
        _this2.trackingService.trackEvent('status-loaded', {
          category: 'status',
          label: 'request',
          tenant: _this2.tenantName
        });

        // fetch until documents are present
        if (!_this2.documentId) {
          _this2.$timeout(function () {
            return _this2.loadStatus(true);
          }, 4000);
        }
      }, function (error) {
        var status = error.status;

        if (status === 403) {
          _this2.go(_verify.statusVerifyStateName, {
            invalidBirthday: _this2.birthday,
            orderId: _this2.orderId
          });
          return;
        }
        if (status === 404) {
          _this2.$timeout(function () {
            return _this2.loadStatus();
          }, 4000);
        }
      });
    }
  }, {
    key: 'minimalInfosPresent',
    value: function minimalInfosPresent() {
      return this.submissionTimestamp;
    }
  }, {
    key: 'markStatusAsCompleted',
    value: function markStatusAsCompleted() {
      var _this3 = this;

      this.statusCompletionLoading = true;
      this.statusService.markStatusAsCompleted(this.orderId, this.birthday).then(function () {
        _this3.completedDWS = true;
      }).finally(function () {
        _this3.statusCompletionLoading = false;
      });
    }
  }, {
    key: 'orderId',
    set: function set(orderId) {
      this.appCache.set('orderId', orderId);
    },
    get: function get() {
      var params = this.$location.search();
      var orderId = this.$stateParams.orderId;

      return this.appCache.get('orderId') || params.id || orderId;
    }
  }, {
    key: 'documentLink',
    get: function get() {
      return this.statusService.api + '/letters/' + this.documentId;
    }
  }, {
    key: 'hasOldOwner',
    get: function get() {
      return this.oldOwners && this.oldOwners[0].firstName;
    }
  }, {
    key: 'markedAfterDays',
    get: function get() {
      return (0, _moment2.default)().diff((0, _moment2.default)(this.submissionTimestamp), 'days');
    }
  }, {
    key: 'tenantName',
    get: function get() {
      return this.configService.getName();
    }
  }]);
  return StatusController;
}(_controller.BaseController);

/***/ }),

/***/ 1722:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusVerifyController = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

var _statusVerifyModal = __webpack_require__(651);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusVerifyController = exports.StatusVerifyController = function (_BaseController) {
  StatusVerifyController.$inject = ["controllerService", "configService", "$uibModal", "userFormService"];
  (0, _inherits3.default)(StatusVerifyController, _BaseController);

  function StatusVerifyController(controllerService, configService, $uibModal, userFormService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, StatusVerifyController);
    return (0, _possibleConstructorReturn3.default)(this, (StatusVerifyController.__proto__ || (0, _getPrototypeOf2.default)(StatusVerifyController)).call(this, {
      controllerService: controllerService,
      configService: configService,
      $uibModal: $uibModal,
      userFormService: userFormService
    }));
  }

  (0, _createClass3.default)(StatusVerifyController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.dateOptions = {
        dateFormat: 'dd.MM.yyyy',
        showWeeks: false
      };
      this.setLanguageOptions().then(function () {
        _this2.dateOptions.dateFormat = _this2.languageOptions.mediumDate;
      });

      var dates = this.getMinMaxDate();
      this.dateOptions.initDate = new Date(dates.initDate);
      this.dateOptions.maxDate = new Date(dates.minDate);
      this.dateOptions.minDate = new Date(dates.maxDate);

      this.$uibModal.open({
        component: _statusVerifyModal.statusVerifyModalComponent.name,
        size: 'modal-lg',
        windowClass: 'status-verify-modal'
      }).result;

      this.messages = {
        birthday: {
          date: 'app.ownerState.error.birthday',
          dateDisabled: 'app.ownerState.error.birthday.dateDisabled',
          min: 'app.ownerState.error.birthday.minvalue',
          max: 'app.ownerState.error.birthday.maxvalue'
        }
      };
    }
  }]);
  return StatusVerifyController;
}(_controller.BaseController);

/***/ }),

/***/ 1723:
/***/ (function(module, exports) {

module.exports = "<ui-modal class=\"status-verify-modal\">\n  <content>\n    <h2 class=\"ui-modal-header\">\n      <span translate=\"app.status.verify.title\"></span>\n    </h2>\n\n    <div class=\"confirm-body\">\n      <p translate=\"app.status.verify.description\"></p>\n\n      <div\n        ng-if=\"vm.invalidBirthday\"\n        class=\"alert alert-danger\"\n        role=\"alert\"\n        translate=\"app.status.verify.invalidBirthday\"\n        translate-values=\"{'birthday': vm.invalidBirthday}\"\n      ></div>\n\n      <form name=\"vm.form\" ng-submit=\"vm.submit()\">\n        <div class=\"form-control-with-suffix\">\n          <fd-form-control\n            type=\"date\"\n            model=\"vm.birthday\"\n            type-options=\"vm.dateOptions\"\n            name=\"birthday\"\n            required=\"true\"\n            form=\"vm.form\"\n            messages=\"vm.messages\"\n            label=\"app.ownerState.birthday\"\n            options=\"{validate: 'birthday'}\"\n          ></fd-form-control>\n        </div>\n      </form>\n    </div>\n  </content>\n  <actions>\n    <fd-form-button\n      btn-primary=\"true\"\n      btn-type=\"submit\"\n      on-click=\"vm.submit()\"\n      is-disabled=\"vm.isInvalid()\"\n      is-busy=\"vm.isLoading\"\n      label=\"app.status.verify.button\"\n    >\n    </fd-form-button>\n  </actions>\n</ui-modal>\n"

/***/ }),

/***/ 1724:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

var _status = __webpack_require__(307);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusVerifyModalController = function (_BaseController) {
  StatusVerifyModalController.$inject = ["controllerService", "$scope"];
  (0, _inherits3.default)(StatusVerifyModalController, _BaseController);

  function StatusVerifyModalController(controllerService, $scope) {
    'ngInject';

    (0, _classCallCheck3.default)(this, StatusVerifyModalController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (StatusVerifyModalController.__proto__ || (0, _getPrototypeOf2.default)(StatusVerifyModalController)).call(this, {
      controllerService: controllerService,
      $scope: $scope
    }));

    _this.info = {};
    return _this;
  }

  (0, _createClass3.default)(StatusVerifyModalController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.messages = {
        required: 'app.status.verify.birthday.required'
      };

      this.dateOptions = {
        dateFormat: 'dd.MM.yyyy',
        showWeeks: false
      };

      var _$stateParams = this.$stateParams,
          invalidBirthday = _$stateParams.invalidBirthday,
          id = _$stateParams.id,
          orderId = _$stateParams.orderId;

      this.invalidBirthday = invalidBirthday;
      this.orderId = orderId || id;

      this.setLanguageOptions().then(function () {
        _this2.dateOptions.dateFormat = _this2.languageOptions.mediumDate;
      });
    }
  }, {
    key: 'close',
    value: function close() {
      this.modalInstance.close();
    }
  }, {
    key: 'submit',
    value: function submit() {
      this.close();
      this.go(_status.statusStateName, {
        orderId: this.orderId,
        token: (0, _moment2.default)(this.birthday).unix()
      });
    }
  }, {
    key: 'isInvalid',
    value: function isInvalid() {
      return this.form.$invalid;
    }
  }]);
  return StatusVerifyModalController;
}(_controller.BaseController);

exports.default = StatusVerifyModalController;

/***/ }),

/***/ 1725:
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ 1726:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PROGRESS_STATES = exports.PROGRESS_STATES = [{
  stateName: 'app.status.started',
  stepTitleKey: 'app.status.started',
  progressbarIcon: 'fa fa-bank'
}, {
  stateName: 'app.status.transmitted',
  stepTitleKey: 'app.status.transmitted',
  progressbarIcon: 'fa fa-exchange'
}, {
  stateName: 'app.status.shipped',
  stepTitleKey: 'app.status.notShipped',
  progressbarIcon: 'fa fa-paper-plane'
}];

/***/ }),

/***/ 1727:
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n  <status-progress-bar\n    states=\"vm.progressbarStates\"\n    active-state=\"vm.progressState\"\n  ></status-progress-bar>\n\n  <div class=\"content-fluid\">\n    <header>\n      <h2 class=\"pretitle\" translate=\"app.status.pretitle\"></h2>\n      <h1 class=\"title has-pretitle\" translate=\"app.status.title\"></h1>\n    </header>\n\n    <div class=\"card\">\n      <div class=\"card-header\">\n        <h3 class=\"card-title\" translate=\"app.status.progress.title\"></h3>\n      </div>\n      <div class=\"card-body\">\n        <progress-pie value=\"vm.value\" progress=\"vm.progress\"></progress-pie>\n\n        <div\n          ng-if=\"vm.completedDWS\"\n          class=\"complete-info alert alert-info\"\n          role=\"alert\"\n          translate=\"app.status.markStatusAsCompleted.success\"\n        ></div>\n      </div>\n      <div class=\"card-footer\">\n        <nav class=\"label-button m-0 mt-3\">\n          <span\n            ng-if=\"!vm.timelimitExceeded\"\n            translate=\"app.status.progress.info\"\n            class=\"label\"\n          ></span>\n          <span\n            ng-if=\"vm.timelimitExceeded\"\n            translate=\"app.status.progress.timedOut\"\n            class=\"label\"\n          ></span>\n          <fd-form-button\n            ng-if=\"vm.documentId && vm.showConfirmationButton\"\n            class=\"complete-btn is-flex-center\"\n            on-click=\"vm.markStatusAsCompleted()\"\n            is-busy=\"vm.statusCompletionLoading\"\n            label=\"app.status.markStatusAsCompleted\"\n            track-event=\"markedAsCompleted\"\n            track-data=\"{{ {daysAfterSubmission: vm.markedAfterDays} }}\"\n          >\n          </fd-form-button>\n        </nav>\n      </div>\n    </div>\n\n    <div class=\"columns\">\n      <!-- Left Column -->\n      <div class=\"column\">\n        <!-- Old Account Owner -->\n        <div class=\"card\" ng-if=\"vm.hasOldOwner\">\n          <div class=\"card-header\">\n            <h3 class=\"card-title\">\n              {{ (vm.hasOldOwner ? 'app.status.oldOwner' :\n              'app.status.owner.title') + (vm.oldOwners.length > 1 ? 's' : '') |\n              translate }}\n            </h3>\n          </div>\n          <div class=\"card-body\">\n            <div\n              ng-repeat=\"owner in vm.oldOwners\"\n              ng-class=\"{ 'card-body-separator': !$last }\"\n            >\n              <overview-owner owner=\"owner\"></overview-owner>\n            </div>\n          </div>\n        </div>\n\n        <!-- New Account Owner -->\n        <div class=\"card\">\n          <div class=\"card-header\">\n            <h3 class=\"card-title\">\n              {{ (vm.hasOldOwner ? 'app.status.newOwner' :\n              'app.status.owner.title') + (vm.newOwners.length > 1 ? 's' : '') |\n              translate }}\n            </h3>\n          </div>\n          <div class=\"card-body\">\n            <div\n              ng-repeat=\"owner in vm.newOwners\"\n              ng-class=\"{ 'card-body-separator': !$last }\"\n            >\n              <overview-owner owner=\"owner\"></overview-owner>\n            </div>\n          </div>\n        </div>\n\n        <!-- Shipment Status -->\n        <div class=\"card\">\n          <div class=\"card-header\">\n            <h3 class=\"card-title\" translate=\"app.status.shipmentStatus\"></h3>\n          </div>\n          <div class=\"card-body\">\n            <shipment-status\n              old-bank=\"vm.oldBank\"\n              new-bank=\"vm.tenantName\"\n              shipment-status=\"vm.shipmentStatus\"\n            ></shipment-status>\n          </div>\n        </div>\n      </div>\n\n      <!-- Right Column -->\n      <div class=\"column\">\n        <div class=\"card\">\n          <div class=\"card-header\">\n            <h3 class=\"card-title\" translate=\"app.status.switch.title\"></h3>\n          </div>\n          <div class=\"card-body\">\n            <account-transfer\n              old-bank=\"vm.oldBank\"\n              new-bank=\"vm.newBank\"\n            ></account-transfer>\n\n            <div class=\"card-body-separator\"></div>\n\n            <transfer-list\n              ng-if=\"vm.oldPortfolio\"\n              list=\"vm.oldPortfolio\"\n              translate-key=\"overviewState\"\n            ></transfer-list>\n          </div>\n          <div class=\"card-footer\">\n            <div ng-if=\"vm.documentId\" class=\"label-button m-0 mt-3\">\n              <span class=\"label\" translate=\"app.status.switch.download\"></span>\n              <fd-form-button\n                on-click=\"vm.downloadPackage()\"\n                btn-primary=\"true\"\n                label=\"app.status.download\"\n              >\n              </fd-form-button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <loading-overlay loading=\"vm.loading\"></loading-overlay>\n  </div>\n</div>\n"

/***/ }),

/***/ 1728:
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n  <div class=\"content-fluid\">\n    <header>\n      <h2 class=\"pretitle\" translate=\"app.overviewState.pretitle\"></h2>\n      <h1 class=\"title has-pretitle\" translate=\"app.overviewState.title\"></h1>\n    </header>\n\n    <div class=\"columns\" ng-class=\"vm.columnsClass\">\n      <!-- Old Account Owner -->\n      <div class=\"column\" ng-class=\"vm.columnClass\" ng-if=\"!vm.isOwnAccount\">\n        <div class=\"card\">\n          <div class=\"card-header\">\n            <h3 class=\"card-title\">\n              {{ vm.oldAccountOwnerTitle | translate }}\n            </h3>\n          </div>\n          <div class=\"card-body\">\n            <div\n              ng-repeat=\"owner in vm.oldOwners\"\n              ng-class=\"{ 'card-body-separator': !$last }\"\n            >\n              <overview-owner\n                owner=\"owner\"\n                column-class=\"vm.columnClassOwner\"\n              ></overview-owner>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!-- New Account Owner -->\n      <div class=\"column\" ng-class=\"vm.columnClass\">\n        <div class=\"card\">\n          <div class=\"card-header\">\n            <h3 class=\"card-title\">\n              {{ vm.newAccountOwnerTitle | translate }}\n            </h3>\n          </div>\n          <div class=\"card-body\">\n            <div\n              ng-repeat=\"owner in vm.newOwners\"\n              ng-class=\"{ 'card-body-separator': !$last }\"\n            >\n              <overview-owner\n                owner=\"owner\"\n                column-class=\"vm.columnClassOwner\"\n              ></overview-owner>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!-- Accounts -->\n      <div class=\"column\" ng-class=\"vm.columnClass\">\n        <div class=\"card\">\n          <div class=\"card-header\">\n            <h3 class=\"card-title\" translate=\"app.overviewState.accounts\"></h3>\n          </div>\n          <div class=\"card-body\">\n            <account-transfer\n              old-bank=\"vm.oldBank\"\n              new-bank=\"vm.newBank\"\n            ></account-transfer>\n          </div>\n        </div>\n      </div>\n\n      <!-- Switch Options -->\n      <div class=\"column\" ng-class=\"vm.columnClass\">\n        <div class=\"card\">\n          <div class=\"card-header\">\n            <h3 class=\"card-title\">\n              {{'app.overviewState.accountSwitchOptions' | translate}} {{\n              vm.isOwnAccount ? '' : 'app.transferState.type.' +\n              vm.transfer.type + '.label' | translate}}\n            </h3>\n          </div>\n          <div class=\"card-body\">\n            <transfer-list\n              list=\"vm.oldPortfolio\"\n              translate-key=\"overviewState\"\n              collapse=\"false\"\n              columns=\"1\"\n            ></transfer-list>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"card\" ng-if=\"!vm.transferAllSecurities\">\n      <div class=\"card-header\">\n        <h3\n          class=\"card-title\"\n          translate=\"app.overviewState.head.portfolio\"\n        ></h3>\n      </div>\n      <div class=\"card-body\">\n        <positions-table\n          ng-if=\"vm.oldPortfolio.data.securities.length > 0\"\n          old-positions=\"vm.oldPortfolio.data\"\n          transfer=\"vm.newPortfolio\"\n          class=\"positions-table\"\n        ></positions-table>\n      </div>\n    </div>\n\n    <!-- PSD only deadline note -->\n    <div ng-if=\"vm.showDeadline\">\n      <h3 translate=\"app.overviewState.deadline\"></h3>\n      <p>{{ vm.model.deadline | date:vm.dateFormat }}</p>\n    </div>\n\n    <!-- Signature Pad -->\n    <div ng-if=\"vm.showSignaturePad\" class=\"card\">\n      <div class=\"card-header\">\n        <h2 class=\"card-title\" translate=\"app.overviewState.titleSign\"></h2>\n        <p class=\"card-title\" translate=\"app.overviewState.signDescription\"></p>\n      </div>\n      <div class=\"card-body\">\n        <div ng-repeat=\"customer in vm.ownerData\" class=\"mt-5\">\n          <strong ng-if=\"vm.hasMultipleOwners\">\n            <span translate=\"app.overviewState.signOwner\"></span>\n            {{customer.firstName}} {{customer.lastName}}\n          </strong>\n          <signature-pad\n            model=\"customer.signature\"\n            clear-label=\"app.overviewState.signature.clearLabel\"\n            auto-crop=\"true\"\n            skip-check-aspect-ratio=\"true\"\n            service-url=\"{{ vm.signatureServiceUrl }}\"\n            mobile-sign-url=\"{{ vm.mobileSignUrl }}\"\n            theme=\"{{ vm.theme }}\"\n            service-name=\"{{ vm.appName }}\"\n          >\n            <span translate=\"app.overviewState.signature.placeholder\"></span>\n          </signature-pad>\n          <br />\n          <div\n            ng-if=\"vm.missingSignatures[$index]\"\n            class=\"alert alert-danger fade-if\"\n            translate=\"app.overviewState.missingSignatureWarning\"\n          ></div>\n        </div>\n      </div>\n    </div>\n\n    <!-- Check \"abdicationCancellationRight\" -->\n    <div\n      ng-if=\"vm.showSignaturePad && !vm.abdicationCancellationRight\"\n      class=\"card\"\n    >\n      <div class=\"card-body\">\n        <fd-form-control\n          type=\"checkbox\"\n          model=\"vm.model.abdicationCancellationRight\"\n          label=\"app.overviewState.abdicationCancellationRight\"\n        ></fd-form-control>\n      </div>\n    </div>\n\n    <div ng-if=\"vm.orderError\" class=\"alert alert-danger fade-if\">\n      {{ vm.orderError.data }}\n    </div>\n\n    <nav class=\"buttons\">\n      <fd-form-button\n        class=\"back-button\"\n        on-click=\"vm.prev()\"\n        label=\"button.back\"\n      >\n      </fd-form-button>\n      <fd-form-button\n        class=\"submit-button\"\n        btn-primary=\"true\"\n        is-busy=\"vm.isBusy\"\n        on-click=\"vm.submit()\"\n        label=\"button.finishTransfer\"\n      >\n      </fd-form-button>\n    </nav>\n  </div>\n</div>\n"

/***/ }),

/***/ 1729:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverviewService = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ng1Request = __webpack_require__(262);

var _lib = __webpack_require__(303);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OverviewService = exports.OverviewService = function (_CancelableRequest) {
  OverviewService.$inject = ["$http", "$q", "appConfig", "configService"];
  (0, _inherits3.default)(OverviewService, _CancelableRequest);

  function OverviewService($http, $q, appConfig, configService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, OverviewService);
    return (0, _possibleConstructorReturn3.default)(this, (OverviewService.__proto__ || (0, _getPrototypeOf2.default)(OverviewService)).call(this, { $http: $http, $q: $q, appConfig: appConfig, configService: configService }));
  }

  (0, _createClass3.default)(OverviewService, [{
    key: 'getSignUrl',
    value: function getSignUrl() {
      return 'https://sign' + this.environment + '.fino.cloud/';
    }
  }, {
    key: 'getSignatureUrl',
    value: function getSignatureUrl() {
      return 'https://sign' + this.environment + '.fino.cloud/api/v0/';
    }
  }, {
    key: 'postOrder',
    value: function postOrder(data) {
      return this.$http({
        method: 'POST',
        data: data,
        url: this.api + '/orders'
      }).then(_lib.DataResponse.transform('data'));
    }
  }, {
    key: 'api',
    get: function get() {
      return this.appConfig.get().api.path;
    }
  }, {
    key: 'environment',
    get: function get() {
      if (this.configService.isDevelopment()) {
        return '.dev';
      }

      if (this.configService.isTesting()) {
        return '.test';
      }

      return '';
    }
  }]);
  return OverviewService;
}(_ng1Request.CancelableRequest);

/***/ }),

/***/ 1730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overviewState = exports.overviewStateName = undefined;

var _overview = __webpack_require__(647);

var _app = __webpack_require__(55);

var overviewStateName = exports.overviewStateName = 'app.overview';

var overviewState = exports.overviewState = ["$stateProvider", function overviewState($stateProvider) {
  'ngInject';

  $stateProvider.state({
    url: '/overview',
    name: overviewStateName,
    component: _overview.overviewComponent.name,
    resolve: { stateResolver: (0, _app.stateResolver)(overviewStateName) }
  });
}];

/***/ }),

/***/ 1731:
/***/ (function(module, exports) {

var path = 'app/common/ui/modals/confirmation.tpl.html';
var html = "<ui-modal>\n  <content>\n    <h2 class=\"ui-modal-header\">\n      <span>\n        <i class=\"fa fa-info\"></i>\n        <span\n          translate=\"{{ confirmTitle }}\"\n          translate-values=\"confirmTitleValues\"\n        ></span>\n      </span>\n      <a href ng-click=\"$modal.dismiss()\" class=\"modal-close\"\n        ><i class=\"fa fa-close\"></i\n      ></a>\n    </h2>\n    <p\n      class=\"confirm-body\"\n      translate=\"{{ confirmBody }}\"\n      translate-values=\"confirmBodyValues\"\n      translate-interpolate\n    ></p>\n\n    <fd-form-control\n      ng-if=\"showAbdicationCancellationRight\"\n      type=\"checkbox\"\n      model=\"vm.model.abdicationCancellationRight\"\n      label=\"app.overviewState.abdicationCancellationRight\"\n    >\n    </fd-form-control>\n  </content>\n  <actions>\n    <fd-form-button\n      btn-type=\"submit\"\n      btn-primary=\"true\"\n      on-click=\"$modal.close()\"\n      label=\"{{ confirmOk }}\"\n      class=\"right\"\n    >\n    </fd-form-button>\n  </actions>\n</ui-modal>\n";
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 1732:
/***/ (function(module, exports) {

var path = 'app/common/ui/modals/feedback.tpl.html';
var html = "<div class=\"modal-close-icon\" ng-click=\"$modal.close()\">\n  <i class=\"fa fa-close\"></i>\n</div>\n\n<div class=\"content p-0\">\n  <header>\n    <h2 class=\"pretitle\" translate=\"app.feedback.modal.pretitle\"></h2>\n    <h1 class=\"title has-pretitle\" translate=\"app.feedback.modal.title\"></h1>\n  </header>\n\n  <p translate=\"app.feedback.modal.description\"></p>\n\n  <div class=\"card\">\n    <div class=\"card-header\">\n      <h3 class=\"card-title\" translate=\"app.feedback.modal.card.title\"></h3>\n    </div>\n    <div class=\"card-body\">\n      <feedback-component></feedback-component>\n    </div>\n  </div>\n</div>\n\n<fd-form-button\n  ng-click=\"$modal.close()\"\n  btn-primary=\"true\"\n  label=\"{{'app.feedback.modal.close' | translate}}\"\n  class=\"pull-right\"\n></fd-form-button>\n";
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 1733:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _overviewOwner = __webpack_require__(1734);

_core.app.component(_overviewOwner.overviewOwnerComponent.name, _overviewOwner.overviewOwnerComponent);

/***/ }),

/***/ 1734:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overviewOwnerComponent = undefined;

var _overviewOwner = __webpack_require__(1735);

var _overviewOwner2 = _interopRequireDefault(_overviewOwner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var overviewOwnerComponent = exports.overviewOwnerComponent = {
  name: 'overviewOwner',
  restrict: 'E',
  template: _overviewOwner2.default,
  controllerAs: 'vm',
  bindings: {
    owner: '<',
    columnClass: '<'
  }
};

/***/ }),

/***/ 1735:
/***/ (function(module, exports) {

module.exports = "<div class=\"columns is-multiline\">\n  <div class=\"column content\" ng-class=\"vm.columnClass\">\n    <div class=\"address\">\n      <strong>{{vm.owner.firstName}} {{vm.owner.lastName}}</strong><br />\n      {{vm.owner.address}}<br />\n      {{vm.owner.zipCode}} {{vm.owner.city}}<br />\n    </div>\n  </div>\n  <div class=\"column content\" ng-class=\"vm.columnClass\">\n    <div class=\"address\">\n      <p ng-if=\"vm.owner.birthday\">\n        <strong translate=\"app.overviewState.birthday\"></strong><br />\n        <span>{{vm.owner.birthday | date:vm.dateFormat}}</span>\n      </p>\n\n      <p ng-if=\"vm.owner.tin\">\n        <strong translate=\"app.overviewState.tin\"></strong><br />\n        <span>{{vm.owner.tin}}</span>\n      </p>\n\n      <p ng-if=\"vm.owner.kundenNummer\">\n        <strong translate=\"app.overviewState.kundenNummer\"></strong><br />\n        <span>{{vm.owner.kundenNummer}}</span>\n      </p>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ 1736:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _transferList = __webpack_require__(1737);

_core.app.component(_transferList.transferListComponent.name, _transferList.transferListComponent);

/***/ }),

/***/ 1737:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transferListComponent = undefined;

var _transferList = __webpack_require__(1738);

var _transferList2 = _interopRequireDefault(_transferList);

var _transferList3 = __webpack_require__(1739);

var _transferList4 = _interopRequireDefault(_transferList3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transferListComponent = exports.transferListComponent = {
  name: 'transferList',
  restrict: 'E',
  template: _transferList2.default,
  bindings: {
    list: '<',
    translateKey: '@',
    collapse: '<',
    columns: '<'
  },
  controllerAs: 'vm',
  controller: _transferList4.default
};

/***/ }),

/***/ 1738:
/***/ (function(module, exports) {

module.exports = "<fd-form-button\n  ng-if=\"vm.collapse\"\n  on-click=\"vm.isCollapsed = !vm.isCollapsed\"\n  label=\"{{ 'app.transferList.toggleCollapse.' + (vm.isCollapsed && 'expand' || 'collapse') }}\"\n></fd-form-button>\n\n<div uib-collapse=\"vm.isCollapsed\">\n  <ul class=\"transfer-list clearfix\" ng-style=\"{'columns': vm.columns}\">\n    <li\n      ng-repeat=\"item in vm.transferList\"\n      ng-class=\"{ 'is-text-muted': !item.value }\"\n    >\n      <i\n        class=\"fa\"\n        ng-class=\"{\n          'fa-check': item.value,\n          'fa-times': !item.value\n        }\"\n      ></i>\n      <span translate=\"{{ ::vm.getTranslateKey(item.key) }}\"></span>\n\n      <ul ng-if=\"item === 'sellFragments'\">\n        <li ng-bind=\"vm.list.fragmentsProceedsDestinationBankName\"></li>\n        <li ng-bind=\"vm.list.fragmentsProceedsDestinationBic\"></li>\n        <li ng-bind=\"vm.list.fragmentsProceedsDestinationAccountOwner\"></li>\n        <li ng-bind=\"vm.list.fragmentsProceedsDestinationIban\"></li>\n      </ul>\n    </li>\n  </ul>\n</div>\n"

/***/ }),

/***/ 1739:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListItems = ['transferAllSecurities', 'disposeSecuritiesAccount', 'transferCapitalLoss', 'disposeSavingsPlan', 'disposeExemptionOrder', 'sellFragments'];

var TransferListController = function (_BaseController) {
  TransferListController.$inject = ["controllerService", "$scope"];
  (0, _inherits3.default)(TransferListController, _BaseController);

  function TransferListController(controllerService, $scope) {
    'ngInject';

    (0, _classCallCheck3.default)(this, TransferListController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TransferListController.__proto__ || (0, _getPrototypeOf2.default)(TransferListController)).call(this, {
      controllerService: controllerService,
      $scope: $scope
    }));

    _this.isCollapsed = false;
    _this.columns = 1;
    return _this;
  }

  (0, _createClass3.default)(TransferListController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.translateKey = this.translateKey || 'oldPortfolioState';
      this.transferList = ListItems.map(function (item) {
        return { key: item, value: _this2.list[item] };
      }).filter(function (x) {
        return angular.isDefined(x.value);
      }).sort(function (a, b) {
        return b.value - a.value;
      });

      if (this.collapse) {
        this.isCollapsed = true;
      }
    }
  }, {
    key: 'getTranslateKey',
    value: function getTranslateKey(key) {
      return 'app.' + this.translateKey + '.' + key;
    }
  }]);
  return TransferListController;
}(_controller.BaseController);

exports.default = TransferListController;

/***/ }),

/***/ 1740:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _owner = __webpack_require__(1741);

var _owner2 = __webpack_require__(652);

var _owner3 = __webpack_require__(653);

_core.app.config(_owner.ownerState);
_core.app.component(_owner2.ownerComponent.name, _owner2.ownerComponent);
_core.app.factory('OwnerModel', function () {
  return _owner3.OwnerModel;
});

/***/ }),

/***/ 1741:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ownerState = exports.ownerStateName = undefined;

var _owner = __webpack_require__(652);

var _app = __webpack_require__(55);

var ownerStateName = exports.ownerStateName = 'app.owner';

var ownerState = exports.ownerState = ["$stateProvider", function ownerState($stateProvider) {
  'ngInject';

  $stateProvider.state({
    url: '/owner',
    name: ownerStateName,
    component: _owner.ownerComponent.name,
    resolve: { stateResolver: (0, _app.stateResolver)(ownerStateName) }
  });
}];

/***/ }),

/***/ 1742:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OwnerController = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _omit2 = __webpack_require__(282);

var _omit3 = _interopRequireDefault(_omit2);

var _controller = __webpack_require__(14);

var _owner = __webpack_require__(653);

var _transfer = __webpack_require__(654);

var _demo = __webpack_require__(1743);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OwnerController = exports.OwnerController = function (_BaseController) {
  OwnerController.$inject = ["controllerService", "configService"];
  (0, _inherits3.default)(OwnerController, _BaseController);
  (0, _createClass3.default)(OwnerController, [{
    key: 'isProd',
    get: function get() {
      return this.configService.isProduction();
    }
  }, {
    key: 'isPSD',
    get: function get() {
      return this.envService.getTenant().indexOf('psd') >= 0;
    }
  }, {
    key: 'featureUserEmail',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.userEmail);
    }
  }, {
    key: 'showAddNewOwner',
    get: function get() {
      return this.newOwners.length < 2;
    }
  }, {
    key: 'showDeadline',
    get: function get() {
      return this.isPSD;
    }
  }, {
    key: 'transferAllSecurities',
    get: function get() {
      var oldPortfolio = this.appCache.get('oldPortfolio');
      return oldPortfolio && oldPortfolio.transferAllSecurities;
    }
  }, {
    key: 'transferInheritance',
    get: function get() {
      return this.isTransferType(_transfer.TransferType.inheritance);
    }
  }, {
    key: 'transferGift',
    get: function get() {
      return this.isTransferType(_transfer.TransferType.gift);
    }
  }, {
    key: 'transferOwnAccount',
    get: function get() {
      return this.isTransferType(_transfer.TransferType.ownAccount);
    }
  }, {
    key: 'transferOwnAccountHint',
    get: function get() {
      return this.transfer && this.transfer.ownAccountInfo;
    }
  }]);

  function OwnerController(controllerService, configService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, OwnerController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (OwnerController.__proto__ || (0, _getPrototypeOf2.default)(OwnerController)).call(this, { controllerService: controllerService, configService: configService }));

    _this.MAX_OWNERS = 2;
    return _this;
  }

  (0, _createClass3.default)(OwnerController, [{
    key: '$onInit',
    value: function $onInit() {
      this.oldOwners = this.appCache.get('oldOwners') || [new _owner.OwnerModel()];
      this.newOwners = this.appCache.get('newOwners') || [new _owner.OwnerModel()];
      this.transfer = this.appCache.get('transfer');
      this.ownersForm = {};
      this.deadlineDateOptions = {
        dateFormat: 'dd.MM.yyyy',
        minDate: new Date()
      };
      this.deadline = new Date();
    }
  }, {
    key: 'next',
    value: function next() {
      this.ownersForm.$submitted = true;
      if (!this.ownersForm.$valid) {
        return;
      }
      this.setOwnersData();
      this.nextState();
    }
  }, {
    key: 'prev',
    value: function prev() {
      if (this.ownersForm.$valid) {
        this.setOwnersData();
      }

      // Since we skip the newPortfolio state if the user transfers all securites
      // we need to skip newPortfolio state backwards as well
      this.transferAllSecurities ? this.go('app.transfer') : this.prevState();
    }
  }, {
    key: 'addOldOwner',
    value: function addOldOwner() {
      if (this.oldOwners.length < 2) {
        this.oldOwners.push(new _owner.OwnerModel({ isAdditionalOwner: true }));
      }
    }
  }, {
    key: 'addNewOwner',
    value: function addNewOwner() {
      if (this.newOwners.length < 2) {
        this.newOwners.push(new _owner.OwnerModel({ isAdditionalOwner: true }));
      }
    }
  }, {
    key: 'removeOldOwner',
    value: function removeOldOwner() {
      if (this.oldOwners.length > 1) {
        this.oldOwners.pop();
      }
    }
  }, {
    key: 'removeNewOwner',
    value: function removeNewOwner() {
      if (this.newOwners.length > 1) {
        this.newOwners.pop();
      }
    }
  }, {
    key: 'setOwnersData',
    value: function setOwnersData() {
      this.appCache.set('deadline', this.deadline);
      this.appCache.set('oldOwners', this.oldOwners);
      this.appCache.set('newOwners', this.newOwners);
    }
  }, {
    key: 'hideEmailOldOnwersForm',
    value: function hideEmailOldOnwersForm(owner) {
      // show email on old owner despite being nachlass
      return this.transferInheritance || !this.featureUserEmail || owner.isAdditionalOwner;
    }
  }, {
    key: 'hideEmailNewOnwersForm',
    value: function hideEmailNewOnwersForm(owner) {
      // show email on new owner when being nachlass or if owner is not changeing
      return !this.transferInheritance && !this.transferOwnAccount || !this.featureUserEmail || owner.isAdditionalOwner;
    }
  }, {
    key: 'isTinRequired',
    value: function isTinRequired() {
      var isTinRequiredFeature = this.configService.isFeatureActive(this.Features.isTinRequired);
      return isTinRequiredFeature || this.transferGift || this.transferInheritance;
    }
  }, {
    key: 'isTransferType',
    value: function isTransferType(type) {
      return this.appCache.get('transfer').type === type;
    }
  }, {
    key: 'demo',
    value: function demo() {
      this.newOwners = this.getDemoUser(_demo.DEMO_DATA_NEW_USER);

      if (!this.transferOwnAccount) {
        this.oldOwners = this.getDemoUser(_demo.DEMO_DATA_OLD_USER);
      }
    }
  }, {
    key: 'getDemoUser',
    value: function getDemoUser(data) {
      var _this2 = this;

      return data.map(function (user) {
        if (!_this2.isTinRequired()) {
          user = (0, _omit3.default)(user, 'tin');
        }
        return new _owner.OwnerModel(user);
      });
    }
  }]);
  return OwnerController;
}(_controller.BaseController);

/***/ }),

/***/ 1743:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEMO_DATA_NEW_USER = exports.DEMO_DATA_NEW_USER = [{
  firstName: 'Manfred',
  lastName: 'Testheimer',
  tin: '12 123 123 123',
  birthday: '1995-04-15T00:00:00.000Z',
  address: 'Universitätsplatz 12',
  zipCode: '34127',
  city: 'Kassel',
  email: 'mm@fino.digital'
}];

var DEMO_DATA_OLD_USER = exports.DEMO_DATA_OLD_USER = [{
  firstName: 'Susi',
  lastName: 'Sorglos',
  tin: '23 234 234 234',
  birthday: '1991-03-23T00:00:00.000Z',
  address: 'Hauptstraße 78',
  zipCode: '34326',
  city: 'Buxtehude',
  email: 'susi@email.de'
}];

/***/ }),

/***/ 1744:
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n  <div\n    ng-class=\"{\n    'content': vm.transferOwnAccount,\n    'content-fluid': !vm.transferOwnAccount,\n  }\"\n  >\n    <header>\n      <h2 class=\"pretitle\" translate=\"app.ownerState.pretitle\"></h2>\n      <h1 class=\"title has-pretitle\" translate=\"app.ownerState.title\"></h1>\n    </header>\n\n    <form name=\"vm.ownersForm\">\n      <div class=\"columns\">\n        <!-- old Owner -->\n        <div class=\"column\" ng-if=\"!vm.transferOwnAccount\">\n          <div class=\"card\">\n            <div class=\"card-header\">\n              <h3\n                class=\"card-title\"\n                translate=\"app.ownerState.currentOwners.title\"\n              ></h3>\n            </div>\n            <div class=\"card-body\">\n              <div\n                ng-repeat=\"owner in vm.oldOwners\"\n                ng-class=\"{ 'card-body-separator': !$last }\"\n              >\n                <user-form\n                  user=\"owner\"\n                  form=\"vm.ownersForm\"\n                  removeable=\"$index == 1\"\n                  remove=\"vm.removeOldOwner()\"\n                  remove-label=\"'app.ownerState.addOldOwner.title'\"\n                  is-additional-owner=\"owner.isAdditionalOwner\"\n                  is-tin-required=\"vm.transferGift\"\n                  hide-email=\"vm.hideEmailOldOnwersForm(owner)\"\n                >\n                </user-form>\n              </div>\n            </div>\n            <div\n              class=\"card-footer\"\n              ng-if=\"vm.oldOwners.length < vm.MAX_OWNERS\"\n            >\n              <nav class=\"label-button m-0 mt-3\">\n                <p\n                  class=\"label\"\n                  translate=\"app.ownerState.addOldOwner.title\"\n                ></p>\n                <fd-form-button\n                  on-click=\"vm.addOldOwner()\"\n                  icon=\"fa fa-plus\"\n                  label=\"button.addOwner\"\n                ></fd-form-button>\n              </nav>\n            </div>\n          </div>\n        </div>\n\n        <!-- new Owner -->\n        <div class=\"column\">\n          <div class=\"card\">\n            <div class=\"card-header\" ng-switch=\"vm.transferOwnAccount\">\n              <h3\n                ng-switch-when=\"true\"\n                class=\"card-title\"\n                translate=\"app.ownerState.newOwners.ownAccount.title\"\n              ></h3>\n              <h3\n                ng-switch-default\n                class=\"card-title\"\n                translate=\"app.ownerState.newOwners.title\"\n              ></h3>\n            </div>\n            <div class=\"card-body\">\n              <div\n                ng-repeat=\"owner in vm.newOwners\"\n                ng-class=\"{ 'card-body-separator': !$last }\"\n              >\n                <user-form\n                  user=\"owner\"\n                  form=\"vm.ownersForm\"\n                  removeable=\"$index == 1\"\n                  remove=\"vm.removeNewOwner()\"\n                  remove-label=\"'app.ownerState.addNewOwner.title'\"\n                  is-additional-owner=\"owner.isAdditionalOwner\"\n                  is-tin-required=\"vm.isTinRequired()\"\n                  hide-email=\"vm.hideEmailNewOnwersForm(owner)\"\n                  ng-class=\"{ 'clearfix': $first }\"\n                >\n                </user-form>\n              </div>\n\n              <div ng-if=\"vm.showDeadline\">\n                <p translate=\"app.ownerState.deadline\"></p>\n                <fd-form-control\n                  type=\"date\"\n                  model=\"vm.deadline\"\n                  type-options=\"vm.deadlineDateOptions\"\n                  required=\"true\"\n                  name=\"deadline\"\n                  form=\"vm.ownersForm\"\n                  label=\"app.ownerState.deadline\"\n                >\n                </fd-form-control>\n              </div>\n\n              <div\n                ng-if=\"vm.transferOwnAccountHint\"\n                class=\"well\"\n                translate=\"app.ownerState.hint\"\n              ></div>\n            </div>\n            <div\n              class=\"card-footer\"\n              ng-if=\"vm.newOwners.length < vm.MAX_OWNERS\"\n            >\n              <nav class=\"label-button m-0 mt-3\">\n                <p\n                  class=\"label\"\n                  translate=\"app.ownerState.addNewOwner.title\"\n                ></p>\n                <fd-form-button\n                  on-click=\"vm.addNewOwner()\"\n                  icon=\"fa fa-plus\"\n                  label=\"button.addOwner\"\n                ></fd-form-button>\n              </nav>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <nav class=\"buttons\">\n        <fd-form-button on-click=\"vm.prev()\" label=\"button.back\">\n        </fd-form-button>\n        <fd-form-button\n          btn-type=\"submit\"\n          btn-primary=\"true\"\n          on-click=\"vm.next()\"\n          label=\"button.continue\"\n          class=\"right\"\n        >\n        </fd-form-button>\n      </nav>\n      <div ng-if=\"!vm.isProd\" class=\"demo-button\">\n        <a ng-click=\"vm.demo()\" translate=\"app.demo\"></a>\n      </div>\n    </form>\n  </div>\n</div>\n"

/***/ }),

/***/ 1745:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _userForm = __webpack_require__(1746);

var _userFormService = __webpack_require__(1750);

_core.app.component('userForm', _userForm.userFormComponent);
_core.app.provider('userFormService', _userFormService.UserFormServiceProvider);

/***/ }),

/***/ 1746:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userFormComponent = undefined;

var _userForm = __webpack_require__(1747);

var _userForm2 = _interopRequireDefault(_userForm);

var _userForm3 = __webpack_require__(1748);

var _userForm4 = _interopRequireDefault(_userForm3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userFormComponent = exports.userFormComponent = {
  name: 'userForm',
  restrict: 'E',
  bindings: {
    user: '=',
    form: '<',
    messages: '<',
    index: '<',
    removeable: '<',
    remove: '&',
    removeLabel: '<',
    isTinRequired: '<',
    hideEmail: '='
  },
  template: _userForm2.default,
  controllerAs: 'vm',
  controller: _userForm4.default
};

/***/ }),

/***/ 1747:
/***/ (function(module, exports) {

module.exports = "<div class=\"user-form\">\n  <!-- Remove user and its form -->\n  <div class=\"remove-user\" ng-if=\"vm.removeable\">\n    <nav class=\"label-button\">\n      <h3 class=\"label\">{{ vm.removeLabel | translate }}</h3>\n      <fd-form-button\n        btn-secondary=\"true\"\n        on-click=\"vm.remove()\"\n        icon=\"fa fa-close\"\n        label=\"button.removeUser\"\n        class=\"right\"\n      >\n      </fd-form-button>\n    </nav>\n  </div>\n\n  <!-- User form fields -->\n  <fd-form-control\n    type=\"text\"\n    model=\"vm.user.firstName\"\n    required=\"true\"\n    id=\"firstName-{{vm.id}}\"\n    name=\"firstName-{{vm.id}}\"\n    form=\"vm.form\"\n    messages=\"vm.messages.firstName\"\n    label=\"app.ownerState.firstName\"\n  >\n  </fd-form-control>\n  <fd-form-control\n    model=\"vm.user.lastName\"\n    required=\"true\"\n    name=\"lastName-{{vm.id}}\"\n    form=\"vm.form\"\n    messages=\"vm.messages.lastName\"\n    label=\"app.ownerState.lastName\"\n  >\n  </fd-form-control>\n\n  <fd-form-control\n    ng-if=\"vm.isTinRequired\"\n    type=\"text\"\n    model=\"vm.user.tin\"\n    required=\"vm.isTinRequired\"\n    name=\"tin-{{vm.id}}\"\n    form=\"vm.form\"\n    messages=\"vm.messages.tin\"\n    label=\"app.ownerState.tin\"\n    options=\"{validate: 'tin'}\"\n  >\n  </fd-form-control>\n  <fd-form-control\n    type=\"date\"\n    model=\"vm.user.birthday\"\n    type-options=\"vm.dateOptions\"\n    required=\"true\"\n    name=\"birthday-{{vm.id}}\"\n    form=\"vm.form\"\n    messages=\"vm.messages.birthday\"\n    label=\"app.ownerState.birthday\"\n    options=\"{validate: 'birthday'}\"\n  >\n  </fd-form-control>\n  <fd-form-control\n    model=\"vm.user.address\"\n    required=\"true\"\n    name=\"address-{{vm.id}}\"\n    form=\"vm.form\"\n    messages=\"vm.messages.address\"\n    label=\"app.ownerState.address\"\n    options=\"{validate: 'address'}\"\n  >\n  </fd-form-control>\n  <div class=\"row\">\n    <fd-form-control\n      type=\"tel\"\n      model=\"vm.user.zipCode\"\n      required=\"true\"\n      name=\"zipCode-{{vm.id}}\"\n      form=\"vm.form\"\n      label=\"app.ownerState.zipCode\"\n      class=\"col-md-4 col-xs-12 pull-left\"\n      messages=\"vm.messages.postcode\"\n      options=\"{validate: 'postcode'}\"\n    >\n    </fd-form-control>\n    <fd-form-control\n      type=\"text\"\n      model=\"vm.user.city\"\n      required=\"true\"\n      name=\"city-{{vm.id}}\"\n      form=\"vm.form\"\n      label=\"app.ownerState.city\"\n      class=\"col-md-8 col-xs-12 pull-right\"\n      messages=\"vm.messages.city\"\n    >\n    </fd-form-control>\n  </div>\n\n  <fd-form-control\n    ng-if=\"!vm.hideEmail\"\n    type=\"email\"\n    model=\"vm.user.email\"\n    required=\"true\"\n    name=\"email-{{vm.id}}\"\n    form=\"vm.form\"\n    messages=\"vm.messages.email\"\n    label=\"app.ownerState.email\"\n  >\n  </fd-form-control>\n\n  <fd-form-control\n    ng-if=\"vm.askForKundenNummer\"\n    type=\"text\"\n    model=\"vm.user.kundenNummer\"\n    required=\"true\"\n    name=\"kundenNummer-{{vm.id}}\"\n    form=\"vm.form\"\n    messages=\"vm.messages.kundenNummer\"\n    label=\"app.ownerState.kundenNummer\"\n  >\n  </fd-form-control>\n</div>\n"

/***/ }),

/***/ 1748:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

var _userForm = __webpack_require__(1749);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserFormController = function (_BaseController) {
  UserFormController.$inject = ["controllerService", "$scope", "userFormService", "configService"];
  (0, _inherits3.default)(UserFormController, _BaseController);

  function UserFormController(controllerService, $scope, userFormService, configService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, UserFormController);
    return (0, _possibleConstructorReturn3.default)(this, (UserFormController.__proto__ || (0, _getPrototypeOf2.default)(UserFormController)).call(this, {
      controllerService: controllerService,
      $scope: $scope,
      userFormService: userFormService,
      configService: configService
    }));
  }

  (0, _createClass3.default)(UserFormController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      // need this to determine which field has error.
      this.id = this.$scope.$id;

      // Setup language specific options like date format for the datepicker
      this.dateOptions = {
        dateFormat: 'dd.MM.yyyy',
        showWeeks: false
      };
      this.setLanguageOptions().then(function () {
        _this2.dateOptions.dateFormat = _this2.languageOptions.mediumDate;
      });

      this.initErrorMessages();

      this.salutations = _userForm.SalutationTypes;
      this.titles = _userForm.TitleTypes;

      var dates = this.getMinMaxDate();
      this.dateOptions.initDate = new Date(dates.initDate);
      this.dateOptions.maxDate = new Date(dates.minDate);
      this.dateOptions.minDate = new Date(dates.maxDate);

      // TODO set feature flags here
      this.isTinRequired = this.isTinRequired || false;
      this.isUserTitleRequired = false;
      this.showUserTitle = true;
    }
  }, {
    key: 'initErrorMessages',
    value: function initErrorMessages() {
      // error message keys
      var formErrorTypes = ['salutation', 'firstName', 'lastName', 'birthday', 'tin', 'address', 'zipCode', 'city', 'email', 'kundennummer'];

      this.messages = {};
      for (var index in formErrorTypes) {
        this.messages[formErrorTypes[index]] = {
          required: 'app.ownerState.error.' + formErrorTypes[index]
        };
        this.messages[formErrorTypes[index]][formErrorTypes[index]] = 'app.ownerState.error.' + formErrorTypes[index];
      }

      this.messages.birthday.parse = 'app.ownerState.error.birthday';
      this.messages.birthday.date = 'app.ownerState.error.birthday';
      this.messages.birthday.dateDisabled = 'app.ownerState.error.birthday.dateDisabled';
      this.messages.birthday.min = 'app.ownerState.error.birthday.minvalue';
      this.messages.birthday.max = 'app.ownerState.error.birthday.maxvalue';
      this.messages.postcode = {
        required: 'app.ownerState.error.zipCode',
        postcode: 'app.ownerState.error.zipCodeLength'
      };
    }
  }, {
    key: 'askForKundenNummer',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.askForKundennummer);
    }
  }]);
  return UserFormController;
}(_controller.BaseController);

exports.default = UserFormController;

/***/ }),

/***/ 1749:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SalutationTypes = exports.SalutationTypes = {
  modelKey: 'key',
  selectables: [{ key: 'app.ownerState.mr', value: 'app.ownerState.mr' }, { key: 'app.ownerState.mrs', value: 'app.ownerState.mrs' }]
};

var TitleTypes = exports.TitleTypes = {
  modelKey: 'key',
  selectables: [{ key: 'app.ownerState.dr', value: 'app.ownerState.dr' }, { key: 'app.ownerState.prof', value: 'app.ownerState.prof' }, { key: 'app.ownerState.profdr', value: 'app.ownerState.profdr' }]
};

/***/ }),

/***/ 1750:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserFormServiceProvider = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _isEmpty2 = __webpack_require__(185);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _libInjection = __webpack_require__(10);

var _accountIdValidation = __webpack_require__(186);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressWithNoRules = [/^([A-zäöüÄÖÜß]+( |,|-|_|\.|\(|\)|\/|\\)*)+\d+.*$/];

var UserFormServiceProvider = exports.UserFormServiceProvider = function (_InjectableClass) {
  UserFormServiceProvider.$inject = ["validationRulesProvider", "appCacheProvider"];
  (0, _inherits3.default)(UserFormServiceProvider, _InjectableClass);

  function UserFormServiceProvider(validationRulesProvider, appCacheProvider) {
    'ngInject';

    (0, _classCallCheck3.default)(this, UserFormServiceProvider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserFormServiceProvider.__proto__ || (0, _getPrototypeOf2.default)(UserFormServiceProvider)).call(this, { validationRulesProvider: validationRulesProvider, appCacheProvider: appCacheProvider }));

    _this.activate();
    return _this;
  }

  (0, _createClass3.default)(UserFormServiceProvider, [{
    key: '$get',
    value: function $get() {
      'ngInject';

      return {
        hasSalutation: this.hasSalutation,
        hasSufficientAge: this.hasSufficientAge,
        isAddressWithHouseNo: this.isAddressWithHouseNo
      };
    }
  }, {
    key: 'activate',
    value: function activate() {
      var _this2 = this;

      this.validationRulesProvider.addRule('salutation', function (value) {
        return _this2.hasSalutation(value);
      });

      this.validationRulesProvider.addRule('address', function (value) {
        return _this2.isAddressWithHouseNo(value);
      });

      this.validationRulesProvider.addRule('birthday', function (value) {
        return _this2.hasSufficientAge(value);
      });

      this.validationRulesProvider.addRule('tin', function (value) {
        var _appCacheProvider$get = _this2.appCacheProvider.get('config'),
            features = _appCacheProvider$get.features;

        var pattern = features.tinValidation;

        return !pattern || (0, _isEmpty3.default)(pattern) || _accountIdValidation.AccountIdValidationService.fullfillsPattern(value, pattern);
      });
    }
  }, {
    key: 'hasSalutation',
    value: function hasSalutation(salutation) {
      return salutation.$modelValue === '0';
    }
  }, {
    key: 'hasSufficientAge',
    value: function hasSufficientAge(birthday) {
      var minDate = new Date();
      minDate.setFullYear(minDate.getFullYear() - 18);

      var maxDate = new Date();
      maxDate.setFullYear(maxDate.getFullYear() - 120);

      return birthday.getTime() >= maxDate.getTime() || birthday.getTime() <= minDate.getTime();
    }
  }, {
    key: 'isAddressWithHouseNo',
    value: function isAddressWithHouseNo(address) {
      return address.match(AddressWithNoRules[0]);
    }
  }]);
  return UserFormServiceProvider;
}(_libInjection.InjectableClass);

/***/ }),

/***/ 1751:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _start = __webpack_require__(300);

var _start2 = __webpack_require__(629);

var _bank = __webpack_require__(301);

var _accounts = __webpack_require__(630);

__webpack_require__(1752);

_core.app.config(_start.startState);
_core.app.component(_start2.startComponent.name, _start2.startComponent);
_core.app.factory('NewBankModel', function () {
  return _bank.NewBankModel;
});
_core.app.service('Accounts', function () {
  return _accounts.Accounts;
});

/***/ }),

/***/ 1752:
/***/ (function(module, exports) {

var path = 'app/common/ui/modals/cheatsheet.tpl.html';
var html = "<div>\n  <h3>Beide Nummern finden Sie online in der Vermögensübericht:</h3>\n  <img\n    style=\"width: 50%\"\n    src=\"https://s3.eu-central-1.amazonaws.com/securities-accountswitch/ebase-onlinebankingdepot.jpg\"\n  />\n  <h3>\n    Zusätzlich sind die Nummern auch in der Depoteröffnungsbestätigung angegeben\n  </h3>\n  <ul>\n    <li>\n      Investmentdepot:<br />\n      <img\n        style=\"width: 50%\"\n        src=\"https://s3.eu-central-1.amazonaws.com/securities-accountswitch/ebase-openingconfirmation_ID.png\"\n      />\n    </li>\n    <li>\n      Wertpapierdepot:<br />\n      <img\n        style=\"width: 50%\"\n        src=\"https://s3.eu-central-1.amazonaws.com/securities-accountswitch/ebase-openingconfirmation_WPD_R.png\"\n      />\n    </li>\n  </ul>\n  <h3>Alternativ finden Sie die Nummern auf dem Depotauszug</h3>\n  <ul>\n    <li>\n      Investmentdepot:<br />\n      <img\n        style=\"width: 50%\"\n        src=\"https://s3.eu-central-1.amazonaws.com/securities-accountswitch/ebase-statement_ID.png\"\n      />\n    </li>\n    <li>\n      Wertpapierdepot:<br />\n      <img\n        style=\"width: 50%\"\n        src=\"https://s3.eu-central-1.amazonaws.com/securities-accountswitch/ebase-statement_WPD.png\"\n      />\n    </li>\n  </ul>\n</div>\n<fd-form-button\n  btn-primary=\"true\"\n  ng-click=\"$modal.close()\"\n  label=\"{{'button.close' | translate}}\"\n  class=\"pull-right\"\n></fd-form-button>\n";
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 1753:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _status = __webpack_require__(307);

var _status2 = __webpack_require__(648);

var _status3 = __webpack_require__(1754);

__webpack_require__(1755);

__webpack_require__(1758);

__webpack_require__(1761);

__webpack_require__(1764);

angular.module(_core.app.name).config(_status.statusState).service('statusService', _status3.StatusService).component(_status2.statusComponent.name, _status2.statusComponent);

/***/ }),

/***/ 1754:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusService = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ng1Request = __webpack_require__(262);

var _lib = __webpack_require__(303);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusService = exports.StatusService = function (_CancelableRequest) {
  StatusService.$inject = ["$http", "$q", "appConfig", "configService"];
  (0, _inherits3.default)(StatusService, _CancelableRequest);

  function StatusService($http, $q, appConfig, configService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, StatusService);
    return (0, _possibleConstructorReturn3.default)(this, (StatusService.__proto__ || (0, _getPrototypeOf2.default)(StatusService)).call(this, { $http: $http, $q: $q, appConfig: appConfig, configService: configService }));
  }

  (0, _createClass3.default)(StatusService, [{
    key: 'getStatus',
    value: function getStatus(id, birthDate) {
      return this.$http({
        method: 'POST',
        data: {
          birthDate: birthDate
        },
        error: {
          silent: true
        },
        url: this.api + '/statuses/' + id
      }).then(_lib.DataResponse.transform('data'));
    }
  }, {
    key: 'markStatusAsCompleted',
    value: function markStatusAsCompleted(id, birthDate) {
      return this.$http({
        method: 'POST',
        data: {
          birthDate: birthDate
        },
        error: {
          silent: true
        },
        url: this.api + '/statuses/' + id + '/confirm'
      }).then(_lib.DataResponse.transform('data'));
    }
  }, {
    key: 'api',
    get: function get() {
      return this.appConfig.get().api.path;
    }
  }, {
    key: 'environment',
    get: function get() {
      if (this.configService.isDevelopment()) {
        return '.dev';
      }

      if (this.configService.isTesting()) {
        return '.test';
      }

      return '';
    }
  }]);
  return StatusService;
}(_ng1Request.CancelableRequest);

/***/ }),

/***/ 1755:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _progressPie = __webpack_require__(1756);

_core.app.component(_progressPie.progressPieComponent.name, _progressPie.progressPieComponent);

/***/ }),

/***/ 1756:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.progressPieComponent = undefined;

var _progressPie = __webpack_require__(1757);

var _progressPie2 = _interopRequireDefault(_progressPie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var progressPieComponent = exports.progressPieComponent = {
  name: 'progressPie',
  restrict: 'E',
  template: _progressPie2.default,
  controllerAs: 'vm',
  bindings: {
    value: '<',
    progress: '<'
  }
};

/***/ }),

/***/ 1757:
/***/ (function(module, exports) {

module.exports = "<div class=\"pie-wrapper progress-{{vm.progress}} style-2\">\n  <span class=\"label\">\n    {{vm.value}}\n    <span class=\"smaller\">\n      {{ 'app.status.progress.' + (vm.value === 1 ? 'day' : 'days') | translate\n      }}\n    </span>\n  </span>\n  <div class=\"pie\">\n    <div class=\"left-side half-circle\"></div>\n    <div class=\"right-side half-circle\"></div>\n  </div>\n  <div class=\"shadow\"></div>\n</div>\n"

/***/ }),

/***/ 1758:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _progressBar = __webpack_require__(1759);

var _progressBar2 = _interopRequireDefault(_progressBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core.app.component('statusProgressBar', _progressBar2.default);

/***/ }),

/***/ 1759:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _progressBar = __webpack_require__(636);

var _progressBar2 = _interopRequireDefault(_progressBar);

var _progressBar3 = __webpack_require__(1760);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  restrict: 'E',
  bindings: {
    states: '<',
    activeState: '<',
    onStateChange: '&'
  },
  template: _progressBar2.default,
  controller: _progressBar3.StatusProgressBarController,
  controllerAs: 'vm'
};

/***/ }),

/***/ 1760:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusProgressBarController = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _findIndex2 = __webpack_require__(291);

var _findIndex3 = _interopRequireDefault(_findIndex2);

var _progressBar = __webpack_require__(637);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusProgressBarController = exports.StatusProgressBarController = function (_ProgressBarControlle) {
  (0, _inherits3.default)(StatusProgressBarController, _ProgressBarControlle);

  function StatusProgressBarController() {
    (0, _classCallCheck3.default)(this, StatusProgressBarController);
    return (0, _possibleConstructorReturn3.default)(this, (StatusProgressBarController.__proto__ || (0, _getPrototypeOf2.default)(StatusProgressBarController)).apply(this, arguments));
  }

  (0, _createClass3.default)(StatusProgressBarController, [{
    key: '$onInit',
    value: function $onInit() {
      this.setStateIndex();
      this.showProgressBar = true;
    }
  }, {
    key: '$onChanges',
    value: function $onChanges() {
      this.setStateIndex();
    }
  }, {
    key: 'setStateIndex',
    value: function setStateIndex() {
      this.currentStateIndex = (0, _findIndex3.default)(this.states, {
        stateName: this.activeState
      });
      this.lastStateIndex = 2;
    }
  }, {
    key: 'getStateStyle',
    value: function getStateStyle() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.activeState;
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.currentStateIndex;
      var currentStateIndex = this.currentStateIndex;


      state.completed = index <= currentStateIndex;
      state.disabled = !state.completed;
      state.style = this.progressItemStyle;
      state.type = state.disabled ? 'text' : 'link';
      state.status = state.isLink ? '' : 'disabled';

      return state.style;
    }
  }]);
  return StatusProgressBarController;
}(_progressBar.ProgressBarController);

/***/ }),

/***/ 1761:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _shipmentStatus = __webpack_require__(1762);

_core.app.component(_shipmentStatus.shiptmentStatusComponent.name, _shipmentStatus.shiptmentStatusComponent);

/***/ }),

/***/ 1762:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shiptmentStatusComponent = undefined;

var _shipmentStatus = __webpack_require__(1763);

var _shipmentStatus2 = _interopRequireDefault(_shipmentStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shiptmentStatusComponent = exports.shiptmentStatusComponent = {
  name: 'shipmentStatus',
  restrict: 'E',
  template: _shipmentStatus2.default,
  controllerAs: 'vm',
  bindings: {
    oldBank: '=',
    newBank: '=',
    shipmentStatus: '='
  }
};

/***/ }),

/***/ 1763:
/***/ (function(module, exports) {

module.exports = "<p\n  ng-if=\"vm.shipmentStatus.shipmentDone\"\n  translate-values=\"{ \n    'shipmentTimestamp':  (vm.shipmentStatus.shipmentTimestamp | date)\n    }\"\n  translate=\"app.status.shipmentStatus.success\"\n></p>\n\n<p\n  ng-if=\"!vm.shipmentStatus.shipmentDone && !vm.shipmentStatus.shipmentFailed\"\n  translate=\"app.status.shipmentStatus.pending\"\n></p>\n\n<p\n  class=\"alert alert-danger\"\n  ng-if=\"vm.shipmentStatus.shipmentFailed\"\n  translate=\"app.status.shipmentStatus.error\"\n  translate-values=\"{ \n    'newBank':  vm.newBank\n    }\"\n></p>\n\n<div>\n  <strong>{{vm.oldBank.name}}</strong>\n  <br />\n  <div ng-if=\"vm.oldBank.address\">{{vm.oldBank.address}} <br /></div>\n  {{vm.oldBank.postcode}} {{vm.oldBank.city}}\n</div>\n"

/***/ }),

/***/ 1764:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _verify = __webpack_require__(649);

var _verify2 = __webpack_require__(650);

__webpack_require__(1765);

_core.app.config(_verify.statusVerifyState);
_core.app.component(_verify2.statusVerifyComponent.name, _verify2.statusVerifyComponent);

/***/ }),

/***/ 1765:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _statusVerifyModal = __webpack_require__(651);

_core.app.component('statusVerifyModalComponent', _statusVerifyModal.statusVerifyModalComponent);

/***/ }),

/***/ 1766:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _switchNotAllowed = __webpack_require__(1767);

var _switchNotAllowed2 = __webpack_require__(655);

_core.app.config(_switchNotAllowed.switchNotAllowedState);
_core.app.component(_switchNotAllowed2.switchNotAllowedComponent.name, _switchNotAllowed2.switchNotAllowedComponent);

/***/ }),

/***/ 1767:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchNotAllowedState = exports.switchNotAllowedStateName = undefined;

var _switchNotAllowed = __webpack_require__(655);

var _app = __webpack_require__(55);

var switchNotAllowedStateName = exports.switchNotAllowedStateName = 'app.switchNotAllowed';

var switchNotAllowedState = exports.switchNotAllowedState = ["$stateProvider", function switchNotAllowedState($stateProvider) {
  'ngInject';

  $stateProvider.state({
    url: '/switchNotAllowed',
    name: switchNotAllowedStateName,
    component: _switchNotAllowed.switchNotAllowedComponent.name,
    resolve: { stateResolver: (0, _app.stateResolver)(switchNotAllowedStateName) }
  });
}];

/***/ }),

/***/ 1768:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwitchNotAllowedController = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _controller = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwitchNotAllowedController = exports.SwitchNotAllowedController = function (_BaseController) {
  SwitchNotAllowedController.$inject = ["controllerService"];
  (0, _inherits3.default)(SwitchNotAllowedController, _BaseController);

  function SwitchNotAllowedController(controllerService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, SwitchNotAllowedController);
    return (0, _possibleConstructorReturn3.default)(this, (SwitchNotAllowedController.__proto__ || (0, _getPrototypeOf2.default)(SwitchNotAllowedController)).call(this, {
      controllerService: controllerService
    }));
  }

  (0, _createClass3.default)(SwitchNotAllowedController, [{
    key: '$onInit',
    value: function $onInit() {
      this.foreignResidence = this.appCache.get('foreignResidence');
      this.USWithholdingTax = this.appCache.get('USWithholdingTax');
    }
  }, {
    key: 'navigateToStart',
    value: function navigateToStart() {
      this.appCache.remove('foreignResidence');
      this.appCache.remove('USWithholdingTax');
      this.go('app.start');
    }
  }]);
  return SwitchNotAllowedController;
}(_controller.BaseController);

/***/ }),

/***/ 1769:
/***/ (function(module, exports) {

module.exports = "<div class=\"switch-not-allowed\">\n  <div class=\"container\">\n    <div class=\"content\">\n      <h1 translate=\"app.switchNotAllowed.title\"></h1>\n\n      <div\n        ng-if=\"vm.foreignResidence\"\n        class=\"alert alert-danger\"\n        translate=\"app.switchNotAllowed.foreignResidence\"\n      ></div>\n\n      <div\n        ng-if=\"vm.USWithholdingTax\"\n        class=\"alert alert-danger\"\n        translate=\"app.switchNotAllowed.USWithholdingTax\"\n      ></div>\n\n      <fd-form-button\n        btn-primary=\"true\"\n        on-click=\"vm.navigateToStart()\"\n        label=\"app.switchNotAllowed.navigateToStart\"\n        class=\"center\"\n      >\n      </fd-form-button>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ 1770:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var _transfer = __webpack_require__(1771);

var _transfer2 = __webpack_require__(656);

var _transfer3 = __webpack_require__(657);

_core.app.config(_transfer.transferState);
_core.app.component(_transfer2.transferComponent.name, _transfer2.transferComponent);
_core.app.factory('TransferModel', function () {
  return _transfer3.TransferModel;
});

/***/ }),

/***/ 1771:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transferState = exports.transferStateName = undefined;

var _transfer = __webpack_require__(656);

var _app = __webpack_require__(55);

var transferStateName = exports.transferStateName = 'app.transfer';

var transferState = exports.transferState = ["$stateProvider", function transferState($stateProvider) {
  'ngInject';

  $stateProvider.state({
    url: '/transfer',
    name: transferStateName,
    component: _transfer.transferComponent.name,
    resolve: { stateResolver: (0, _app.stateResolver)(transferStateName) }
  });
}];

/***/ }),

/***/ 1772:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransferController = undefined;

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _keys = __webpack_require__(70);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _merge2 = __webpack_require__(124);

var _merge3 = _interopRequireDefault(_merge2);

var _filter2 = __webpack_require__(292);

var _filter3 = _interopRequireDefault(_filter2);

var _controller = __webpack_require__(14);

var _transfer = __webpack_require__(657);

var _transfer2 = __webpack_require__(654);

var _bank = __webpack_require__(644);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransferController = exports.TransferController = function (_BaseController) {
  TransferController.$inject = ["$scope", "controllerService", "securitiesService", "configService"];
  (0, _inherits3.default)(TransferController, _BaseController);
  (0, _createClass3.default)(TransferController, [{
    key: 'checkCreditorChange',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.checkCreditorChange);
    }
  }, {
    key: 'guidedTourIsActive',
    get: function get() {
      return this.appCache.get('guidedTourIsActive');
    }
  }, {
    key: 'iconPath',
    get: function get() {
      return this.configService.getFeature(this.Features.infoIconPath);
    }
  }, {
    key: 'transferTypes',
    get: function get() {
      return this.configService.getFeature(this.Features.transferTypes) || (0, _keys2.default)(_transfer2.TransferType);
    }
  }, {
    key: 'transferAllSecurities',
    get: function get() {
      return this.appCache.get('transferAllSecurities');
    }
  }, {
    key: 'transferWithLogin',
    get: function get() {
      return !this.transferAllSecurities && !this.creditorChange;
    }
  }, {
    key: 'tenantName',
    get: function get() {
      return this.configService.getTenant();
    }
  }]);

  function TransferController($scope, controllerService, securitiesService, configService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, TransferController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TransferController.__proto__ || (0, _getPrototypeOf2.default)(TransferController)).call(this, {
      $scope: $scope,
      controllerService: controllerService,
      securitiesService: securitiesService,
      configService: configService
    }));

    _this.loading = false;
    return _this;
  }

  (0, _createClass3.default)(TransferController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.oldPortfolio = this.appCache.get('oldPortfolio');

      this.oldBank = this.appCache.get('oldBank') || new _bank.OldBankModel();

      this.transfer = this.appCache.get('transfer') || new _transfer.TransferModel();
      this.transferOptions = (0, _filter3.default)(_transfer2.TransferOptions, function (o) {
        return _this2.transferTypes.indexOf(o.value) !== -1;
      }).map(function (option) {
        return (0, _merge3.default)(option, {
          type: 'radio',
          name: 'transfer-radio',
          iconPath: _this2.iconPath
        });
      });

      if (this.ownAccountTransferPrechecked) {
        this.transfer.type = this.transfer.type || _transfer2.TransferType.ownAccount;
        this.ownAccount = true;
      }

      this.$scope.$watch('vm.ownAccount', function (newValue) {
        _this2.transfer.type = newValue ? _transfer2.TransferType.ownAccount : null;

        // Stop transfer to next state for switch where ownAccount value is not truthy.
        if (_this2.checkCreditorChange) {
          _this2.creditorChange = !newValue;
        }
      });

      this.$scope.$watch('vm.transfer.type', function (newValue) {
        _this2.transferTypValid();
      });
    }
  }, {
    key: 'nextWithLogin',
    value: function nextWithLogin() {
      this.appCache.set('guidedTourIsActive', false);
      this.updateCache();
      this.startUBA();
    }
  }, {
    key: 'nextWithoutLogin',
    value: function nextWithoutLogin() {
      this.appCache.set('guidedTourIsActive', true);
      this.updateCache();
      this.nextState();
    }
  }, {
    key: 'next',
    value: function next() {
      this.updateCache();

      this.transferForm.$setSubmitted();
      if (!this.transferForm.$valid || !this.formValid()) {
        return;
      }

      this.nextState('app.owner');
    }
  }, {
    key: 'prev',
    value: function prev() {
      this.updateCache();
      this.prevState();
    }
  }, {
    key: 'startUBA',
    value: function startUBA() {
      var _this3 = this;

      this.loading = true;
      this.securitiesService.loginWithUBA().then(function (response) {
        var _response$data = response.data,
            redirectURL = _response$data.redirectURL,
            sessionId = _response$data.sessionId,
            userIdentifier = _response$data.userIdentifier;

        var redirectURLAfterUBA = _this3.$window.location.origin + '/newPortfolio';
        var exitURL = _this3.$window.location.origin + '/transfer';
        var service = 'dws';
        var tenant = _this3.tenantName.toLowerCase().replaceAll('_', '-');

        var _configService$config = _this3.configService.config,
            primaryColor = _configService$config.primaryColor,
            logo = _configService$config.logo;


        var theme = encodeURIComponent(angular.toJson({
          primaryColor: primaryColor,
          logo: logo
        }));

        var ubaUrl = [redirectURL + '?sessionId=' + sessionId, 'userIdentifier=' + userIdentifier, 'redirectURL=' + redirectURLAfterUBA, 'exitURL=' + exitURL, 'service=' + service, 'tenant=' + tenant, 'theme=' + theme, 'accountTypes=DEPOT,FONDSDEPOT', 'demoAccount=depot', 'translateKey=dws'].join('&');

        _this3.appCache.set('UBAUserIdentifier', userIdentifier);

        _this3.$window.location.href = ubaUrl;
      }, function () {}, function () {
        return _this3.loading = false;
      });
    }
  }, {
    key: 'updateCache',
    value: function updateCache() {
      this.transfer.ownAccountInfo = this.transfer.type === _transfer2.TransferType.ownAccount;

      if (this.transfer.type !== _transfer2.TransferType.ownAccount) {
        // Bei einem DWS mit Gläubigerwechsel, können keine Verlustverrechnungstöpfe (transferCapitalLoss) übertragen werden.
        this.oldPortfolio.transferCapitalLoss = false;
      }
      // apply checkbox from start page
      this.oldPortfolio.transferAllSecurities = this.transferAllSecurities;
      this.appCache.set('oldPortfolio', this.oldPortfolio);
      this.appCache.set('oldBank', this.oldBank);
      this.appCache.set('transfer', (0, _extends3.default)({}, this.transfer, {
        type: this.transfer.type
      }));
    }
  }, {
    key: 'transferTypValid',
    value: function transferTypValid() {
      if (this.transferForm.$submitted) {
        this.transferTypValidationError = !this.transfer.type;
      }
    }
  }, {
    key: 'formValid',
    value: function formValid() {
      this.oldBankNotSelectedError = !this.oldBank.legacyBankIdentifier;
      this.transferTypValid();
      return !this.transferTypValidationError && !this.oldBankNotSelectedError;
    }
  }, {
    key: 'ownAccountTransferPrechecked',
    get: function get() {
      return this.configService.isFeatureActive(this.Features.ownAccountTransferPrechecked);
    }
  }]);
  return TransferController;
}(_controller.BaseController);

/***/ }),

/***/ 1773:
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n  <div class=\"content\">\n    <!-- Transfer options -->\n    <form name=\"vm.transferForm\" novalidate>\n      <header ng-if=\"!vm.transferAllSecurities\">\n        <h2 class=\"pretitle\" translate=\"app.transferState.pretitle\"></h2>\n        <h1 class=\"title has-pretitle\" translate=\"app.transferState.title\"></h1>\n      </header>\n\n      <div ng-if=\"vm.transferAllSecurities\">\n        <old-bank-input\n          form=\"vm.transferForm\"\n          model=\"vm.oldBank\"\n          title=\"'app.oldPortfolioState.bank.title'\"\n          pretitle=\"'app.oldPortfolioState.bank.pretitle'\"\n        >\n        </old-bank-input>\n      </div>\n\n      <div class=\"card\">\n        <div class=\"card-body\">\n          <toggle-control\n            model=\"vm.ownAccount\"\n            label=\"app.transferState.type.ownAccount.label\"\n            info-text-key=\"app.transferState.type.ownAccount.info\"\n            control-id=\"transfer-own-account\"\n          ></toggle-control>\n        </div>\n      </div>\n\n      <div ng-if=\"!vm.ownAccount\">\n        <h4 translate=\"app.transferState.type.title\"></h4>\n        <info-checkbox\n          ng-repeat=\"option in vm.transferOptions track by $index\"\n          options=\"option\"\n          form=\"vm.transferForm\"\n          model=\"vm.transfer.type\"\n        >\n        </info-checkbox>\n      </div>\n\n      <div ng-if=\"vm.transferWithLogin\" class=\"card\">\n        <div class=\"card-body\">\n          {{ 'app.transferState.hint' | translate }}\n\n          <div class=\"clearfix mt-3\">\n            <fd-form-button\n              btn-type=\"submit\"\n              btn-primary=\"true\"\n              btn-class=\"equal-width\"\n              on-click=\"vm.nextWithLogin()\"\n              is-busy=\"vm.loading\"\n              label=\"app.bankLogin.submit\"\n              class=\"right pull-right\"\n            >\n            </fd-form-button>\n          </div>\n        </div>\n      </div>\n\n      <div\n        ng-if=\"vm.transferTypValidationError\"\n        class=\"alert alert-danger fade-if\"\n        translate=\"app.transferState.type.missing\"\n      ></div>\n\n      <div\n        ng-if=\"vm.oldBankNotSelectedError\"\n        class=\"alert alert-danger fade-if\"\n        translate=\"app.start.error.oldBank.required\"\n      ></div>\n\n      <!-- Button -->\n      <nav class=\"buttons\">\n        <fd-form-button on-click=\"vm.prev()\" label=\"button.back\">\n        </fd-form-button>\n\n        <fd-form-button\n          ng-if=\"vm.transferAllSecurities && !vm.creditorChange\"\n          btn-type=\"submit\"\n          btn-primary=\"true\"\n          on-click=\"vm.next()\"\n          label=\"button.next\"\n          class=\"right\"\n        >\n        </fd-form-button>\n\n        <fd-form-button\n          ng-if=\"vm.transferWithLogin\"\n          btn-class=\"equal-width\"\n          on-click=\"vm.nextWithoutLogin()\"\n          label=\"app.guided.submit\"\n          class=\"right\"\n        >\n        </fd-form-button>\n      </nav>\n    </form>\n  </div>\n</div>\n"

/***/ }),

/***/ 1774:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadTranslations = exports.loadTheme = undefined;

var _kebabCase2 = __webpack_require__(639);

var _kebabCase3 = _interopRequireDefault(_kebabCase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable angular/document-service */
var loadTheme = exports.loadTheme = function loadTheme(theme, tenant, onloadCallback) {
  var url = theme + '.bundle.js';
  var script = document.createElement('script');
  var scripts = document.getElementsByTagName('script');
  var lastScript = scripts[scripts.length - 1];
  script.async = false;
  script.src = url;
  script.onload = onloadCallback;

  // Insert custom script into head
  lastScript.parentNode.insertBefore(script, lastScript.nextSibling);

  // Add custom class name to body
  document.getElementsByTagName('body')[0].classList.add(theme);
  document.getElementsByTagName('body')[0].classList.add((0, _kebabCase3.default)(tenant));
};

/* eslint-disable angular/document-service */
var loadTranslations = exports.loadTranslations = function loadTranslations(config, $translatePartialLoaderProvider) {
  var theme = config.theme;
  var translateKey = config.translateKey;

  // add custom translation

  var customI18NUrl = 'custom/' + theme;
  $translatePartialLoaderProvider.addPart(customI18NUrl);

  // add tenant specific translations if present
  if (translateKey) {
    var tenantSpecificI18NUrl = 'custom/' + theme + '/tenants/' + translateKey;
    $translatePartialLoaderProvider.addPart(tenantSpecificI18NUrl);
  }
};

/***/ }),

/***/ 1775:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControllerService = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _libInjection = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ControllerService = exports.ControllerService = function (_InjectableClass) {
  ControllerService.$inject = ["$log", "$translate", "$locale", "tmhDynamicLocale", "$state", "$stateParams", "$timeout", "$window", "appCache", "appConfig", "envService", "errorService", "trackingService"];
  (0, _inherits3.default)(ControllerService, _InjectableClass);

  function ControllerService($log, $translate, $locale, tmhDynamicLocale, $state, $stateParams, $timeout, $window, appCache, appConfig, envService, errorService, trackingService) {
    'ngInject';

    (0, _classCallCheck3.default)(this, ControllerService);
    return (0, _possibleConstructorReturn3.default)(this, (ControllerService.__proto__ || (0, _getPrototypeOf2.default)(ControllerService)).call(this, {
      $log: $log,
      $translate: $translate,
      $locale: $locale,
      tmhDynamicLocale: tmhDynamicLocale,
      $state: $state,
      $stateParams: $stateParams,
      $timeout: $timeout,
      $window: $window,
      appCache: appCache,
      appConfig: appConfig,
      envService: envService,
      errorService: errorService,
      trackingService: trackingService
    }));
  }

  return ControllerService;
}(_libInjection.InjectableClass);

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Features = exports.Features = {
  abdicationCancellationRight: 'abdicationCancellationRight',
  accountNumberValidation: 'accountNumberValidation',
  additionalAccount: 'additionalAccount',
  askForKundennummer: 'askForKundennummer',
  asyncProcessing: 'asyncProcessing',
  checkCreditorChange: 'checkCreditorChange',
  footerContact: 'footerContact',
  foreignResidenceCheck: 'foreignResidenceCheck',
  hasFeedbackModal: 'hasFeedbackModal',
  hasStatusPage: 'hasStatusPage',
  infoIconPath: 'infoIconPath',
  investmentAccountUrl: 'investmentAccountUrl',
  isTinRequired: 'isTinRequired',
  ownAccountTransferPrechecked: 'ownAccountTransferPrechecked',
  prefillBankCode: 'prefillBankCode',
  proceedsOnClearingAccount: 'proceedsOnClearingAccount',
  promotionImage: 'promotionImage',
  promotionLink: 'promotionLink',
  securitiesAccountUrl: 'securitiesAccountUrl',
  showBlzInput: 'showBlzInput',
  showFinanceType: 'showFinanceType',
  showFinanceTypeInfo: 'showFinanceTypeInfo',
  showFinoLogoInHeader: 'showFinoLogoInHeader',
  showHeadline: 'showHeadline',
  showHelpItem: 'showHelpItem',
  showNewPortfolioNeededInfo: 'showNewPortfolioNeededInfo',
  showSignaturePad: 'showSignaturePad',
  showStartOpenSecuritiesAccountInfo: 'showStartOpenSecuritiesAccountInfo',
  transferTypes: 'transferTypes',
  userEmail: 'userEmail',
  USWithholdingTaxCheck: 'USWithholdingTaxCheck'
};

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountIdValidationService = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _request = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountIdValidationService = exports.AccountIdValidationService = function (_ApiRequest) {
  AccountIdValidationService.$inject = ["$http", "$q"];
  (0, _inherits3.default)(AccountIdValidationService, _ApiRequest);

  function AccountIdValidationService($http, $q) {
    'ngInject';

    (0, _classCallCheck3.default)(this, AccountIdValidationService);
    return (0, _possibleConstructorReturn3.default)(this, (AccountIdValidationService.__proto__ || (0, _getPrototypeOf2.default)(AccountIdValidationService)).call(this, { $http: $http, $q: $q }));
  }

  (0, _createClass3.default)(AccountIdValidationService, [{
    key: 'checkAccountId',
    value: function checkAccountId(depotNumber) {
      return this.$http({
        method: 'POST',
        url: '/api/validation/depotnumber ',
        data: {
          depotNumber: depotNumber
        }
      });
    }
  }], [{
    key: 'isValidEbaseAccountId',
    value: function isValidEbaseAccountId(value) {
      return (/^99\d{9}$/.test(value)
      );
    }
  }, {
    key: 'isValidAccountId',
    value: function isValidAccountId(value) {
      return (/\d{11}$/.test(value)
      );
    }
  }, {
    key: 'isJustNumber',
    value: function isJustNumber(value) {
      return (/^\d+$/.test(value)
      );
    }
  }, {
    key: 'fullfillsPattern',
    value: function fullfillsPattern(value, pattern) {
      var revert = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      // support multiple pattern
      if (angular.isArray(pattern)) {
        return pattern.every(function (p) {
          return AccountIdValidationService.fullfillsPattern(value, p, revert);
        });
      }

      var match = new RegExp(pattern, 'ig').test(value);
      return revert ? !match : match;
    }
  }, {
    key: 'fullfillsRanges',
    value: function fullfillsRanges(value, ranges) {
      var num = +value;
      return ranges.some(function (range) {
        var from = range.from,
            to = range.to;

        return num >= from && num <= to;
      });
    }
  }]);
  return AccountIdValidationService;
}(_request.ApiRequest);

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startState = exports.startStateName = undefined;

var _start = __webpack_require__(629);

var startStateName = exports.startStateName = 'app.start';

var startState = exports.startState = ["$stateProvider", function startState($stateProvider) {
  'ngInject';

  $stateProvider.state({
    url: '/',
    name: startStateName,
    component: _start.startComponent.name
  });
}];

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewBankModel = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _model = __webpack_require__(71);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewBankModel = exports.NewBankModel = function (_BaseModel) {
  (0, _inherits3.default)(NewBankModel, _BaseModel);

  function NewBankModel(data) {
    (0, _classCallCheck3.default)(this, NewBankModel);
    return (0, _possibleConstructorReturn3.default)(this, (NewBankModel.__proto__ || (0, _getPrototypeOf2.default)(NewBankModel)).call(this, data, {
      portfolioId: null,
      investmentId: null,
      orderOfAccountFields: null,
      blz: null
    }));
  }

  return NewBankModel;
}(_model.BaseModel);

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.legalState = exports.legalStateName = undefined;

var _legal = __webpack_require__(631);

var legalStateName = exports.legalStateName = 'app.legal';

var legalState = exports.legalState = ["$stateProvider", function legalState($stateProvider) {
  'ngInject';

  $stateProvider.state({
    url: '/legal/:document',
    name: legalStateName,
    params: { document: null },
    component: _legal.legalComponent.name
  });
}];

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackModel = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _model = __webpack_require__(71);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeedbackModel = exports.FeedbackModel = function (_BaseModel) {
  (0, _inherits3.default)(FeedbackModel, _BaseModel);

  function FeedbackModel(data) {
    (0, _classCallCheck3.default)(this, FeedbackModel);
    return (0, _possibleConstructorReturn3.default)(this, (FeedbackModel.__proto__ || (0, _getPrototypeOf2.default)(FeedbackModel)).call(this, data, {
      rating: 0,
      message: '',
      orderId: null
    }));
  }

  return FeedbackModel;
}(_model.BaseModel);

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewPortfolioModel = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _model = __webpack_require__(71);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewPortfolioModel = exports.NewPortfolioModel = function (_BaseModel) {
  (0, _inherits3.default)(NewPortfolioModel, _BaseModel);

  function NewPortfolioModel(data) {
    (0, _classCallCheck3.default)(this, NewPortfolioModel);
    return (0, _possibleConstructorReturn3.default)(this, (NewPortfolioModel.__proto__ || (0, _getPrototypeOf2.default)(NewPortfolioModel)).call(this, data, {
      securities: [],
      funds: []
    }));
  }

  return NewPortfolioModel;
}(_model.BaseModel);

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusState = exports.statusStateName = undefined;

var _status = __webpack_require__(648);

var statusStateName = exports.statusStateName = 'app.status';

var statusState = exports.statusState = ["$stateProvider", function statusState($stateProvider) {
  'ngInject';

  $stateProvider.state({
    name: statusStateName,
    url: '/status/:orderId?id?token?birthday',
    component: _status.statusComponent.name,
    params: {
      id: null,
      token: null,
      birthday: null,
      orderId: {
        value: '',
        squash: true
      }
    }
  });
}];

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateResolver = exports.appState = exports.ProgressableStates = undefined;

var _values = __webpack_require__(626);

var _values2 = _interopRequireDefault(_values);

var _app = __webpack_require__(628);

var _feature = __webpack_require__(184);

var _start = __webpack_require__(300);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressableStates = exports.ProgressableStates = function ProgressableStates(hasStatus) {
  return (0, _values2.default)((0, _app.AppStateFlow)(hasStatus)).filter(function (step) {
    return step.progressbarVisible;
  });
};

var appState = exports.appState = ["$stateProvider", function appState($stateProvider) {
  'ngInject';

  $stateProvider.state({
    abstract: true,
    name: 'app',
    redirectTo: 'start',
    template: '<app />',
    resolve: {
      languageOptions: ["$translate", "$locale", "controllerService", function languageOptions($translate, $locale, controllerService) {
        'ngInject';

        var lang = $translate.use();
        return controllerService.tmhDynamicLocale.set(lang).then(function () {
          var _$locale$DATETIME_FOR = $locale.DATETIME_FORMATS,
              longDate = _$locale$DATETIME_FOR.longDate,
              mediumDate = _$locale$DATETIME_FOR.mediumDate,
              shortDate = _$locale$DATETIME_FOR.shortDate;

          return {
            lang: lang,
            dateFormat: longDate,
            longDate: longDate,
            mediumDate: mediumDate,
            shortDate: shortDate
          };
        });
      }]
    }
  });
}];

/**
 * Check if the given state is accessible by stateProvider.
 *
 * @param {string} stateName Name of the state to resolve
 */
var stateResolver = exports.stateResolver = function stateResolver(stateName) {
  return ['$state', '$q', 'appCache', 'configService', function ($state, $q, appCache, configService) {
    var deferred = $q.defer();
    var hasStatusPage = configService.isFeatureActive(_feature.Features.hasStatusPage);

    var rejectState = void 0;
    // Check for the given state if all required values are available.
    var stateConfig = (0, _app.AppStateFlow)(hasStatusPage)[stateName];
    if (stateConfig && stateConfig.requires) {
      var requires = stateConfig.requires;

      requires.forEach(function (key) {
        rejectState = rejectState || !appCache.get(key);
      });
    }

    // console.log('stateResolver', { stateName, rejectState });
    // Reject the resolve request and fallback to last accessed state or defaults to start
    if (rejectState) {
      deferred.reject();
      var lastStateIndex = appCache.get('lastStateIndex');
      var lastState = ProgressableStates(hasStatusPage)[lastStateIndex] || {
        stateName: _start.startStateName
      };
      $state.go(lastState.stateName);
    } else {
      deferred.resolve();
    }

    return deferred.promise;
  }];
};

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var AppStateFlow = exports.AppStateFlow = function AppStateFlow(hasStatus) {
  var states = {
    'app.start': {
      stateName: 'app.start',
      stepTitleKey: 'app.progressBar.start',
      progressbarIcon: 'fa fa-bank',
      progressbarVisible: true
    },
    'app.oldPortfolio': {
      stateName: 'app.oldPortfolio',
      stepTitleKey: 'app.progressBar.oldPortfolio',
      progressbarVisible: true,
      progressbarIcon: 'fa fa-sign-out',
      requires: ['newBank']
    },
    'app.transfer': {
      stateName: 'app.transfer',
      stepTitleKey: 'app.progressBar.transfer',
      progressbarVisible: true,
      progressbarIcon: 'fa fa-exchange',
      requires: ['newBank', 'oldPortfolio']
    },
    'app.newPortfolio': {
      stateName: 'app.newPortfolio',
      stepTitleKey: 'app.progressBar.newPortfolio',
      progressbarVisible: true,
      progressbarIcon: 'fa fa-sign-in',
      requires: ['newBank', 'oldPortfolio', 'transfer']
    },
    'app.owner': {
      stateName: 'app.owner',
      stepTitleKey: 'app.progressBar.owner',
      progressbarVisible: true,
      progressbarIcon: 'fa fa-user',
      requires: ['newBank', 'oldPortfolio', 'transfer']
    },
    'app.overview': {
      stateName: 'app.overview',
      stepTitleKey: 'app.progressBar.overview',
      progressbarVisible: true,
      progressbarIcon: 'fa fa-check-square-o',
      requires: ['newBank', 'oldPortfolio', 'transfer', 'newOwners']
    }
  };
  if (hasStatus) {
    states['app.status'] = { stateName: 'app.status', requires: ['orderId'] };
  } else {
    states['app.finish'] = { stateName: 'app.finish', requires: ['orderId'] };
  }
  return states;
};

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startComponent = undefined;

var _start = __webpack_require__(1567);

var _start2 = __webpack_require__(1570);

var _start3 = _interopRequireDefault(_start2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var startComponent = exports.startComponent = {
  name: 'startComponent',
  restrict: 'E',
  template: _start3.default,
  controller: _start.StartController,
  controllerAs: 'vm',
  bindings: {}
};

/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accounts = undefined;

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Accounts = exports.Accounts = function () {
  function Accounts(financeTypes, form, items) {
    (0, _classCallCheck3.default)(this, Accounts);

    this.financeTypes = financeTypes;
    this.form = form;

    if (items) {
      this.accounts = items;
    } else {
      this.accounts = [this.getDefaultAccountObject()];
    }
  }

  (0, _createClass3.default)(Accounts, [{
    key: "add",
    value: function add(number, type) {
      if (this.accounts.length > 1) {
        return;
      }
      if (number && type) {
        /*
        if we initial pushed an object with empty values to account array and
        want to add specific values, we can fill the 'empty object' with values.
         */
        if (this.accounts && !this.accounts[0].number) {
          this.accounts.pop();
        }

        this.accounts.push({
          number: number,
          type: type
        });
      } else {
        this.accounts.push(this.getDefaultAccountObject());
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      if (this.accounts.length <= 1) {
        return;
      }
      this.accounts.pop();
    }
  }, {
    key: "getDefaultAccountObject",
    value: function getDefaultAccountObject() {
      var defaultObject = {
        number: null,
        type: this.financeTypes[0]
      };
      if (this.accounts && this.accounts.length <= 1) {
        // not proud of this
        if (this.accounts[0].type === this.financeTypes[0]) {
          defaultObject.type = this.financeTypes[1];
        } else {
          defaultObject.type = this.financeTypes[0];
        }
      }
      return defaultObject;
    }
  }, {
    key: "getItem",
    value: function getItem(i) {
      return this.accounts[i];
    }
  }, {
    key: "copyAccountsToObject",
    value: function copyAccountsToObject(model) {
      for (var key in model) {
        model[key] = null;
      }

      for (var i = this.accounts.length - 1; i >= 0; i--) {
        model[this.accounts[i].type] = this.accounts[i].number;
      }
      return model;
    }
  }, {
    key: "all",
    get: function get() {
      return this.accounts;
    }
  }, {
    key: "length",
    get: function get() {
      return this.accounts.length;
    }
  }, {
    key: "bothAccountsHaveSameType",
    get: function get() {
      return this.accounts.length > 1 && this.accounts[0].type === this.accounts[1].type;
    }
  }, {
    key: "bothAccountsHaveSameNumber",
    get: function get() {
      return this.accounts.length > 1 && this.accounts[0].number === this.accounts[1].number;
    }
  }]);
  return Accounts;
}();

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.legalComponent = undefined;

var _legal = __webpack_require__(1575);

var _legal2 = _interopRequireDefault(_legal);

var _legal3 = __webpack_require__(1576);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var legalComponent = exports.legalComponent = {
  name: 'legalComponent',
  restrict: 'E',
  template: _legal2.default,
  controller: _legal3.LegalController,
  controllerAs: 'vm',
  bindings: {}
};

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changelogState = exports.changelogStateName = undefined;

var _changelog = __webpack_require__(633);

var changelogStateName = exports.changelogStateName = 'app.changelog';

var changelogState = exports.changelogState = ["$stateProvider", function changelogState($stateProvider) {
  'ngInject';

  $stateProvider.state('changelog', {
    url: '/changelog',
    name: changelogStateName,
    component: _changelog.changelogComponent.name
  });
}];

/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changelogComponent = undefined;

var _changelog = __webpack_require__(1577);

var _changelog2 = _interopRequireDefault(_changelog);

var _changelog3 = __webpack_require__(1578);

__webpack_require__(1579);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var changelogComponent = exports.changelogComponent = {
  name: 'changelog',
  restrict: 'E',
  template: _changelog2.default,
  controller: _changelog3.ChangelogController,
  controllerAs: 'vm',
  bindings: {}
};

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addSecuritiesComponent = undefined;

var _addSecurities = __webpack_require__(1592);

var _addSecurities2 = _interopRequireDefault(_addSecurities);

var _addSecurities3 = __webpack_require__(1593);

var _addSecurities4 = _interopRequireDefault(_addSecurities3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addSecuritiesComponent = exports.addSecuritiesComponent = {
  name: 'addSecuritiesComponent',
  restrict: 'E',
  bindings: {
    modalInstance: '<'
  },
  template: _addSecurities2.default,
  controller: _addSecurities4.default,
  controllerAs: 'vm'
};

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var OldPortfolioOptions = exports.OldPortfolioOptions = [{
  infoTextKey: 'app.oldPortfolioState.transferCapitalLoss.info',
  label: 'app.oldPortfolioState.transferCapitalLoss',
  name: 'app.oldPortfolioState.transferCapitalLoss',
  model: 'transferCapitalLoss'
}, {
  infoTextKey: 'app.oldPortfolioState.disposeSavingsPlan.info',
  label: 'app.oldPortfolioState.disposeSavingsPlan',
  name: 'app.oldPortfolioState.disposeSavingsPlan',
  model: 'disposeSavingsPlan'
}];

var OldPortfolioMessages = exports.OldPortfolioMessages = {
  fragmentsProceedsDestinationIban: {
    iban: 'app.oldPortfolioState.error.fragmentsProceedsDestinationIban.invalid',
    required: 'app.oldPortfolioState.error.fragmentsProceedsDestinationIban'
  },
  oldAccountNumber: {
    required: 'app.oldPortfolioState.error.oldAccountNumber',
    oldAccountNumberEqualsNewAccountNumber: 'app.oldPortfolioState.error.oldAccountNumberEqualsNewAccountNumber'
  },
  oldBankIdentifier: {
    required: 'app.oldPortfolioState.error.oldBankIdentifier',
    invalidBankIdentifier: 'app.oldPortfolioState.error.invalidBankIdentifier'
  },
  fragmentsProceedsDestinationBic: {
    bic: 'app.oldPortfolioState.fragmentsProceedsDestinationBic.invalid',
    required: 'app.oldPortfolioState.error.fragmentsProceedsDestinationBic'
  },
  fragmentsProceedsDestinationBankName: {
    required: 'app.oldPortfolioState.error.fragmentsProceedsDestinationBankName'
  },
  fragmentsProceedsDestinationAccountOwner: {
    required: 'app.oldPortfolioState.error.fragmentsProceedsDestinationAccountOwner'
  }
};

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"!vm.isStartPage\" class=\"container\">\n  <div class=\"progress-bar-component\" ng-if=\"vm.showProgressBar || vm.show\">\n    <nav class=\"progress-bar-wrapper\">\n      <ul class=\"states flex hidden-xs\">\n        <li\n          ng-repeat=\"state in vm.states\"\n          ng-style=\"vm.getStateStyle(state, $index)\"\n          ng-switch=\"state.type\"\n          class=\"state flex column align-center\"\n          ng-class=\"{\n            'link': state.isLink,\n            'active': state.active,\n            'completed':state.completed,\n            'disabled':state.disabled\n          }\"\n        >\n          <!-- State Link -->\n          <a\n            ng-switch-when=\"link\"\n            ui-sref=\"{{ state.stateName }}\"\n            class=\"flex column align-center\"\n          >\n            <!-- Icon circle -->\n            <span class=\"icon-circle\">\n              <i\n                class=\"icon {{ state.progressbarIcon }}\"\n                ng-class=\"{'fa-inverse': state.active}\"\n              ></i>\n            </span>\n\n            <!-- Title with optional complete icon -->\n            <span class=\"label\">\n              <i ng-if=\"state.completed\" class=\"fa fa-check\"></i>\n              <span\n                class=\"state-title\"\n                translate=\"{{ state.stepTitleKey }}\"\n                translate-values=\"state.translateParams\"\n              ></span>\n            </span>\n          </a>\n\n          <!-- State text (disabled) -->\n          <span ng-switch-default class=\"flex column align-center\">\n            <span class=\"icon-circle\">\n              <i class=\"icon {{ state.progressbarIcon }}\"></i>\n            </span>\n            <span\n              class=\"state-title\"\n              translate=\"{{ state.stepTitleKey }}\"\n              translate-values=\"state.translateParams\"\n            ></span>\n          </span>\n        </li>\n      </ul>\n\n      <div class=\"progress-bar\" ng-style=\"vm.progressBarStyle\">\n        <div\n          class=\"slider slider-active\"\n          ng-style=\"vm.progressBarSliderStyle\"\n        ></div>\n      </div>\n\n      <p class=\"progress-label visible-xs\">\n        Schritt {{vm.currentStateIndex}} von {{vm.states.length}}\n      </p>\n    </nav>\n  </div>\n</div>\n"

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBarController = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _findIndex2 = __webpack_require__(291);

var _findIndex3 = _interopRequireDefault(_findIndex2);

var _controller = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBarController = exports.ProgressBarController = function (_BaseController) {
  ProgressBarController.$inject = ["controllerService", "$transitions"];
  (0, _inherits3.default)(ProgressBarController, _BaseController);

  function ProgressBarController(controllerService, $transitions) {
    'ngInject';

    (0, _classCallCheck3.default)(this, ProgressBarController);
    return (0, _possibleConstructorReturn3.default)(this, (ProgressBarController.__proto__ || (0, _getPrototypeOf2.default)(ProgressBarController)).call(this, { controllerService: controllerService, $transitions: $transitions }));
  }

  (0, _createClass3.default)(ProgressBarController, [{
    key: '$onInit',
    value: function $onInit() {
      this.$transitions.onSuccess({}, this.onStateChange.bind(this));
      this.onStateChange();
    }
  }, {
    key: 'onStateChange',
    value: function onStateChange() {
      this.setStateIndex();
    }
  }, {
    key: 'setStateIndex',
    value: function setStateIndex() {
      this.currentStateIndex = (0, _findIndex3.default)(this.states, {
        stateName: this.currentState.name
      });
      this.showProgressBar = this.currentStateIndex > -1;

      // Store/update latest (highest) transitioned state
      this.lastStateIndex = this.appCache.get('lastStateIndex') || -1;
      if (this.lastStateIndex < this.currentStateIndex) {
        this.appCache.set('lastStateIndex', this.currentStateIndex);
      }
    }
  }, {
    key: 'getStateStyle',
    value: function getStateStyle() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentState;
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.currentStateIndex;
      var currentStateIndex = this.currentStateIndex,
          lastStateIndex = this.lastStateIndex;


      state.active = state.stateName === this.$state.current.name;
      state.completed = index < Math.max(currentStateIndex, lastStateIndex);
      state.disabled = !(state.active || state.completed || index <= lastStateIndex);
      state.style = this.progressItemStyle;
      state.type = state.disabled ? 'text' : 'link';
      state.isLink = state.type === 'link';
      state.status = state.isLink ? '' : 'disabled';

      return state.style;
    }
  }, {
    key: 'getProgressbarWidth',
    value: function getProgressbarWidth(currentStep, totalSteps, totalWidth) {
      if (currentStep > totalSteps) {
        currentStep = totalSteps;
      }
      // The progress should be calculated by the completed steps:
      // Instead of dividing by the total steps, we divide by totalSteps - 1,
      // because each step represents a portion of the completed progress.
      var width = currentStep / (totalSteps - 1) * totalWidth;
      return width;
    }
  }, {
    key: 'progressItemStyle',
    get: function get() {
      return {
        width: 100 / this.states.length + '%'
      };
    }
  }, {
    key: 'progressBarStyle',
    get: function get() {
      var margin = 100 / this.states.length / 2;
      return {
        left: margin + '%',
        right: margin + '%',
        width: 100 - margin * 2 + '%'
      };
    }
  }, {
    key: 'progressBarSliderStyle',
    get: function get() {
      var index = this.currentStateIndex;
      return {
        // calculate current length of progress bar
        width: this.getProgressbarWidth(index, this.states.length, 100) + '%'
      };
    }
  }, {
    key: 'isStartPage',
    get: function get() {
      return this.currentState && this.currentState.name === 'app.start';
    }
  }]);
  return ProgressBarController;
}(_controller.BaseController);

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.finishState = exports.finishStateName = undefined;

var _finish = __webpack_require__(642);

var _app = __webpack_require__(55);

var finishStateName = exports.finishStateName = 'app.finish';

var finishState = exports.finishState = ["$stateProvider", function finishState($stateProvider) {
  'ngInject';

  $stateProvider.state({
    url: '/finish',
    name: finishStateName,
    component: _finish.finishComponent.name,
    resolve: { stateResolver: (0, _app.stateResolver)(finishStateName) }
  });
}];

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.finishComponent = undefined;

var _finish = __webpack_require__(1689);

var _finish2 = __webpack_require__(1690);

var _finish3 = _interopRequireDefault(_finish2);

__webpack_require__(1691);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var finishComponent = exports.finishComponent = {
  name: 'finishComponent',
  restrict: 'E',
  template: _finish3.default,
  controller: _finish.FinishController,
  controllerAs: 'vm',
  bindings: {}
};

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newPortfolioComponent = undefined;

var _newPortfolio = __webpack_require__(1700);

var _newPortfolio2 = __webpack_require__(1702);

var _newPortfolio3 = _interopRequireDefault(_newPortfolio2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var newPortfolioComponent = exports.newPortfolioComponent = {
  name: 'newPortfolioComponent',
  restrict: 'E',
  template: _newPortfolio3.default,
  controller: _newPortfolio.NewPortfolioController,
  controllerAs: 'vm',
  bindings: {}
};

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OldBankModel = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _model = __webpack_require__(71);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OldBankModel = exports.OldBankModel = function (_BaseModel) {
  (0, _inherits3.default)(OldBankModel, _BaseModel);

  function OldBankModel(data) {
    (0, _classCallCheck3.default)(this, OldBankModel);
    return (0, _possibleConstructorReturn3.default)(this, (OldBankModel.__proto__ || (0, _getPrototypeOf2.default)(OldBankModel)).call(this, data, {
      legacyBankIdentifier: null,
      oldAccountNumber: null
    }));
  }

  return OldBankModel;
}(_model.BaseModel);

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OldPortfolioModel = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _model = __webpack_require__(71);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OldPortfolioModel = exports.OldPortfolioModel = function (_BaseModel) {
  (0, _inherits3.default)(OldPortfolioModel, _BaseModel);

  function OldPortfolioModel(data) {
    (0, _classCallCheck3.default)(this, OldPortfolioModel);
    return (0, _possibleConstructorReturn3.default)(this, (OldPortfolioModel.__proto__ || (0, _getPrototypeOf2.default)(OldPortfolioModel)).call(this, data, {
      data: {
        accounts: [],
        securities: [],
        funds: []
      },
      disposeExemptionOrder: null,
      disposeExemptionOrderInfo: false,
      disposeSavingsPlan: null,
      disposeSavingsPlanInfo: false,
      disposeSecuritiesAccount: false,
      disposeSecuritiesAccountInfo: false,
      fragmentsProceedsDestinationAccountOwner: null,
      fragmentsProceedsDestinationBankName: null,
      fragmentsProceedsDestinationBic: null,
      fragmentsProceedsDestinationIban: null,
      sellFragments: null,
      sellFragmentsInfo: null,
      transferAllSecurities: false,
      transferCapitalLoss: null,
      transferCapitalLossInfo: false
    }));
  }

  (0, _createClass3.default)(OldPortfolioModel, [{
    key: 'precheckAllOptions',
    value: function precheckAllOptions() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.disposeSavingsPlan = check;
      this.disposeSecuritiesAccount = check;
      this.sellFragments = check;
      this.transferAllSecurities = check;
      this.transferCapitalLoss = check;
      return this;
    }
  }]);
  return OldPortfolioModel;
}(_model.BaseModel);

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oldPortfolioComponent = undefined;

var _oldPortfolio = __webpack_require__(1705);

var _oldPortfolio2 = __webpack_require__(1706);

var _oldPortfolio3 = _interopRequireDefault(_oldPortfolio2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var oldPortfolioComponent = exports.oldPortfolioComponent = {
  name: 'oldPortfolioComponent',
  restrict: 'E',
  template: _oldPortfolio3.default,
  controller: _oldPortfolio.OldPortfolioController,
  controllerAs: 'vm',
  bindings: {}
};

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overviewComponent = undefined;

var _overview = __webpack_require__(1712);

var _overview2 = __webpack_require__(1728);

var _overview3 = _interopRequireDefault(_overview2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var overviewComponent = exports.overviewComponent = {
  name: 'overviewComponent',
  restrict: 'E',
  template: _overview3.default,
  controller: _overview.OverviewController,
  controllerAs: 'vm',
  bindings: {}
};

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusComponent = undefined;

var _status = __webpack_require__(1721);

var _status2 = __webpack_require__(1727);

var _status3 = _interopRequireDefault(_status2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var statusComponent = exports.statusComponent = {
  name: 'statusComponent',
  restrict: 'E',
  template: _status3.default,
  controller: _status.StatusController,
  controllerAs: 'vm',
  bindings: {}
};

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusVerifyState = exports.statusVerifyStateName = undefined;

var _verify = __webpack_require__(650);

var statusVerifyStateName = exports.statusVerifyStateName = 'app.verify';

var statusVerifyState = exports.statusVerifyState = ["$stateProvider", function statusVerifyState($stateProvider) {
  'ngInject';

  $stateProvider.state({
    url: '/status/:orderId/verify?invalidBirthday',
    name: statusVerifyStateName,
    params: {
      orderId: null,
      invalidBirthday: null
    },
    component: _verify.statusVerifyComponent.name
  });
}];

/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusVerifyComponent = undefined;

var _verify = __webpack_require__(1722);

var _verify2 = __webpack_require__(1725);

var _verify3 = _interopRequireDefault(_verify2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var statusVerifyComponent = exports.statusVerifyComponent = {
  name: 'statusVerifyComponent',
  restrict: 'E',
  template: _verify3.default,
  controller: _verify.StatusVerifyController,
  controllerAs: 'vm',
  bindings: {}
};

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusVerifyModalComponent = undefined;

var _statusVerifyModal = __webpack_require__(1723);

var _statusVerifyModal2 = _interopRequireDefault(_statusVerifyModal);

var _statusVerifyModal3 = __webpack_require__(1724);

var _statusVerifyModal4 = _interopRequireDefault(_statusVerifyModal3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var statusVerifyModalComponent = exports.statusVerifyModalComponent = {
  name: 'statusVerifyModalComponent',
  restrict: 'E',
  bindings: {
    modalInstance: '<'
  },
  template: _statusVerifyModal2.default,
  controller: _statusVerifyModal4.default,
  controllerAs: 'vm'
};

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ownerComponent = undefined;

var _owner = __webpack_require__(1742);

var _owner2 = __webpack_require__(1744);

var _owner3 = _interopRequireDefault(_owner2);

__webpack_require__(1745);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ownerComponent = exports.ownerComponent = {
  name: 'ownerComponent',
  restrict: 'E',
  template: _owner3.default,
  controller: _owner.OwnerController,
  controllerAs: 'vm',
  bindings: {}
};

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OwnerModel = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _model = __webpack_require__(71);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OwnerModel = exports.OwnerModel = function (_BaseModel) {
  (0, _inherits3.default)(OwnerModel, _BaseModel);

  function OwnerModel(data) {
    (0, _classCallCheck3.default)(this, OwnerModel);
    return (0, _possibleConstructorReturn3.default)(this, (OwnerModel.__proto__ || (0, _getPrototypeOf2.default)(OwnerModel)).call(this, data, {
      firstName: null,
      lastName: null,
      tin: null,
      birthday: null,
      address: null,
      zipCode: null,
      city: null
    }));
  }

  return OwnerModel;
}(_model.BaseModel);

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TransferType = exports.TransferType = {
  ownAccount: 'ownAccount',
  gift: 'gift',
  inheritance: 'inheritance',
  other: 'other'
};

var TransferOptions = exports.TransferOptions = [{
  infoTextKey: 'app.transferState.type.ownAccount.info',
  label: 'app.transferState.type.ownAccount.label',
  value: TransferType.ownAccount
}, {
  infoTextKey: 'app.transferState.type.gift.info',
  label: 'app.transferState.type.gift.label',
  value: TransferType.gift
}, {
  infoTextKey: 'app.transferState.type.inheritance.info',
  label: 'app.transferState.type.inheritance.label',
  value: TransferType.inheritance
}, {
  infoTextKey: 'app.transferState.type.other.info',
  label: 'app.transferState.type.other.label',
  value: TransferType.other
}];

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchNotAllowedComponent = undefined;

var _switchNotAllowed = __webpack_require__(1768);

var _switchNotAllowed2 = __webpack_require__(1769);

var _switchNotAllowed3 = _interopRequireDefault(_switchNotAllowed2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var switchNotAllowedComponent = exports.switchNotAllowedComponent = {
  name: 'switchNotAllowedComponent',
  restrict: 'E',
  template: _switchNotAllowed3.default,
  controller: _switchNotAllowed.SwitchNotAllowedController,
  controllerAs: 'vm',
  bindings: {}
};

/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transferComponent = undefined;

var _transfer = __webpack_require__(1772);

var _transfer2 = __webpack_require__(1773);

var _transfer3 = _interopRequireDefault(_transfer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transferComponent = exports.transferComponent = {
  name: 'transferComponent',
  restrict: 'E',
  template: _transfer3.default,
  controller: _transfer.TransferController,
  controllerAs: 'vm',
  bindings: {}
};

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransferModel = undefined;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _model = __webpack_require__(71);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransferModel = exports.TransferModel = function (_BaseModel) {
  (0, _inherits3.default)(TransferModel, _BaseModel);

  function TransferModel(data) {
    (0, _classCallCheck3.default)(this, TransferModel);
    return (0, _possibleConstructorReturn3.default)(this, (TransferModel.__proto__ || (0, _getPrototypeOf2.default)(TransferModel)).call(this, data, {
      type: 'ownAccount',
      ownAccountInfo: false,
      giftInfo: false,
      inheritanceInfo: false,
      otherInfo: false
    }));
  }

  return TransferModel;
}(_model.BaseModel);

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(659);
module.exports = __webpack_require__(842);


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.app = undefined;

var _angular = __webpack_require__(65);

var _angular2 = _interopRequireDefault(_angular);

var _dependencies = __webpack_require__(844);

var _dependencies2 = _interopRequireDefault(_dependencies);

__webpack_require__(1553);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Create the main angular module called "app".
// It's empty now, but other parts of the app will register things on it.
// Since it is exported, other parts of the application (in other files) can then import it and register things.
var app = exports.app = _angular2.default.module('app', _dependencies2.default);

// Import vendor styles (try to use `ui-icon` instead)

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseModel = undefined;

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseModel = exports.BaseModel = function BaseModel(data) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _classCallCheck3.default)(this, BaseModel);

  var model = angular.extend({}, defaults, data);
  angular.extend(this, model);
};

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

__webpack_require__(1562);

__webpack_require__(1566);

var _config = __webpack_require__(1657);

__webpack_require__(1669);

__webpack_require__(1674);

__webpack_require__(1676);

__webpack_require__(1677);

__webpack_require__(1685);

__webpack_require__(1687);

__webpack_require__(1688);

__webpack_require__(1697);

__webpack_require__(1698);

__webpack_require__(1703);

__webpack_require__(1707);

__webpack_require__(1740);

__webpack_require__(1751);

__webpack_require__(1753);

__webpack_require__(1766);

__webpack_require__(1770);

var _loadCustoms = __webpack_require__(1774);

var _controller = __webpack_require__(1775);

// Ensure register the app wide cache at the very first
// since it's already used within the config phase.
_core.app.service('controllerService', _controller.ControllerService);

// Base Controller Service


// Import the components that make up the main subsections of the application
// Each submodule registers its own states/services/components
/**
 * This file is the main entry point for the entire app.
 *
 * If the application is being bundled, this is where the bundling process
 * starts.  If the application is being loaded by an es6 module loader, this
 * is the entry point.
 *
 * Point Webpack or SystemJS to this file.
 *
 * This module imports all the different parts of the application:
 * - 3rd party Libraries and app core module
 * - Services
 * - Components
 * - Submodules
 * - Top-level states
 * - UI-Router Transition Hooks
 */

/* globals ENV_CONFIG:false */

// Import the core app module


(0, _config.fetchConfig)().then(function (resp) {
  var config = resp.data;
  var theme = config.theme,
      tenant = config.tenant;


  (0, _loadCustoms.loadTheme)(theme, tenant, function () {
    angular.bootstrap(document, [_core.app.name]);
  });

  _core.app.config(["$qProvider", "$translatePartialLoaderProvider", function ($qProvider, $translatePartialLoaderProvider) {
    // Dont throw error when promise errors are not handled
    $qProvider.errorOnUnhandledRejections(false);

    (0, _loadCustoms.loadTranslations)(config, $translatePartialLoaderProvider);
  }]);

  _core.app.run(["$log", "configService", "envService", function ($log, configService, envService) {
    'ngInject';

    configService.storeConfig(config);
    $log.info('build ' + envService.build + ' on ' + envService.getStage() + ' stage');
  }]);
});

/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(845);

__webpack_require__(847);

__webpack_require__(848);

var _angularAria = __webpack_require__(851);

var _angularAria2 = _interopRequireDefault(_angularAria);

var _angularAnimate = __webpack_require__(853);

var _angularAnimate2 = _interopRequireDefault(_angularAnimate);

var _angularMessages = __webpack_require__(336);

var _angularMessages2 = _interopRequireDefault(_angularMessages);

var _angularSanitize = __webpack_require__(856);

var _angularSanitize2 = _interopRequireDefault(_angularSanitize);

var _angularStorage = __webpack_require__(858);

var _angularStorage2 = _interopRequireDefault(_angularStorage);

var _angularLoadingBar = __webpack_require__(860);

var _angularLoadingBar2 = _interopRequireDefault(_angularLoadingBar);

var _ngDeviceDetector = __webpack_require__(862);

var _ngDeviceDetector2 = _interopRequireDefault(_ngDeviceDetector);

var _ngShowdown = __webpack_require__(865);

var _ngShowdown2 = _interopRequireDefault(_ngShowdown);

var _angularUiRouter = __webpack_require__(867);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _uiSelect = __webpack_require__(900);

var _uiSelect2 = _interopRequireDefault(_uiSelect);

__webpack_require__(902);

var _buttons = __webpack_require__(903);

var _buttons2 = _interopRequireDefault(_buttons);

var _collapse = __webpack_require__(905);

var _collapse2 = _interopRequireDefault(_collapse);

var _dropdown = __webpack_require__(907);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _modal = __webpack_require__(914);

var _modal2 = _interopRequireDefault(_modal);

var _progressbar = __webpack_require__(920);

var _progressbar2 = _interopRequireDefault(_progressbar);

var _typeahead = __webpack_require__(925);

var _typeahead2 = _interopRequireDefault(_typeahead);

var _ng1BankSearch = __webpack_require__(934);

var _ng1BankSearch2 = _interopRequireDefault(_ng1BankSearch);

var _ng1Cache = __webpack_require__(1154);

var _ng1Cache2 = _interopRequireDefault(_ng1Cache);

var _ng1Config = __webpack_require__(1195);

var _ng1Config2 = _interopRequireDefault(_ng1Config);

var _ng1Environment = __webpack_require__(1242);

var _ng1Environment2 = _interopRequireDefault(_ng1Environment);

var _ng1FreshdeskFaqs = __webpack_require__(1300);

var _ng1FreshdeskFaqs2 = _interopRequireDefault(_ng1FreshdeskFaqs);

var _ng1Loading = __webpack_require__(1312);

var _ng1Loading2 = _interopRequireDefault(_ng1Loading);

var _ng1Locale = __webpack_require__(1315);

var _ng1Locale2 = _interopRequireDefault(_ng1Locale);

var _ng1PromiseDecorator = __webpack_require__(1319);

var _ng1PromiseDecorator2 = _interopRequireDefault(_ng1PromiseDecorator);

var _ng1Response = __webpack_require__(1368);

var _ng1Response2 = _interopRequireDefault(_ng1Response);

var _ng1SignaturePad = __webpack_require__(1371);

var _ng1SignaturePad2 = _interopRequireDefault(_ng1SignaturePad);

var _ng1Translation = __webpack_require__(1384);

var _ng1Translation2 = _interopRequireDefault(_ng1Translation);

var _ng1ErrorHandling = __webpack_require__(1404);

var _ng1ErrorHandling2 = _interopRequireDefault(_ng1ErrorHandling);

var _ng1FloatLabel = __webpack_require__(1412);

var _ng1FloatLabel2 = _interopRequireDefault(_ng1FloatLabel);

var _ng1FormButton = __webpack_require__(1415);

var _ng1FormButton2 = _interopRequireDefault(_ng1FormButton);

var _ng1FormControl = __webpack_require__(1427);

var _ng1FormControl2 = _interopRequireDefault(_ng1FormControl);

var _ng1FormValidation = __webpack_require__(1495);

var _ng1FormValidation2 = _interopRequireDefault(_ng1FormValidation);

var _ng1Icon = __webpack_require__(1506);

var _ng1Icon2 = _interopRequireDefault(_ng1Icon);

var _ng1InputLabel = __webpack_require__(1514);

var _ng1InputLabel2 = _interopRequireDefault(_ng1InputLabel);

var _ng1Modal = __webpack_require__(1518);

var _ng1Modal2 = _interopRequireDefault(_ng1Modal);

var _ng1Translate = __webpack_require__(1527);

var _ng1Translate2 = _interopRequireDefault(_ng1Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// fino shared modules


// UI Bootstrap components
// Vendor libs
// ------------------------------------

// Angular extensions
exports.default = ['angular.filter', 'hc.marked', _angularAria2.default, _angularAnimate2.default, _angularMessages2.default, _angularSanitize2.default, _angularStorage2.default, _angularLoadingBar2.default, _ngDeviceDetector2.default, _ngShowdown2.default.name, _uiSelect2.default, _angularUiRouter2.default, 'uiCropper', 'ngRaven', _buttons2.default, _collapse2.default, _dropdown2.default, _modal2.default, _progressbar2.default, _typeahead2.default, _ng1BankSearch2.default, _ng1Cache2.default, _ng1Config2.default, _ng1Environment2.default, _ng1PromiseDecorator2.default, _ng1Response2.default, _ng1Loading2.default, _ng1Locale2.default, _ng1Translation2.default, _ng1FreshdeskFaqs2.default, _ng1SignaturePad2.default, _ng1Translate2.default, _ng1FormButton2.default, _ng1FormControl2.default, _ng1FormValidation2.default, _ng1FloatLabel2.default, _ng1InputLabel2.default, _ng1ErrorHandling2.default, _ng1Modal2.default, _ng1Icon2.default];

// Angular UI modules

/***/ })

},[658]);


// WEBPACK FOOTER //
// app.bundle.js